[
  {
    "id": "842",
    "name": "Katie Ostrom MD, LLC",
    "address": {
      "id": "addr-842",
      "address1": "205 W. Fairview Ave",
      "city": "Homer",
      "state": "AK",
      "postalCode": "99603",
      "country": "US"
    },
    "headline": "Katie Ostrom MD, LLC",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(907) 235-0555",
    "bookingUrl": null,
    "location": {
      "latitude": 59.6494,
      "longitude": -151.5475
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 25,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 53.333333333333336
    },
    "medicaldirector": "Katie Ostrom, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "under35": 15
    },
    "newPatientSuccessRates": {
      "under35": 71.42857142857143
    },
    "newPatientSuccessRateDenominators": {
      "under35": 7
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "325",
    "name": "Alabama Fertility Specialists",
    "address": {
      "id": "addr-325",
      "address1": "3490 Independence Dr",
      "city": "Birmingham",
      "state": "AL",
      "postalCode": "35209",
      "country": "US"
    },
    "headline": "Alabama Fertility Specialists",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(205) 874-0000",
    "bookingUrl": null,
    "location": {
      "latitude": 33.4709,
      "longitude": -86.7828
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 301,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 52.6,
      "between35And37": 47.5,
      "between38And40": 38.2
    },
    "medicaldirector": "Janet M. Bouknight, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 57,
      "between35And37": 52.9,
      "between38And40": 28
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "frozenEmbryos": 37.5,
      "donatedEmbryos": 28
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "212",
    "name": "Center for Reproductive Medicine",
    "address": {
      "id": "addr-212",
      "address1": "3 Mobile Infirmary Cir, Suite 401",
      "city": "Mobile",
      "state": "AL",
      "postalCode": "36607",
      "country": "US"
    },
    "headline": "Center for Reproductive Medicine",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(251) 438-4200",
    "bookingUrl": null,
    "location": {
      "latitude": 30.6975,
      "longitude": -88.1029
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 218,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 45,
      "between35And37": 33.3,
      "between38And40": 35.3
    },
    "medicaldirector": "George T. Koulianos, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 50.9,
      "between35And37": 26.31578947368421,
      "between38And40": 29.2
    },
    "newPatientSuccessRateDenominators": {
      "between35And37": 19
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "830",
    "name": "Fertility Institute of North Alabama",
    "address": {
      "id": "addr-830",
      "address1": "808 Turner St S.W.",
      "city": "Huntsville",
      "state": "AL",
      "postalCode": "35801",
      "country": "US"
    },
    "headline": "Fertility Institute of North Alabama",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(256) 217-9613",
    "bookingUrl": null,
    "location": {
      "latitude": 34.7209,
      "longitude": -86.5846
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 98,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 41.5,
      "between35And37": 45.45454545454545,
      "between38And40": 60
    },
    "medicaldirector": "Brett Davenport, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between35And37": 11,
      "between38And40": 10
    },
    "newPatientSuccessRates": {
      "under35": 48.7
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 83.33333333333334,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 6
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "881",
    "name": "Innovative Fertility Specialists",
    "address": {
      "id": "addr-881",
      "address1": "One Inverness Center Pkwy, Suite 210",
      "city": "Birmingham",
      "state": "AL",
      "postalCode": "35242",
      "country": "US"
    },
    "headline": "Innovative Fertility Specialists",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(205) 509-0700",
    "bookingUrl": null,
    "location": {
      "latitude": 33.4236,
      "longitude": -86.7028
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 42,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 26.31578947368421
    },
    "medicaldirector": "Nicholas A. Cataldo, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "under35": 19
    },
    "newPatientSuccessRates": {
      "under35": 0,
      "between38And40": 0
    },
    "newPatientSuccessRateDenominators": {
      "under35": 5
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "151",
    "name": "University of Alabama at Birmingham, Reproductive Endocrinology and Infertility",
    "address": {
      "id": "addr-151",
      "address1": "Women and Infants Center-OB/GYN, 1700 6th Ave South, Suite 9103",
      "city": "Birmingham",
      "state": "AL",
      "postalCode": "35233",
      "country": "US"
    },
    "headline": "University of Alabama at Birmingham, Reproductive Endocrinology and Infertility",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(205) 934-1030",
    "bookingUrl": null,
    "location": {
      "latitude": 33.506,
      "longitude": -86.8047
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 86,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 60,
      "between35And37": 50
    },
    "medicaldirector": "Deidre D. Gunn, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between35And37": 14
    },
    "newPatientSuccessRates": {
      "under35": 46.9,
      "between35And37": 46.15384615384615,
      "between38And40": 0
    },
    "newPatientSuccessRateDenominators": {
      "between35And37": 13,
      "between38And40": 6
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "497",
    "name": "Arkansas Fertility Center",
    "address": {
      "id": "addr-497",
      "address1": "9101 Kanis Rd, Suite 300",
      "city": "Little Rock",
      "state": "AR",
      "postalCode": "72205",
      "country": "US"
    },
    "headline": "Arkansas Fertility Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(501) 534-3764",
    "bookingUrl": null,
    "location": {
      "latitude": 34.7407,
      "longitude": -92.3763
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 214,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 34.6,
      "between35And37": 28.6
    },
    "medicaldirector": "Dean M. Moutos, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 42.7,
      "between35And37": 38.1
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "32",
    "name": "ACFS Fertility, Arizona Associates for Reproductive Health",
    "address": {
      "id": "addr-32",
      "address1": "8426 E. Shea Blvd",
      "city": "Scottsdale",
      "state": "AZ",
      "postalCode": "85260",
      "country": "US"
    },
    "headline": "ACFS Fertility, Arizona Associates for Reproductive Health",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(480) 860-4792",
    "bookingUrl": null,
    "location": {
      "latitude": 33.6454,
      "longitude": -111.894
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 179,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 69.6,
      "between35And37": 51.7,
      "between38And40": 54.54545454545454
    },
    "medicaldirector": "Ketan S. Patel, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between38And40": 11
    },
    "newPatientSuccessRates": {
      "under35": 57.1,
      "between35And37": 32.3,
      "between38And40": 21.7
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 57.1
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "312",
    "name": "Advanced Fertility Care, PLLC",
    "address": {
      "id": "addr-312",
      "address1": "9819 N. 95th St, Suite 105",
      "city": "Scottsdale",
      "state": "AZ",
      "postalCode": "85258",
      "country": "US"
    },
    "headline": "Advanced Fertility Care, PLLC",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(480) 874-2229",
    "bookingUrl": null,
    "location": {
      "latitude": 33.5756,
      "longitude": -111.875
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 361,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 53.6,
      "between35And37": 53.2,
      "between38And40": 54.5
    },
    "medicaldirector": "Frederick W. Larsen, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 59.3,
      "between35And37": 39.4,
      "between38And40": 36.1
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 51.1,
      "donatedEmbryos": 70
    },
    "donorSuccessRateDenominators": {
      "donatedEmbryos": 10
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "160",
    "name": "Arizona Center for Reproductive Endocrinology and Infertility",
    "address": {
      "id": "addr-160",
      "address1": "5190 E. Farness Dr, Suite 114",
      "city": "Tucson",
      "state": "AZ",
      "postalCode": "85712",
      "country": "US"
    },
    "headline": "Arizona Center for Reproductive Endocrinology and Infertility",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(520) 326-0001",
    "bookingUrl": null,
    "location": {
      "latitude": 32.2475,
      "longitude": -110.883
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 163,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 27,
      "between35And37": 16.7,
      "between38And40": 17.6
    },
    "medicaldirector": "Timothy J. Gelety, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 40.9,
      "between38And40": 19
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 43.75,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 16
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "454",
    "name": "Arizona Reproductive Medicine Specialists, LLC",
    "address": {
      "id": "addr-454",
      "address1": "1701 E. Thomas Rd, Bldg 1, Suite 101",
      "city": "Phoenix",
      "state": "AZ",
      "postalCode": "85016",
      "country": "US"
    },
    "headline": "Arizona Reproductive Medicine Specialists, LLC",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(602) 343-2767",
    "bookingUrl": null,
    "location": {
      "latitude": 33.4799,
      "longitude": -112.045
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 144,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 62.5,
      "between35And37": 35.7,
      "between38And40": 60.9
    },
    "medicaldirector": "Drew V. Moffitt, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 66.7,
      "between35And37": 43.75,
      "between38And40": 45.5
    },
    "newPatientSuccessRateDenominators": {
      "between35And37": 16
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 38.6
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "712",
    "name": "Bloom Reproductive Institute",
    "address": {
      "id": "addr-712",
      "address1": "8415 N. Pima Rd, Suite 290",
      "city": "Scottsdale",
      "state": "AZ",
      "postalCode": "85258",
      "country": "US"
    },
    "headline": "Bloom Reproductive Institute",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(480) 434-6565",
    "bookingUrl": null,
    "location": {
      "latitude": 33.5573,
      "longitude": -111.891
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 336,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 53.3,
      "between35And37": 41.5,
      "between38And40": 42.2
    },
    "medicaldirector": "Millie A. Behera, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 50,
      "between35And37": 39.4,
      "between38And40": 16.2
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 47.4
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "246",
    "name": "Fertility Treatment Center, PC",
    "address": {
      "id": "addr-246",
      "address1": "2155 E. Conference Dr, Suite 115",
      "city": "Tempe",
      "state": "AZ",
      "postalCode": "85284",
      "country": "US"
    },
    "headline": "Fertility Treatment Center, PC",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(480) 831-2445",
    "bookingUrl": null,
    "location": {
      "latitude": 33.3424,
      "longitude": -111.895
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 290,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 51.6,
      "between35And37": 51.5,
      "between38And40": 20.5
    },
    "medicaldirector": "H. Randall Craig, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 52.2,
      "between35And37": 42.3
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 36,
      "donatedEmbryos": 52.63157894736842
    },
    "donorSuccessRateDenominators": {
      "donatedEmbryos": 19
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "384",
    "name": "IVF Phoenix",
    "address": {
      "id": "addr-384",
      "address1": "9817 N. 95th St, Bldg I, Suite 107",
      "city": "Scottsdale",
      "state": "AZ",
      "postalCode": "85258",
      "country": "US"
    },
    "headline": "IVF Phoenix",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(602) 765-2229",
    "bookingUrl": null,
    "location": {
      "latitude": 33.5756,
      "longitude": -111.876
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 110,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 45.2
    },
    "medicaldirector": "John L. Couvaras, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 29.3
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "629",
    "name": "New Direction Fertility Centers",
    "address": {
      "id": "addr-629",
      "address1": "1760 E. Pecos Rd, Suite 532",
      "city": "Gilbert",
      "state": "AZ",
      "postalCode": "85295",
      "country": "US"
    },
    "headline": "New Direction Fertility Centers",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(480) 351-8222",
    "bookingUrl": null,
    "location": {
      "latitude": 33.2964,
      "longitude": -111.752
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 709,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 58.4,
      "between35And37": 58.3,
      "between38And40": 53.2
    },
    "medicaldirector": "Mark Amols, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 64.1,
      "between35And37": 44.4,
      "between38And40": 30.6
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 30.4
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "378",
    "name": "Reproductive Health Center",
    "address": {
      "id": "addr-378",
      "address1": "4518 E. Camp Lowell Dr",
      "city": "Tucson",
      "state": "AZ",
      "postalCode": "85712",
      "country": "US"
    },
    "headline": "Reproductive Health Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(520) 733-0083",
    "bookingUrl": null,
    "location": {
      "latitude": 32.2646,
      "longitude": -110.896
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 199,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 36.7,
      "between35And37": 34.3,
      "between38And40": 30.8
    },
    "medicaldirector": "Scot M. Hutchison, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 48.1,
      "between35And37": 31.8,
      "between38And40": 14.3
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 23.8
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "120",
    "name": "Southwest Fertility Center",
    "address": {
      "id": "addr-120",
      "address1": "3125 N. 32nd St, Suite 200",
      "city": "Phoenix",
      "state": "AZ",
      "postalCode": "85018",
      "country": "US"
    },
    "headline": "Southwest Fertility Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(602) 956-7481",
    "bookingUrl": null,
    "location": {
      "latitude": 33.4852,
      "longitude": -112.013
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 173,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 41.4,
      "between35And37": 33.3,
      "between38And40": 30.3
    },
    "medicaldirector": "Sujatha Gunnala, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 52.2,
      "between35And37": 34.8,
      "between38And40": 14.3
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "frozenEmbryos": 30
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "481",
    "name": "Advanced Fertility Associates Medical Group, Inc.",
    "address": {
      "id": "addr-481",
      "address1": "4690 Hoen Ave",
      "city": "Santa Rosa",
      "state": "CA",
      "postalCode": "95405",
      "country": "US"
    },
    "headline": "Advanced Fertility Associates Medical Group, Inc.",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(707) 575-5831",
    "bookingUrl": null,
    "location": {
      "latitude": 38.442,
      "longitude": -122.7
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 79,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 72,
      "between35And37": 63.1578947368421
    },
    "medicaldirector": "Jennifer V. Ratcliffe, MD, PHD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between35And37": 19
    },
    "newPatientSuccessRates": {
      "under35": 73.68421052631578,
      "between35And37": 46.666666666666664,
      "between38And40": 0
    },
    "newPatientSuccessRateDenominators": {
      "under35": 19,
      "between35And37": 15,
      "between38And40": 12
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 62.5,
      "freshEmbryosFrozenEggs": 0,
      "donatedEmbryos": 45.45454545454545
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFreshEggs": 8,
      "donatedEmbryos": 11
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "301",
    "name": "Alex Steinleitner, MD, Inc.",
    "address": {
      "id": "addr-301",
      "address1": "127 Casa St",
      "city": "San Luis Obispo",
      "state": "CA",
      "postalCode": "93405",
      "country": "US"
    },
    "headline": "Alex Steinleitner, MD, Inc.",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(805) 543-2228",
    "bookingUrl": null,
    "location": {
      "latitude": 35.2919,
      "longitude": -120.665
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 174,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 55.2,
      "between35And37": 35.9,
      "between38And40": 36.84210526315789
    },
    "medicaldirector": "Alex J. Steinleitner, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between38And40": 19
    },
    "newPatientSuccessRates": {
      "under35": 45.8,
      "between35And37": 32
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {},
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "839",
    "name": "American Fertility Medical Center Corporation",
    "address": {
      "id": "addr-839",
      "address1": "1370 Valley Vista Dr, Suite 135",
      "city": "Diamond Bar",
      "state": "CA",
      "postalCode": "91765",
      "country": "US"
    },
    "headline": "American Fertility Medical Center Corporation",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(909) 777-8888",
    "bookingUrl": null,
    "location": {
      "latitude": 34.0286,
      "longitude": -117.81
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 34,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 62.5,
      "between35And37": 62.5
    },
    "medicaldirector": "Thomas Lee, MD",
    "clinicStatus": "Reorganized",
    "successRateDenominators": {
      "under35": 8,
      "between35And37": 8
    },
    "newPatientSuccessRates": {
      "under35": 50
    },
    "newPatientSuccessRateDenominators": {
      "under35": 10
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 60
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 10
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "138",
    "name": "American Reproductive Centers",
    "address": {
      "id": "addr-138",
      "address1": "1199 N. Indian Canyon Dr",
      "city": "Palm Springs",
      "state": "CA",
      "postalCode": "92262",
      "country": "US"
    },
    "headline": "American Reproductive Centers",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(760) 346-4334",
    "bookingUrl": null,
    "location": {
      "latitude": 33.8392,
      "longitude": -116.546
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 94,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 36.4,
      "between35And37": 33.33333333333333,
      "between38And40": 33.33333333333333
    },
    "medicaldirector": "Maher A. Abdallah, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between35And37": 15,
      "between38And40": 18
    },
    "newPatientSuccessRates": {
      "under35": 0
    },
    "newPatientSuccessRateDenominators": {
      "under35": 6
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "921",
    "name": "Banafsheh Kashani, MD, Inc.",
    "address": {
      "id": "addr-921",
      "address1": "23141 Moulton Pkwy, Suite 205",
      "city": "Laguna Hills",
      "state": "CA",
      "postalCode": "92653",
      "country": "US"
    },
    "headline": "Banafsheh Kashani, MD, Inc.",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(949) 516-0150",
    "bookingUrl": null,
    "location": {
      "latitude": 33.6263,
      "longitude": -117.7319
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 45,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 50,
      "between35And37": 60,
      "between38And40": 55.55555555555556
    },
    "medicaldirector": "Banafsheh Kashani, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "under35": 14,
      "between35And37": 10,
      "between38And40": 9
    },
    "newPatientSuccessRates": {
      "under35": 38.46153846153847,
      "between35And37": 75
    },
    "newPatientSuccessRateDenominators": {
      "under35": 13,
      "between35And37": 8
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "423",
    "name": "Bay IVF Center",
    "address": {
      "id": "addr-423",
      "address1": "1681 El Camino Real",
      "city": "Palo Alto",
      "state": "CA",
      "postalCode": "94306",
      "country": "US"
    },
    "headline": "Bay IVF Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(650) 322-0500",
    "bookingUrl": null,
    "location": {
      "latitude": 37.4307,
      "longitude": -122.152
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 101,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 30.8,
      "between35And37": 31.8,
      "between38And40": 23.3
    },
    "medicaldirector": "Francis Polansky, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 42.10526315789473
    },
    "newPatientSuccessRateDenominators": {
      "under35": 19
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "902",
    "name": "Beverly Hills Fertility",
    "address": {
      "id": "addr-902",
      "address1": "10390 Santa Monica Blvd, Suite 340",
      "city": "Los Angeles",
      "state": "CA",
      "postalCode": "90025",
      "country": "US"
    },
    "headline": "Beverly Hills Fertility",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(310) 855-3688",
    "bookingUrl": null,
    "location": {
      "latitude": 34.0624,
      "longitude": -118.4147
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 5,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 0,
      "between35And37": 0,
      "between38And40": 0
    },
    "medicaldirector": "Ellen Goldstein, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 0,
      "between35And37": 0,
      "between38And40": 0
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "426",
    "name": "California Center for Reproductive Health, Reproductive Fertility Center",
    "address": {
      "id": "addr-426",
      "address1": "9201 W. Sunset Blvd, Suite 500",
      "city": "West Hollywood",
      "state": "CA",
      "postalCode": "90069",
      "country": "US"
    },
    "headline": "California Center for Reproductive Health, Reproductive Fertility Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(818) 907-1571",
    "bookingUrl": null,
    "location": {
      "latitude": 34.091,
      "longitude": -118.393
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 643,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 56.3,
      "between35And37": 46,
      "between38And40": 42
    },
    "medicaldirector": "Peyman Saadat, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 41.5,
      "between35And37": 23.7,
      "between38And40": 19.8
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 57.1
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "135",
    "name": "California Center for Reproductive Medicine",
    "address": {
      "id": "addr-135",
      "address1": "477 N. El Camino Real, Suite C310",
      "city": "Encinitas",
      "state": "CA",
      "postalCode": "92024",
      "country": "US"
    },
    "headline": "California Center for Reproductive Medicine",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(760) 274-2000",
    "bookingUrl": null,
    "location": {
      "latitude": 33.0571,
      "longitude": -117.261
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 44,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 71.42857142857143
    },
    "medicaldirector": "Lori L. Arnold, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "under35": 7
    },
    "newPatientSuccessRates": {
      "under35": 62.5,
      "between35And37": 0
    },
    "newPatientSuccessRateDenominators": {
      "under35": 8,
      "between35And37": 6
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 68,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "889",
    "name": "California Dream Fertility Center",
    "address": {
      "id": "addr-889",
      "address1": "113 Waterworks Way, Suite 110",
      "city": "Irvine",
      "state": "CA",
      "postalCode": "92618",
      "country": "US"
    },
    "headline": "California Dream Fertility Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(949) 336-4956",
    "bookingUrl": null,
    "location": {
      "latitude": 33.6655,
      "longitude": -117.7633
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 7,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 0,
      "between38And40": 0
    },
    "medicaldirector": "Fangyin Meng, MD, PHD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {},
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "220",
    "name": "California Fertility Partners",
    "address": {
      "id": "addr-220",
      "address1": "11818 Wilshire Blvd, Suite 300",
      "city": "Los Angeles",
      "state": "CA",
      "postalCode": "90025",
      "country": "US"
    },
    "headline": "California Fertility Partners",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(310) 828-4008",
    "bookingUrl": null,
    "location": {
      "latitude": 34.0473,
      "longitude": -118.463
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 563,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 65.8,
      "between35And37": 68.2,
      "between38And40": 47.3
    },
    "medicaldirector": "Richard P. Marrs, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 41.4,
      "between35And37": 32.2,
      "between38And40": 18.8
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 63
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "40",
    "name": "California IVF Fertility Center",
    "address": {
      "id": "addr-40",
      "address1": "2590 Venture Oaks Way, Suite 103",
      "city": "Sacramento",
      "state": "CA",
      "postalCode": "95833",
      "country": "US"
    },
    "headline": "California IVF Fertility Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(916) 979-5599",
    "bookingUrl": null,
    "location": {
      "latitude": 38.6123,
      "longitude": -121.516
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 318,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 52.7,
      "between35And37": 38.2,
      "between38And40": 53.3
    },
    "medicaldirector": "Ernest J. Zeringue, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 47.7,
      "between35And37": 10.9,
      "between38And40": 34.1
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 47.6,
      "donatedEmbryos": 47.1
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "244",
    "name": "CARE Fertility",
    "address": {
      "id": "addr-244",
      "address1": "1500 E. Chevy Chase Dr, Suite 450",
      "city": "Glendale",
      "state": "CA",
      "postalCode": "91206",
      "country": "US"
    },
    "headline": "CARE Fertility",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(818) 230-7778",
    "bookingUrl": null,
    "location": {
      "latitude": 34.1517,
      "longitude": -118.232
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 236,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 39,
      "between35And37": 41.7,
      "between38And40": 35.9
    },
    "medicaldirector": "Rodolfo Quintero, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 38,
      "between35And37": 36.8,
      "between38And40": 30.6
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "280",
    "name": "CARE for the Bay Area",
    "address": {
      "id": "addr-280",
      "address1": "555 Knowles Dr, Suite 212",
      "city": "Los Gatos",
      "state": "CA",
      "postalCode": "95032",
      "country": "US"
    },
    "headline": "CARE for the Bay Area",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(408) 628-0783",
    "bookingUrl": null,
    "location": {
      "latitude": 37.262,
      "longitude": -121.966
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 167,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 68.42105263157895,
      "between35And37": 55.6,
      "between38And40": 75
    },
    "medicaldirector": "Karen J. Purcell, MD, PHD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "under35": 19,
      "between38And40": 8
    },
    "newPatientSuccessRates": {
      "under35": 30,
      "between35And37": 25,
      "between38And40": 0
    },
    "newPatientSuccessRateDenominators": {
      "between38And40": 12
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "804",
    "name": "CCRM San Francisco, Bay Area Center for Reproductive Medicine, LLC (BACRM)",
    "address": {
      "id": "addr-804",
      "address1": "1060 Marsh Rd, 1st Floor",
      "city": "Menlo Park",
      "state": "CA",
      "postalCode": "94025",
      "country": "US"
    },
    "headline": "CCRM San Francisco, Bay Area Center for Reproductive Medicine, LLC (BACRM)",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(650) 646-7500",
    "bookingUrl": null,
    "location": {
      "latitude": 37.4809,
      "longitude": -122.183
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 463,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 62.5,
      "between35And37": 65.6,
      "between38And40": 83
    },
    "medicaldirector": "Salli Tazuke, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 48.3,
      "between35And37": 36.5,
      "between38And40": 33.3
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 64.3,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "316",
    "name": "Cedars Sinai Medical Center, Center for Fertility and Reproductive Medicine",
    "address": {
      "id": "addr-316",
      "address1": "444 S. San Vicente Blvd, Suite 1002",
      "city": "Los Angeles",
      "state": "CA",
      "postalCode": "90048",
      "country": "US"
    },
    "headline": "Cedars Sinai Medical Center, Center for Fertility and Reproductive Medicine",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(310) 423-9964",
    "bookingUrl": null,
    "location": {
      "latitude": 34.0701,
      "longitude": -118.375
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 101,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 61.53846153846154,
      "between35And37": 46.666666666666664,
      "between38And40": 38.46153846153847
    },
    "medicaldirector": "Margareta D. Pisarska, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "under35": 13,
      "between35And37": 15,
      "between38And40": 13
    },
    "newPatientSuccessRates": {
      "under35": 46.15384615384615
    },
    "newPatientSuccessRateDenominators": {
      "under35": 13
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "482",
    "name": "Center for Reproductive Health & Gynecology, (CRH&G)",
    "address": {
      "id": "addr-482",
      "address1": "351 S. Beverly Dr, Suite 230",
      "city": "Beverly Hills",
      "state": "CA",
      "postalCode": "90212",
      "country": "US"
    },
    "headline": "Center for Reproductive Health & Gynecology, (CRH&G)",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(310) 360-7584",
    "bookingUrl": null,
    "location": {
      "latitude": 34.0673,
      "longitude": -118.377
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 69,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "between35And37": 72.72727272727273,
      "between38And40": 60
    },
    "medicaldirector": "Sam Najmabadi, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between35And37": 11,
      "between38And40": 10
    },
    "newPatientSuccessRates": {
      "between38And40": 42.857142857142854
    },
    "newPatientSuccessRateDenominators": {
      "between38And40": 14
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 61.53846153846154
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 13
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "178",
    "name": "Central California IVF Program, Women's Specialty and Fertility Center",
    "address": {
      "id": "addr-178",
      "address1": "729 N. Medical Center Dr West, Suite 205",
      "city": "Clovis",
      "state": "CA",
      "postalCode": "93611",
      "country": "US"
    },
    "headline": "Central California IVF Program, Women's Specialty and Fertility Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(559) 299-7700",
    "bookingUrl": null,
    "location": {
      "latitude": 36.8418,
      "longitude": -119.661
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 223,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 52.6,
      "between35And37": 29.2,
      "between38And40": 20.9
    },
    "medicaldirector": "Carlos Sueldo, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 50.7,
      "between35And37": 27,
      "between38And40": 17.4
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 50
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 14
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "388",
    "name": "Coastal Fertility Medical Center, Inc.",
    "address": {
      "id": "addr-388",
      "address1": "15500 Sand Canyon Ave, Suite 100",
      "city": "Irvine",
      "state": "CA",
      "postalCode": "92618",
      "country": "US"
    },
    "headline": "Coastal Fertility Medical Center, Inc.",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(949) 726-0600",
    "bookingUrl": null,
    "location": {
      "latitude": 33.6684,
      "longitude": -117.766
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 147,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 39.1,
      "between35And37": 27.3,
      "between38And40": 31.8
    },
    "medicaldirector": "Minh Ho, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 30,
      "between35And37": 20.8,
      "between38And40": 27.77777777777778
    },
    "newPatientSuccessRateDenominators": {
      "between38And40": 18
    },
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 20
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "901",
    "name": "Envita Fertility Center",
    "address": {
      "id": "addr-901",
      "address1": "23521 Paseo De Valencia, Suite 100",
      "city": "Laguna Hills",
      "state": "CA",
      "postalCode": "92653",
      "country": "US"
    },
    "headline": "Envita Fertility Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(949) 666-2229",
    "bookingUrl": null,
    "location": {
      "latitude": 33.6131,
      "longitude": -117.7138
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 0,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 0,
      "between35And37": 0,
      "between38And40": 0
    },
    "medicaldirector": "William A. Freije, MD, PHD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 0,
      "between35And37": 0,
      "between38And40": 0
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "270",
    "name": "Fertility and Surgical Associates of California",
    "address": {
      "id": "addr-270",
      "address1": "325 Rolling Oaks Dr, Suite 110",
      "city": "Thousand Oaks",
      "state": "CA",
      "postalCode": "91361",
      "country": "US"
    },
    "headline": "Fertility and Surgical Associates of California",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(805) 778-1122",
    "bookingUrl": null,
    "location": {
      "latitude": 34.1748,
      "longitude": -118.872
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 617,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 52.5,
      "between35And37": 54,
      "between38And40": 56.8
    },
    "medicaldirector": "Gary Hubert, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 57.9,
      "between35And37": 46.1,
      "between38And40": 23.3
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 45,
      "donatedEmbryos": 50
    },
    "donorSuccessRateDenominators": {
      "donatedEmbryos": 10
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "148",
    "name": "Fertility Care of Orange County",
    "address": {
      "id": "addr-148",
      "address1": "203 N. Brea Blvd, Suite 100",
      "city": "Brea",
      "state": "CA",
      "postalCode": "92821",
      "country": "US"
    },
    "headline": "Fertility Care of Orange County",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(714) 256-0777",
    "bookingUrl": null,
    "location": {
      "latitude": 33.9219,
      "longitude": -117.898
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 145,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 53.8,
      "between35And37": 44,
      "between38And40": 36.84210526315789
    },
    "medicaldirector": "Changnin T. Lee, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between38And40": 19
    },
    "newPatientSuccessRates": {
      "under35": 70.4,
      "between35And37": 30.4
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 61.53846153846154,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 13
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "211",
    "name": "Fertility Center of Southern California",
    "address": {
      "id": "addr-211",
      "address1": "4980 Barranca Pkwy, Suite 200",
      "city": "Irvine",
      "state": "CA",
      "postalCode": "92604",
      "country": "US"
    },
    "headline": "Fertility Center of Southern California",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(949) 955-0072",
    "bookingUrl": null,
    "location": {
      "latitude": 33.6757,
      "longitude": -117.794
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 128,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 52.94117647058824,
      "between35And37": 47.6,
      "between38And40": 52.94117647058824
    },
    "medicaldirector": "Ilene E. Hatch, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "under35": 17,
      "between38And40": 17
    },
    "newPatientSuccessRates": {
      "under35": 46.666666666666664,
      "between35And37": 41.17647058823529
    },
    "newPatientSuccessRateDenominators": {
      "under35": 15,
      "between35And37": 17
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 95.7,
      "donatedEmbryos": 77.77777777777779
    },
    "donorSuccessRateDenominators": {
      "donatedEmbryos": 9
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "271",
    "name": "Fertility Centers of Orange County",
    "address": {
      "id": "addr-271",
      "address1": "17875 Von Karman Ave, Suite 480",
      "city": "Irvine",
      "state": "CA",
      "postalCode": "92614",
      "country": "US"
    },
    "headline": "Fertility Centers of Orange County",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(949) 387-3888",
    "bookingUrl": null,
    "location": {
      "latitude": 40.7637,
      "longitude": -73.9735
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 364,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 53.8,
      "between35And37": 51.5,
      "between38And40": 61.1
    },
    "medicaldirector": "Wayne Lin, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 54.2,
      "between35And37": 45.2,
      "between38And40": 27.2
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 75,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 12
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "13",
    "name": "Fertility Specialists Medical Group",
    "address": {
      "id": "addr-13",
      "address1": "8010 Frost St, Suite P",
      "city": "San Diego",
      "state": "CA",
      "postalCode": "92123",
      "country": "US"
    },
    "headline": "Fertility Specialists Medical Group",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(858) 505-5500",
    "bookingUrl": null,
    "location": {
      "latitude": 32.8015,
      "longitude": -117.152
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 174,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 45.5,
      "between35And37": 31.7,
      "between38And40": 29.411764705882355
    },
    "medicaldirector": "Wendy B. Shelly, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between38And40": 17
    },
    "newPatientSuccessRates": {
      "under35": 37.5,
      "between35And37": 28.6,
      "between38And40": 12
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 52.4
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "832",
    "name": "Gen 5 Fertility Center",
    "address": {
      "id": "addr-832",
      "address1": "3420 Carmel Mountain Rd, Suite 200",
      "city": "San Diego",
      "state": "CA",
      "postalCode": "92121",
      "country": "US"
    },
    "headline": "Gen 5 Fertility Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(858) 267-4365",
    "bookingUrl": null,
    "location": {
      "latitude": 32.9195,
      "longitude": -117.238
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 310,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {},
    "medicaldirector": "Samuel H. Wood, MD, PHD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 8.7,
      "between35And37": 4.5
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 61.5,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "616",
    "name": "Hanabusa IVF",
    "address": {
      "id": "addr-616",
      "address1": "4910 Directors Pl, Suite 150",
      "city": "San Diego",
      "state": "CA",
      "postalCode": "92121",
      "country": "US"
    },
    "headline": "Hanabusa IVF",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(858) 480-5400",
    "bookingUrl": null,
    "location": {
      "latitude": 32.8946,
      "longitude": -117.212
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 49,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 0,
      "between35And37": 0,
      "between38And40": 0
    },
    "medicaldirector": "Lyndon Chang, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 0,
      "between35And37": 0,
      "between38And40": 0
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 42.9,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "847",
    "name": "Harvest Fertility",
    "address": {
      "id": "addr-847",
      "address1": "125 W. Huntington Dr, Bldg B, 3rd Floor",
      "city": "Arcadia",
      "state": "CA",
      "postalCode": "91007",
      "country": "US"
    },
    "headline": "Harvest Fertility",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(626) 538-4838",
    "bookingUrl": null,
    "location": {
      "latitude": 34.139,
      "longitude": -118.0385
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 0,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 0,
      "between35And37": 0,
      "between38And40": 0
    },
    "medicaldirector": "Kathleen Kornafel, MD, PHD",
    "clinicStatus": "Reorganized",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 0,
      "between35And37": 0,
      "between38And40": 0
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "477",
    "name": "HRC Fertility-Pasadena",
    "address": {
      "id": "addr-477",
      "address1": "55 S. Lake Ave, 9th Floor",
      "city": "Pasadena",
      "state": "CA",
      "postalCode": "91101",
      "country": "US"
    },
    "headline": "HRC Fertility-Pasadena",
    "images": [],
    "tags": [],
    "services": [
      "Acupuncture",
      "Concierge service",
      "Patient portal",
      "Support resources",
      "Outside monitoring"
    ],
    "languages": ["en", "es", "zh", "ru"],
    "clinicType": "Network & group",
    "conditions": [
      "PCOS",
      "Endometriosis",
      "Male factor",
      "Ovulatory dysfunction",
      "Unexplained infertility",
      "Oncofertility"
    ],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Embryo Freezing",
      "PGT",
      "Sperm Freezing",
      "Donor programs",
      "Surrogacy",
      "Fertility preservation"
    ],
    "website": "https://www.havingbabies.com/locations/pasadena/",
    "email": "publicrelations@havingbabies.com",
    "phone": "(626) 440-9161",
    "bookingUrl": "https://www.havingbabies.com/appointments/",
    "location": {
      "latitude": 34.1449,
      "longitude": -118.133
    },
    "insurances": [],
    "insuranceAccepted": true,
    "insuranceName": null,
    "financiers": [
      "Payment plans",
      "Loans",
      "Package pricing",
      "CapexMD",
      "Future Family",
      "PatientFi"
    ],
    "consultationTypes": ["In person", "Telehealth"],
    "patientGroups": ["LGBTQIA+", "Single Parents", "Same sex couples"],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 2279,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": "Southern California's pioneering fertility network since 1988, part of Jinxin Fertility Group, offering comprehensive IVF, third-party reproduction, and oncofertility services.",
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 52.1,
      "between35And37": 52,
      "between38And40": 51.2
    },
    "medicaldirector": "John G. Wilcox, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 42.3,
      "between35And37": 34.3,
      "between38And40": 23
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "frozenEmbryos": 47.3,
      "donatedEmbryos": 52.7
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "942",
    "name": "Incinta Fertility Center",
    "address": {
      "id": "addr-942",
      "address1": "21545 Hawthorne Blvd",
      "city": "Torrance",
      "state": "CA",
      "postalCode": "90503",
      "country": "US"
    },
    "headline": "Incinta Fertility Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(424) 212-4087",
    "bookingUrl": null,
    "location": {
      "latitude": 33.8284,
      "longitude": -118.3489
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 26,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 0,
      "between35And37": 0,
      "between38And40": 0
    },
    "medicaldirector": "James Lin, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 0,
      "between35And37": 0,
      "between38And40": 0
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 42.3,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "512",
    "name": "Innovative Fertility Center",
    "address": {
      "id": "addr-512",
      "address1": "3500 N. Sepulveda Blvd",
      "city": "Manhattan Beach",
      "state": "CA",
      "postalCode": "90266",
      "country": "US"
    },
    "headline": "Innovative Fertility Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(310) 648-2229",
    "bookingUrl": null,
    "location": {
      "latitude": 33.9001,
      "longitude": -118.396
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 114,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 58.333333333333336,
      "between35And37": 41.66666666666667
    },
    "medicaldirector": "Joshua J. Berger, MD, PHD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "under35": 12,
      "between35And37": 12
    },
    "newPatientSuccessRates": {
      "under35": 0
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "869",
    "name": "Kaiser Permanente Center for Reproductive Health",
    "address": {
      "id": "addr-869",
      "address1": "1700 California St, Suite 400",
      "city": "San Francisco",
      "state": "CA",
      "postalCode": "94109",
      "country": "US"
    },
    "headline": "Kaiser Permanente Center for Reproductive Health",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(628) 242-7300",
    "bookingUrl": null,
    "location": {
      "latitude": 37.7905,
      "longitude": -122.4231
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 172,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 44.4,
      "between35And37": 64.5,
      "between38And40": 62.5
    },
    "medicaldirector": "Irene Moy, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 37.1,
      "between35And37": 41.5,
      "between38And40": 24.3
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "467",
    "name": "Kaiser Permanente Center for Reproductive Health-Fremont",
    "address": {
      "id": "addr-467",
      "address1": "39141 Civic Center Dr, Suite 350",
      "city": "Fremont",
      "state": "CA",
      "postalCode": "94538",
      "country": "US"
    },
    "headline": "Kaiser Permanente Center for Reproductive Health-Fremont",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(510) 248-6900",
    "bookingUrl": null,
    "location": {
      "latitude": 37.554,
      "longitude": -121.977
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 719,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 50.5,
      "between35And37": 54.3,
      "between38And40": 41.7
    },
    "medicaldirector": "Lisa Farah-Eways, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 51.9,
      "between35And37": 39.4,
      "between38And40": 22.8
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 41.7,
      "frozenEmbryos": 51.5,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "515",
    "name": "Kaiser Permanente Center for Reproductive Health-Sacramento",
    "address": {
      "id": "addr-515",
      "address1": "1650 Response Rd, Suite 1A",
      "city": "Sacramento",
      "state": "CA",
      "postalCode": "95815",
      "country": "US"
    },
    "headline": "Kaiser Permanente Center for Reproductive Health-Sacramento",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(916) 614-5083",
    "bookingUrl": null,
    "location": {
      "latitude": 38.5964,
      "longitude": -121.43
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 286,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 47.8,
      "between35And37": 48.1,
      "between38And40": 55
    },
    "medicaldirector": "Lisa Farah-Eways, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 49.4,
      "between35And37": 31,
      "between38And40": 31.3
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 50,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "870",
    "name": "Kindbody Silicon Valley",
    "address": {
      "id": "addr-870",
      "address1": "4756 El Camino Real",
      "city": "Los Altos",
      "state": "CA",
      "postalCode": "94022",
      "country": "US"
    },
    "headline": "Kindbody Silicon Valley",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(650) 445-4724",
    "bookingUrl": null,
    "location": {
      "latitude": 37.3997,
      "longitude": -122.1113
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 16,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "between38And40": 0
    },
    "medicaldirector": "Lynn M. Westphal, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {},
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "834",
    "name": "Kindbody-Los Angeles",
    "address": {
      "id": "addr-834",
      "address1": "1260 15th St, Suite 1402",
      "city": "Santa Monica",
      "state": "CA",
      "postalCode": "90404",
      "country": "US"
    },
    "headline": "Kindbody-Los Angeles",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(855) 563-2639",
    "bookingUrl": null,
    "location": {
      "latitude": 34.0263,
      "longitude": -118.487
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 145,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 46.3,
      "between35And37": 45.7,
      "between38And40": 52.63157894736842
    },
    "medicaldirector": "Meredith Brower, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between38And40": 19
    },
    "newPatientSuccessRates": {
      "under35": 48.3,
      "between35And37": 25.9
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 85.71428571428571,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 7
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "829",
    "name": "Kindbody-San Francisco",
    "address": {
      "id": "addr-829",
      "address1": "88 Sutter St",
      "city": "San Francisco",
      "state": "CA",
      "postalCode": "94104",
      "country": "US"
    },
    "headline": "Kindbody-San Francisco",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(628) 777-7064",
    "bookingUrl": null,
    "location": {
      "latitude": 37.7902,
      "longitude": -122.402
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 98,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 56.5,
      "between35And37": 68.75,
      "between38And40": 53.333333333333336
    },
    "medicaldirector": "Geraldine Ekpo, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between35And37": 16,
      "between38And40": 15
    },
    "newPatientSuccessRates": {
      "under35": 50,
      "between35And37": 22.7,
      "between38And40": 50
    },
    "newPatientSuccessRateDenominators": {
      "between38And40": 12
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "615",
    "name": "LA IVF Clinic",
    "address": {
      "id": "addr-615",
      "address1": "2080 Century Park East, Suite 400",
      "city": "Los Angeles",
      "state": "CA",
      "postalCode": "90067",
      "country": "US"
    },
    "headline": "LA IVF Clinic",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(310) 286-2800",
    "bookingUrl": null,
    "location": {
      "latitude": 34.0601,
      "longitude": -118.4119
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 6,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 0,
      "between35And37": 0,
      "between38And40": 0
    },
    "medicaldirector": "Aykut Bayrak, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 0,
      "between35And37": 0,
      "between38And40": 0
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "874",
    "name": "LA/OC Fertility, Inc.",
    "address": {
      "id": "addr-874",
      "address1": "510 N. Prospect Ave, Suite 205",
      "city": "Redondo Beach",
      "state": "CA",
      "postalCode": "90277",
      "country": "US"
    },
    "headline": "LA/OC Fertility, Inc.",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(714) 988-4272",
    "bookingUrl": null,
    "location": {
      "latitude": 33.8525,
      "longitude": -118.3789
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 1021,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 48.8,
      "between35And37": 45.2,
      "between38And40": 47.9
    },
    "medicaldirector": "Gayane Ambartsumyan, MD, PHD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 27.1,
      "between35And37": 15.8,
      "between38And40": 10.7
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "923",
    "name": "Labryo Fertility Center",
    "address": {
      "id": "addr-923",
      "address1": "2001 Westcliff Dr, Suite 300",
      "city": "Newport Beach",
      "state": "CA",
      "postalCode": "92660",
      "country": "US"
    },
    "headline": "Labryo Fertility Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(949) 891-1531",
    "bookingUrl": null,
    "location": {
      "latitude": 33.6274,
      "longitude": -117.9039
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 9,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 0,
      "between35And37": 0,
      "between38And40": 0
    },
    "medicaldirector": "Benito Villanueva, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 0,
      "between35And37": 0,
      "between38And40": 0
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "200",
    "name": "Lane Fertility Institute",
    "address": {
      "id": "addr-200",
      "address1": "101 Rowland Way, Suite 305",
      "city": "Novato",
      "state": "CA",
      "postalCode": "94945",
      "country": "US"
    },
    "headline": "Lane Fertility Institute",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(415) 893-0391",
    "bookingUrl": null,
    "location": {
      "latitude": 38.0973,
      "longitude": -122.56
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 43,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {},
    "medicaldirector": "Danielle E. Lane, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {},
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 35.714285714285715
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 14
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "19",
    "name": "Laurel Fertility Care",
    "address": {
      "id": "addr-19",
      "address1": "1700 California St, Suite 570",
      "city": "San Francisco",
      "state": "CA",
      "postalCode": "94109",
      "country": "US"
    },
    "headline": "Laurel Fertility Care",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(415) 673-9199",
    "bookingUrl": null,
    "location": {
      "latitude": 37.7905,
      "longitude": -122.423
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 265,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 37.5,
      "between35And37": 32.7,
      "between38And40": 32.4
    },
    "medicaldirector": "Collin B. Smikle, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 47.1,
      "between35And37": 31.6,
      "between38And40": 23.5
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "frozenEmbryos": 39.1
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "7",
    "name": "Life IVF Center",
    "address": {
      "id": "addr-7",
      "address1": "3500 Barranca Pkwy, Suite 300",
      "city": "Irvine",
      "state": "CA",
      "postalCode": "92606",
      "country": "US"
    },
    "headline": "Life IVF Center",
    "images": [],
    "tags": [],
    "services": ["Patient portal", "Support resources"],
    "languages": ["en", "es", "zh", "ko", "ja", "vi"],
    "clinicType": "Boutique",
    "conditions": [
      "Diminished ovarian reserve",
      "Male factor",
      "Unexplained infertility",
      "PCOS"
    ],
    "treatments": [
      "IVF & ICSI",
      "Egg Freezing",
      "Embryo Freezing",
      "PGT",
      "Donor programs",
      "Surrogacy",
      "Fertility preservation",
      "miniIVF"
    ],
    "website": "https://lifeivfcenter.com/",
    "email": "info@lifeivfcenter.com",
    "phone": "(949) 788-1133",
    "bookingUrl": "https://lifeivfcenter.com/home/book-consultation/",
    "location": {
      "latitude": 33.6863,
      "longitude": -117.815
    },
    "insurances": [],
    "insuranceAccepted": true,
    "insuranceName": null,
    "financiers": ["Package pricing", "Discount pricing"],
    "consultationTypes": ["In person", "Telehealth"],
    "patientGroups": ["LGBTQIA+", "Single Parents"],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": true,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 2030,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": "Boutique fertility center specializing in Natural Cycle and Minimal Stimulation IVF with transparent flat-fee pricing, welcoming patients regardless of age, AMH, or FSH levels.",
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 59,
      "between35And37": 55,
      "between38And40": 55.2
    },
    "medicaldirector": "Frank D. Yelian, MD, PHD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 30.5,
      "between35And37": 27.3,
      "between38And40": 12.8
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 52.4
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "207",
    "name": "LifeStart Fertility Center",
    "address": {
      "id": "addr-207",
      "address1": "29525 Canwood St, Suite 210",
      "city": "Agoura Hills",
      "state": "CA",
      "postalCode": "91301",
      "country": "US"
    },
    "headline": "LifeStart Fertility Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(818) 889-4532",
    "bookingUrl": null,
    "location": {
      "latitude": 34.148,
      "longitude": -118.767
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 6,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "between35And37": 0,
      "between38And40": 0
    },
    "medicaldirector": "Anita P. Singh, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "between38And40": 0
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "199",
    "name": "Loma Linda University Center for Fertility and IVF",
    "address": {
      "id": "addr-199",
      "address1": "Department of Gynecology and Obstetrics, 11370 Anderson St, Suite 3950",
      "city": "Loma Linda",
      "state": "CA",
      "postalCode": "92354",
      "country": "US"
    },
    "headline": "Loma Linda University Center for Fertility and IVF",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(440) 212-3625",
    "bookingUrl": null,
    "location": {
      "latitude": 34.0472,
      "longitude": -117.262
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 86,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 57.89473684210527,
      "between38And40": 50
    },
    "medicaldirector": "Gihan M. Bareh, MD, PHD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "under35": 19,
      "between38And40": 10
    },
    "newPatientSuccessRates": {
      "under35": 25
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "710",
    "name": "Los Angeles Reproductive Center (LARC)",
    "address": {
      "id": "addr-710",
      "address1": "16055 Ventura Blvd, Suite 1127",
      "city": "Encino",
      "state": "CA",
      "postalCode": "91436",
      "country": "US"
    },
    "headline": "Los Angeles Reproductive Center (LARC)",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(818) 946-8051",
    "bookingUrl": null,
    "location": {
      "latitude": 34.1568,
      "longitude": -118.483
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 235,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 54.4,
      "between35And37": 56.7,
      "between38And40": 50
    },
    "medicaldirector": "Nurit Winkler, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between38And40": 18
    },
    "newPatientSuccessRates": {
      "under35": 48.9,
      "between35And37": 40.7,
      "between38And40": 13.8
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 62.1,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "demo",
    "name": "Louise Demo Clinic",
    "address": {
      "id": "addr-demo",
      "address1": "123 Fertility Lane",
      "city": "San Francisco",
      "state": "CA",
      "postalCode": "94105",
      "country": "US"
    },
    "headline": "Louise Demo Clinic",
    "images": [],
    "tags": [],
    "services": [
      "Acupuncture",
      "Counseling",
      "Nutrition counseling",
      "Support groups",
      "Yoga",
      "Mind/Body",
      "Massage therapy",
      "Wellness program",
      "Patient portal",
      "Support resources",
      "Outside monitoring",
      "Concierge service"
    ],
    "languages": ["en", "es"],
    "clinicType": "Network & group",
    "conditions": [
      "PCOS",
      "Endometriosis",
      "Male Factor",
      "Diminished ovarian reserve",
      "Recurrent pregnancy loss",
      "Unexplained infertility",
      "Tubal factor",
      "Ovulatory dysfunction",
      "Uterine factor",
      "Oncofertility"
    ],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Embryo Freezing",
      "PGT",
      "Ovulation Induction",
      "Sperm Freezing",
      "Donor programs",
      "Surrogacy",
      "Fertility preservation",
      "Male factor",
      "Tubal / vasectomy reversal"
    ],
    "website": "https://demo.louisehealth.com",
    "email": "demo@louisehealth.com",
    "phone": "(415) 555-0100",
    "bookingUrl": "https://demo.louisehealth.com/book",
    "location": {
      "latitude": 37.7749,
      "longitude": -122.4194
    },
    "insurances": [],
    "insuranceAccepted": true,
    "insuranceName": "Aetna, Cigna, Blue Cross, UnitedHealthcare",
    "financiers": ["Future Family", "CapexMD", "Gaia", "PatientFi"],
    "consultationTypes": ["In person", "Telehealth"],
    "patientGroups": ["LGBTQIA+", "Single Parents", "Same sex couples"],
    "accessibilities": [],
    "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"],
    "openingTime": "08:00",
    "closingTime": "17:00",
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "Manual",
    "lastReportYear": 2026,
    "publicNotes": "A fully-featured demo clinic showcasing all Louise platform capabilities.",
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "65",
    "name": "Marin Fertility Center",
    "address": {
      "id": "addr-65",
      "address1": "1100 S. Eliseo Dr, Suite 107",
      "city": "Greenbrae",
      "state": "CA",
      "postalCode": "94904",
      "country": "US"
    },
    "headline": "Marin Fertility Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(415) 925-9404",
    "bookingUrl": null,
    "location": {
      "latitude": 37.9439,
      "longitude": -122.534
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 176,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 48,
      "between35And37": 52.2,
      "between38And40": 47.05882352941176
    },
    "medicaldirector": "Peter S. Uzelac, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between38And40": 17
    },
    "newPatientSuccessRates": {
      "under35": 38.9,
      "between35And37": 47.368421052631575,
      "between38And40": 30
    },
    "newPatientSuccessRateDenominators": {
      "between35And37": 19
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 62.5
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 16
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "210",
    "name": "Newport Fertility Center",
    "address": {
      "id": "addr-210",
      "address1": "3501 Jamboree Rd, Suite 1100",
      "city": "Newport Beach",
      "state": "CA",
      "postalCode": "92660",
      "country": "US"
    },
    "headline": "Newport Fertility Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(949) 222-1290",
    "bookingUrl": null,
    "location": {
      "latitude": 33.6549,
      "longitude": -117.866
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 254,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 71.2,
      "between35And37": 55.2,
      "between38And40": 44.1
    },
    "medicaldirector": "Sina Abhari, MD",
    "clinicStatus": "Reorganized",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 57.7,
      "between35And37": 16.7,
      "between38And40": 25.9
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 78.57142857142857,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 14
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "424",
    "name": "Northern California Fertility Medical Center",
    "address": {
      "id": "addr-424",
      "address1": "4320 Auburn Blvd",
      "city": "Sacramento",
      "state": "CA",
      "postalCode": "95841",
      "country": "US"
    },
    "headline": "Northern California Fertility Medical Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(916) 773-2229",
    "bookingUrl": null,
    "location": {
      "latitude": 38.6447,
      "longitude": -121.363
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 679,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 64.2,
      "between35And37": 57.4,
      "between38And40": 59.8
    },
    "medicaldirector": "Michael Murray, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 59.2,
      "between35And37": 41.8,
      "between38And40": 32.4
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 50,
      "donatedEmbryos": 46.15384615384615
    },
    "donorSuccessRateDenominators": {
      "donatedEmbryos": 13
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "460",
    "name": "Nova In Vitro Fertilization",
    "address": {
      "id": "addr-460",
      "address1": "2500 Hospital Dr, Bldg 7",
      "city": "Mountain View",
      "state": "CA",
      "postalCode": "94040",
      "country": "US"
    },
    "headline": "Nova In Vitro Fertilization",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(650) 325-6682",
    "bookingUrl": null,
    "location": {
      "latitude": 37.3683,
      "longitude": -122.082
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 167,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 48.9,
      "between35And37": 63.2,
      "between38And40": 42.4
    },
    "medicaldirector": "Richard J. Schmidt, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 53.8,
      "between35And37": 64,
      "between38And40": 32.1
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 88.23529411764706
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 17
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "317",
    "name": "OC Fertility",
    "address": {
      "id": "addr-317",
      "address1": "1401 Avocado Ave, Suite 403",
      "city": "Newport Beach",
      "state": "CA",
      "postalCode": "92660",
      "country": "US"
    },
    "headline": "OC Fertility",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(949) 706-2229",
    "bookingUrl": null,
    "location": {
      "latitude": 33.6125,
      "longitude": -117.871
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 166,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 62.8,
      "between35And37": 65,
      "between38And40": 53.84615384615385
    },
    "medicaldirector": "Sharon E. Moayeri, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between38And40": 13
    },
    "newPatientSuccessRates": {
      "under35": 52.5,
      "between35And37": 42.3,
      "between38And40": 9.5
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 55.55555555555556,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 9
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "214",
    "name": "Pacific Fertility Center",
    "address": {
      "id": "addr-214",
      "address1": "55 Francisco St, Suite 500",
      "city": "San Francisco",
      "state": "CA",
      "postalCode": "94133",
      "country": "US"
    },
    "headline": "Pacific Fertility Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(415) 834-3000",
    "bookingUrl": null,
    "location": {
      "latitude": 37.8054,
      "longitude": -122.406
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 487,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 48.3,
      "between35And37": 52.6,
      "between38And40": 49.4
    },
    "medicaldirector": "Isabelle Ryan, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 44.2,
      "between35And37": 45.1,
      "between38And40": 18.5
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 41.3
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "99",
    "name": "Pacific Fertility Center-Los Angeles",
    "address": {
      "id": "addr-99",
      "address1": "10921 Wilshire Blvd, Suite 700",
      "city": "Los Angeles",
      "state": "CA",
      "postalCode": "90024",
      "country": "US"
    },
    "headline": "Pacific Fertility Center-Los Angeles",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(310) 209-7700",
    "bookingUrl": null,
    "location": {
      "latitude": 34.0591,
      "longitude": -118.445
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 247,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 53.5,
      "between35And37": 53.6,
      "between38And40": 42.9
    },
    "medicaldirector": "Vicken Sahakian, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 36.5,
      "between35And37": 36.1,
      "between38And40": 5.4
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 28.9
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "188",
    "name": "Pacific Reproductive Center",
    "address": {
      "id": "addr-188",
      "address1": "3720 Lomita Blvd, Suite 200",
      "city": "Torrance",
      "state": "CA",
      "postalCode": "90505",
      "country": "US"
    },
    "headline": "Pacific Reproductive Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(310) 376-7000",
    "bookingUrl": null,
    "location": {
      "latitude": 33.8149,
      "longitude": -118.35
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 163,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 64.2,
      "between35And37": 55.2,
      "between38And40": 55.2
    },
    "medicaldirector": "Rifaat Salem, MD, PHD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 51.3,
      "between35And37": 55,
      "between38And40": 42.3
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 55.55555555555556,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 9
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "101",
    "name": "Palo Alto Medical Foundation",
    "address": {
      "id": "addr-101",
      "address1": "2581 Samaritan Dr, Suite 302",
      "city": "San Jose",
      "state": "CA",
      "postalCode": "95124",
      "country": "US"
    },
    "headline": "Palo Alto Medical Foundation",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(800) 597-2234",
    "bookingUrl": null,
    "location": {
      "latitude": 37.2531,
      "longitude": -121.949
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 479,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 52.4,
      "between35And37": 42.5,
      "between38And40": 46.3
    },
    "medicaldirector": "Mohammad M. Ezzati, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 58.8,
      "between35And37": 48.7,
      "between38And40": 37.5
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "frozenEmbryos": 42.4
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "446",
    "name": "Reproductive Fertility Center, LinFertility Family Foundation",
    "address": {
      "id": "addr-446",
      "address1": "16300 Sand Canyon Ave, Suite 911",
      "city": "Irvine",
      "state": "CA",
      "postalCode": "92618",
      "country": "US"
    },
    "headline": "Reproductive Fertility Center, LinFertility Family Foundation",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(949) 453-8600",
    "bookingUrl": null,
    "location": {
      "latitude": 33.6604,
      "longitude": -117.773
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 217,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 65,
      "between35And37": 48,
      "between38And40": 54.5
    },
    "medicaldirector": "James P. Lin, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 62.1,
      "between35And37": 40,
      "between38And40": 40
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 51.1,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "888",
    "name": "Reproductive Health and Wellness Center",
    "address": {
      "id": "addr-888",
      "address1": "23141 Moulton Pkwy, Suite 204",
      "city": "Laguna Hills",
      "state": "CA",
      "postalCode": "92653",
      "country": "US"
    },
    "headline": "Reproductive Health and Wellness Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(949) 516-0606",
    "bookingUrl": null,
    "location": {
      "latitude": 33.6263,
      "longitude": -117.7321
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 172,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 63.2,
      "between35And37": 39,
      "between38And40": 60.7
    },
    "medicaldirector": "Marcus A. Rosencrantz, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 65.3,
      "between35And37": 37.5,
      "between38And40": 34.6
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 84.61538461538461
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 13
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "820",
    "name": "Reproductive Medicine Associates of Northern California",
    "address": {
      "id": "addr-820",
      "address1": "150 Spear St, Suite 500",
      "city": "San Francisco",
      "state": "CA",
      "postalCode": "94105",
      "country": "US"
    },
    "headline": "Reproductive Medicine Associates of Northern California",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(415) 603-6999",
    "bookingUrl": null,
    "location": {
      "latitude": 37.7918,
      "longitude": -122.394
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 1047,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 66.2,
      "between35And37": 54.8,
      "between38And40": 56.3
    },
    "medicaldirector": "Scott Morin, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 53.7,
      "between35And37": 36.2,
      "between38And40": 17
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 62.5,
      "frozenEmbryos": 54,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFrozenEggs": 8
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "825",
    "name": "Reproductive Medicine Associates of Southern California",
    "address": {
      "id": "addr-825",
      "address1": "11500 W. Olympic Blvd, Suite 150",
      "city": "Los Angeles",
      "state": "CA",
      "postalCode": "90064",
      "country": "US"
    },
    "headline": "Reproductive Medicine Associates of Southern California",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(424) 293-8841",
    "bookingUrl": null,
    "location": {
      "latitude": 34.0358,
      "longitude": -118.444
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 115,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 72.22222222222221,
      "between35And37": 55.2,
      "between38And40": 57.1
    },
    "medicaldirector": "Thomas Kim, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "under35": 18
    },
    "newPatientSuccessRates": {
      "under35": 62.5,
      "between35And37": 54.5,
      "between38And40": 28.6
    },
    "newPatientSuccessRateDenominators": {
      "under35": 16
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 41.17647058823529
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 17
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "339",
    "name": "Reproductive Partners Fertility Center-San Diego",
    "address": {
      "id": "addr-339",
      "address1": "9850 Genesee Ave, Suite 800",
      "city": "La Jolla",
      "state": "CA",
      "postalCode": "92037",
      "country": "US"
    },
    "headline": "Reproductive Partners Fertility Center-San Diego",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(858) 552-9177",
    "bookingUrl": null,
    "location": {
      "latitude": 32.8833,
      "longitude": -117.226
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 439,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 55.8,
      "between35And37": 58.6,
      "between38And40": 54.4
    },
    "medicaldirector": "V. Gabriel Garzo, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 59,
      "between35And37": 42.3,
      "between38And40": 32.9
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 41.7,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "385",
    "name": "Reproductive Partners-Beverly Hills, Redondo Beach & Westminster",
    "address": {
      "id": "addr-385",
      "address1": "510 N. Prospect Ave, Suite 202",
      "city": "Redondo Beach",
      "state": "CA",
      "postalCode": "90277",
      "country": "US"
    },
    "headline": "Reproductive Partners-Beverly Hills, Redondo Beach & Westminster",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(310) 318-3010",
    "bookingUrl": null,
    "location": {
      "latitude": 33.8525,
      "longitude": -118.379
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 1080,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 65.5,
      "between35And37": 51.8,
      "between38And40": 51.2
    },
    "medicaldirector": "Gayane Ambartsumyan, MD, PHD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 53.6,
      "between35And37": 31.9,
      "between38And40": 29.9
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 50,
      "frozenEmbryos": 52.3,
      "donatedEmbryos": 42.857142857142854
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFrozenEggs": 14,
      "donatedEmbryos": 14
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "18",
    "name": "Reproductive Science Center of the San Francisco Bay Area",
    "address": {
      "id": "addr-18",
      "address1": "100 Park Pl, Suite 200",
      "city": "San Ramon",
      "state": "CA",
      "postalCode": "94583",
      "country": "US"
    },
    "headline": "Reproductive Science Center of the San Francisco Bay Area",
    "images": [],
    "tags": [],
    "services": [
      "Mind/Body",
      "Nutrition counseling",
      "Counseling",
      "Patient portal",
      "Support resources"
    ],
    "languages": ["en"],
    "clinicType": "Network & group",
    "conditions": [
      "PCOS",
      "Endometriosis",
      "Male Factor",
      "Diminished ovarian reserve",
      "Recurrent pregnancy loss",
      "Unexplained infertility",
      "Ovulatory dysfunction"
    ],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Embryo Freezing",
      "PGT",
      "Ovulation Induction",
      "Sperm Freezing",
      "Donor programs",
      "Surrogacy",
      "Fertility preservation"
    ],
    "website": "https://rscbayarea.com",
    "email": null,
    "phone": "(925) 867-1800",
    "bookingUrl": "https://rscbayarea.com/contact.html",
    "location": {
      "latitude": 37.7725,
      "longitude": -121.99
    },
    "insurances": [],
    "insuranceAccepted": true,
    "insuranceName": null,
    "financiers": ["Discount pricing", "Package pricing", "CapexMD"],
    "consultationTypes": ["In person"],
    "patientGroups": ["LGBTQIA+", "Single Parents", "Same sex couples"],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 1305,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": "Pioneering fertility center with over 40 years of experience, part of the US Fertility network, offering free emotional health programs and bundled multi-cycle savings.",
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 65.5,
      "between35And37": 65.3,
      "between38And40": 62.6
    },
    "medicaldirector": "Mary D. Hinckley, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 56.6,
      "between35And37": 52.2,
      "between38And40": 35
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 68.1,
      "frozenEmbryos": 52.9,
      "donatedEmbryos": 72.72727272727273
    },
    "donorSuccessRateDenominators": {
      "donatedEmbryos": 11
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "602",
    "name": "Reproductive Sciences Medical Center",
    "address": {
      "id": "addr-602",
      "address1": "3661 Valley Centre Dr, Suite 100",
      "city": "San Diego",
      "state": "CA",
      "postalCode": "92130",
      "country": "US"
    },
    "headline": "Reproductive Sciences Medical Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(858) 436-7186",
    "bookingUrl": null,
    "location": {
      "latitude": 32.9364,
      "longitude": -117.234
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 142,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 69.7,
      "between35And37": 75,
      "between38And40": 56.25
    },
    "medicaldirector": "Minh N. Ho, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between35And37": 12,
      "between38And40": 16
    },
    "newPatientSuccessRates": {
      "under35": 61.5,
      "between35And37": 54.54545454545454
    },
    "newPatientSuccessRateDenominators": {
      "between35And37": 11
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 48.7
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "866",
    "name": "RMA of San Diego dba, Pearl Mini IVF",
    "address": {
      "id": "addr-866",
      "address1": "4510 Executive Dr, Suite 150",
      "city": "San Diego",
      "state": "CA",
      "postalCode": "92121",
      "country": "US"
    },
    "headline": "RMA of San Diego dba, Pearl Mini IVF",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(858) 614-6161",
    "bookingUrl": null,
    "location": {
      "latitude": 32.8762,
      "longitude": -117.2109
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 56,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {},
    "medicaldirector": "Anne C. Davis, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {},
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "705",
    "name": "San Diego Fertility Center",
    "address": {
      "id": "addr-705",
      "address1": "11425 El Camino Real",
      "city": "San Diego",
      "state": "CA",
      "postalCode": "92130",
      "country": "US"
    },
    "headline": "San Diego Fertility Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(858) 794-6363",
    "bookingUrl": null,
    "location": {
      "latitude": 32.9276,
      "longitude": -117.237
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 684,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 61.1,
      "between35And37": 58.2,
      "between38And40": 49.4
    },
    "medicaldirector": "Sandy Chuan, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 60,
      "between35And37": 36.2,
      "between38And40": 22
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "frozenEmbryos": 66.1,
      "donatedEmbryos": 66.7
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "12",
    "name": "Santa Barbara Fertility Center",
    "address": {
      "id": "addr-12",
      "address1": "536 E. Arrellaga St, Suite 201",
      "city": "Santa Barbara",
      "state": "CA",
      "postalCode": "93103",
      "country": "US"
    },
    "headline": "Santa Barbara Fertility Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(805) 965-3400",
    "bookingUrl": null,
    "location": {
      "latitude": 34.4331,
      "longitude": -119.703
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 135,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 37.8,
      "between35And37": 25.6,
      "between38And40": 38.1
    },
    "medicaldirector": "René B. Allen, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 42.9,
      "between35And37": 33.3,
      "between38And40": 20.8
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 19
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "491",
    "name": "Santa Monica Fertility",
    "address": {
      "id": "addr-491",
      "address1": "2825 Santa Monica Blvd, Suite 100",
      "city": "Santa Monica",
      "state": "CA",
      "postalCode": "90404",
      "country": "US"
    },
    "headline": "Santa Monica Fertility",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(310) 566-1470",
    "bookingUrl": null,
    "location": {
      "latitude": 34.0357,
      "longitude": -118.472
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 236,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 0
    },
    "medicaldirector": "Guy E. Ringler, MD",
    "clinicStatus": "Reorganized",
    "successRateDenominators": {},
    "newPatientSuccessRates": {},
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 21.2,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "124",
    "name": "Southern California Center for Reproductive Medicine",
    "address": {
      "id": "addr-124",
      "address1": "361 Hospital Rd, Suite 333",
      "city": "Newport Beach",
      "state": "CA",
      "postalCode": "92663",
      "country": "US"
    },
    "headline": "Southern California Center for Reproductive Medicine",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(949) 642-8727",
    "bookingUrl": null,
    "location": {
      "latitude": 33.6262,
      "longitude": -117.93
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 448,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 47.9,
      "between35And37": 61.3,
      "between38And40": 57.5
    },
    "medicaldirector": "Robert E. Anderson, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 46.9,
      "between35And37": 44.9,
      "between38And40": 35.8
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 58.2
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "107",
    "name": "Southern California Reproductive Center",
    "address": {
      "id": "addr-107",
      "address1": "450 N. Roxbury Dr, Suite 500",
      "city": "Beverly Hills",
      "state": "CA",
      "postalCode": "90210",
      "country": "US"
    },
    "headline": "Southern California Reproductive Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(310) 277-2393",
    "bookingUrl": null,
    "location": {
      "latitude": 34.0683,
      "longitude": -118.407
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 854,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 59.4,
      "between35And37": 56.2,
      "between38And40": 54.8
    },
    "medicaldirector": "Mark W. Surrey, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 42.1,
      "between35And37": 32.7,
      "between38And40": 15.7
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 53.3
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "876",
    "name": "Spring Fertility-East Bay",
    "address": {
      "id": "addr-876",
      "address1": "80 Grand Ave, 3rd Floor",
      "city": "Oakland",
      "state": "CA",
      "postalCode": "94612",
      "country": "US"
    },
    "headline": "Spring Fertility-East Bay",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(415) 964-5618",
    "bookingUrl": null,
    "location": {
      "latitude": 37.8117,
      "longitude": -122.2662
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 235,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 65,
      "between35And37": 53.2,
      "between38And40": 62.5
    },
    "medicaldirector": "Thomas E. Fisher, DO",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 54.8,
      "between35And37": 44.4,
      "between38And40": 26.3
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 77.77777777777779,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 9
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "723",
    "name": "Spring Fertility-San Francisco",
    "address": {
      "id": "addr-723",
      "address1": "1 Daniel Burnham Ct, Suite 110C",
      "city": "San Francisco",
      "state": "CA",
      "postalCode": "94109",
      "country": "US"
    },
    "headline": "Spring Fertility-San Francisco",
    "images": [],
    "tags": [],
    "services": [
      "Acupuncture",
      "Nutrition counseling",
      "Counseling",
      "Support groups",
      "Patient portal"
    ],
    "languages": ["en", "es", "fr"],
    "clinicType": "Network & group",
    "conditions": [
      "PCOS",
      "Endometriosis",
      "Male Factor",
      "Diminished ovarian reserve",
      "Unexplained infertility",
      "Oncofertility"
    ],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Embryo Freezing",
      "PGT",
      "Sperm Freezing",
      "Donor programs",
      "Surrogacy",
      "Fertility preservation",
      "miniIVF"
    ],
    "website": "https://springfertility.com",
    "email": "info@springfertility.com",
    "phone": "(415) 964-5618",
    "bookingUrl": "https://springfertility.com/book-a-consult/",
    "location": {
      "latitude": 37.7867,
      "longitude": -122.422
    },
    "insurances": [],
    "insuranceAccepted": true,
    "insuranceName": null,
    "financiers": ["Package pricing"],
    "consultationTypes": ["In person", "Telehealth"],
    "patientGroups": ["LGBTQIA+", "Single Parents", "Same sex couples"],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 1374,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": "Patient-centric fertility network with integrative services including acupuncture and nutrition, offering dedicated care teams with a personal navigator for every patient.",
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 62.1,
      "between35And37": 58.1,
      "between38And40": 52.5
    },
    "medicaldirector": "Monica C. Pasternak, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 60.6,
      "between35And37": 44.8,
      "between38And40": 30.3
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 40.9,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "875",
    "name": "Spring Fertility-Silicon Valley",
    "address": {
      "id": "addr-875",
      "address1": "550 Lakeside Dr",
      "city": "Sunnyvale",
      "state": "CA",
      "postalCode": "94085",
      "country": "US"
    },
    "headline": "Spring Fertility-Silicon Valley",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(415) 964-5618",
    "bookingUrl": null,
    "location": {
      "latitude": 37.3858,
      "longitude": -121.9928
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 283,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 56.1,
      "between35And37": 60.4,
      "between38And40": 57.7
    },
    "medicaldirector": "Nam D. Tran, MD, PHD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 56.2,
      "between35And37": 38.2,
      "between38And40": 17.5
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 60
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 10
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "621",
    "name": "Stanford Medicine Fertility & Reproductive Health",
    "address": {
      "id": "addr-621",
      "address1": "1195 W. Fremont Ave",
      "city": "Sunnyvale",
      "state": "CA",
      "postalCode": "94087",
      "country": "US"
    },
    "headline": "Stanford Medicine Fertility & Reproductive Health",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(650) 498-7911",
    "bookingUrl": null,
    "location": {
      "latitude": 37.3527,
      "longitude": -122.062
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 737,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 54.9,
      "between35And37": 51.1,
      "between38And40": 41.7
    },
    "medicaldirector": "Ruben J. Alvero, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 34.8,
      "between35And37": 24.8,
      "between38And40": 17.2
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 38.46153846153847,
      "frozenEmbryos": 27,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFrozenEggs": 13
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "458",
    "name": "The Center for Fertility and Gynecology, Vermesh Center for Fertility",
    "address": {
      "id": "addr-458",
      "address1": "18370 Burbank Blvd, Suite 301",
      "city": "Tarzana",
      "state": "CA",
      "postalCode": "91356",
      "country": "US"
    },
    "headline": "The Center for Fertility and Gynecology, Vermesh Center for Fertility",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(818) 881-9800",
    "bookingUrl": null,
    "location": {
      "latitude": 34.1704,
      "longitude": -118.533
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 163,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 72.9,
      "between35And37": 61.9,
      "between38And40": 69.23076923076923
    },
    "medicaldirector": "Michael Vermesh, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between38And40": 13
    },
    "newPatientSuccessRates": {
      "under35": 80,
      "between35And37": 47.368421052631575
    },
    "newPatientSuccessRateDenominators": {
      "between35And37": 19
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 71.4
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "356",
    "name": "The Fertility and Gynecology Center, Monterey Bay IVF",
    "address": {
      "id": "addr-356",
      "address1": "9833 Blue Larkspur Ln",
      "city": "Monterey",
      "state": "CA",
      "postalCode": "93940",
      "country": "US"
    },
    "headline": "The Fertility and Gynecology Center, Monterey Bay IVF",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(831) 649-4483",
    "bookingUrl": null,
    "location": {
      "latitude": 36.5714,
      "longitude": -121.802
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 65,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 38.88888888888889,
      "between38And40": 0
    },
    "medicaldirector": "Edward J. Ramirez, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "under35": 18,
      "between38And40": 7
    },
    "newPatientSuccessRates": {
      "between35And37": 0,
      "between38And40": 0
    },
    "newPatientSuccessRateDenominators": {
      "between35And37": 9,
      "between38And40": 9
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "171",
    "name": "Tree of Life Center for Fertility, California Fertility Clinics",
    "address": {
      "id": "addr-171",
      "address1": "18370 Burbank Blvd, Suite 511",
      "city": "Tarzana",
      "state": "CA",
      "postalCode": "91356",
      "country": "US"
    },
    "headline": "Tree of Life Center for Fertility, California Fertility Clinics",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(818) 344-8522",
    "bookingUrl": null,
    "location": {
      "latitude": 34.1705,
      "longitude": -118.533
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 135,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 52,
      "between35And37": 33.3,
      "between38And40": 35
    },
    "medicaldirector": "Vuk Jovanovic, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 44.4,
      "between35And37": 25.9,
      "between38And40": 29.2
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 64,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "361",
    "name": "UCLA Fertility Center",
    "address": {
      "id": "addr-361",
      "address1": "Department of Obstetrics and Gynecology, 1245 16th St, Suite 202",
      "city": "Santa Monica",
      "state": "CA",
      "postalCode": "90404",
      "country": "US"
    },
    "headline": "UCLA Fertility Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(310) 825-9500",
    "bookingUrl": null,
    "location": {
      "latitude": 34.0648,
      "longitude": -118.447
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 304,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 56.7,
      "between35And37": 49.1,
      "between38And40": 58.1
    },
    "medicaldirector": "Kathleen M. Brennan, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 41.8,
      "between35And37": 46.7,
      "between38And40": 22.9
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 71.42857142857143,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 7
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "362",
    "name": "UCSF Center for Reproductive Health",
    "address": {
      "id": "addr-362",
      "address1": "499 Illinois St, 6th Floor",
      "city": "San Francisco",
      "state": "CA",
      "postalCode": "94158",
      "country": "US"
    },
    "headline": "UCSF Center for Reproductive Health",
    "images": [],
    "tags": [],
    "services": [
      "Counseling",
      "Support groups",
      "Patient portal",
      "Support resources"
    ],
    "languages": ["en", "es"],
    "clinicType": "Hospital-based",
    "conditions": [
      "PCOS",
      "Endometriosis",
      "Male Factor",
      "Diminished ovarian reserve",
      "Recurrent pregnancy loss",
      "Unexplained infertility",
      "Oncofertility",
      "Ovulatory dysfunction",
      "Uterine factor"
    ],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Embryo Freezing",
      "PGT",
      "Ovulation Induction",
      "Sperm Freezing",
      "Donor programs",
      "Surrogacy",
      "Fertility preservation",
      "Male factor"
    ],
    "website": "https://crh.ucsf.edu/",
    "email": null,
    "phone": "(415) 353-3040",
    "bookingUrl": "https://crh.ucsf.edu/appointments/",
    "location": {
      "latitude": 37.7658,
      "longitude": -122.388
    },
    "insurances": [],
    "insuranceAccepted": true,
    "insuranceName": null,
    "financiers": ["Payment plans", "Discount pricing", "Future Family"],
    "consultationTypes": ["In person"],
    "patientGroups": ["LGBTQIA+", "Single Parents", "Same sex couples"],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 1429,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": "Academic medical center at UCSF Mission Bay offering research-driven fertility care with specialized multidisciplinary clinics for PCOS, oncofertility, and LGBTQ+ family building.",
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 45.8,
      "between35And37": 42.9,
      "between38And40": 44.2
    },
    "medicaldirector": "Marcelle I. Cedars, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 43.9,
      "between35And37": 38.5,
      "between38And40": 25.3
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 55.55555555555556,
      "freshEmbryosFrozenEggs": 48,
      "frozenEmbryos": 42.5,
      "donatedEmbryos": 38.88888888888889
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFreshEggs": 9,
      "donatedEmbryos": 18
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "810",
    "name": "Unity Fertility Center, LLC",
    "address": {
      "id": "addr-810",
      "address1": "625 S. Fair Oaks Ave, Suite 330",
      "city": "Pasadena",
      "state": "CA",
      "postalCode": "91105",
      "country": "US"
    },
    "headline": "Unity Fertility Center, LLC",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(626) 588-1555",
    "bookingUrl": null,
    "location": {
      "latitude": 34.135,
      "longitude": -118.151
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 29,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {},
    "medicaldirector": "Chun-Yeh Wang, MD, PHD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {},
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "27",
    "name": "University Fertility Center",
    "address": {
      "id": "addr-27",
      "address1": "23550 Hawthorne Blvd, Suite 210",
      "city": "Torrance",
      "state": "CA",
      "postalCode": "90505",
      "country": "US"
    },
    "headline": "University Fertility Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(310) 378-7445",
    "bookingUrl": null,
    "location": {
      "latitude": 33.8119,
      "longitude": -118.35
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 118,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 30,
      "between35And37": 44.8,
      "between38And40": 41.7
    },
    "medicaldirector": "Omid A. Khorram, MD, PHD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "between35And37": 40.7,
      "between38And40": 40
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 33.3
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "937",
    "name": "USC Fertility",
    "address": {
      "id": "addr-937",
      "address1": "55 S. Lake Ave., 9th Floor",
      "city": "Pasadena",
      "state": "CA",
      "postalCode": "91101",
      "country": "US"
    },
    "headline": "USC Fertility",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(626) 440-9161",
    "bookingUrl": null,
    "location": {
      "latitude": 34.1446,
      "longitude": -118.1325
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 12,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 0,
      "between35And37": 0,
      "between38And40": 0
    },
    "medicaldirector": "Richard J. Paulson, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 0,
      "between35And37": 0,
      "between38And40": 0
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 0
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 7
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "392",
    "name": "Valley Center for Reproductive Health, Inc., West Coast Women's Reproductive Center",
    "address": {
      "id": "addr-392",
      "address1": "4835 Van Nuys Blvd, Suite 200",
      "city": "Sherman Oaks",
      "state": "CA",
      "postalCode": "91403",
      "country": "US"
    },
    "headline": "Valley Center for Reproductive Health, Inc., West Coast Women's Reproductive Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(818) 986-1648",
    "bookingUrl": null,
    "location": {
      "latitude": 34.1585,
      "longitude": -118.449
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 17,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {},
    "medicaldirector": "Tina B. Koopersmith, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {},
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 5
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "84",
    "name": "West Coast Fertility Center",
    "address": {
      "id": "addr-84",
      "address1": "11160 Warner Ave, Suite 411",
      "city": "Fountain Valley",
      "state": "CA",
      "postalCode": "92708",
      "country": "US"
    },
    "headline": "West Coast Fertility Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(714) 513-1399",
    "bookingUrl": null,
    "location": {
      "latitude": 33.7155,
      "longitude": -117.934
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 66,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 52.94117647058824,
      "between35And37": 36.84210526315789,
      "between38And40": 22.7
    },
    "medicaldirector": "Vitaly A. Kushnir, MD",
    "clinicStatus": "Reorganized",
    "successRateDenominators": {
      "under35": 17,
      "between35And37": 19
    },
    "newPatientSuccessRates": {
      "under35": 50,
      "between35And37": 45.45454545454545,
      "between38And40": 29.411764705882355
    },
    "newPatientSuccessRateDenominators": {
      "under35": 18,
      "between35And37": 11,
      "between38And40": 17
    },
    "donorSuccessRates": {
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "706",
    "name": "Western Fertility Institute",
    "address": {
      "id": "addr-706",
      "address1": "16260 Ventura Blvd, Suite 210",
      "city": "Encino",
      "state": "CA",
      "postalCode": "91436",
      "country": "US"
    },
    "headline": "Western Fertility Institute",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(818) 292-2242",
    "bookingUrl": null,
    "location": {
      "latitude": 34.1567,
      "longitude": -118.488
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 192,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 57.5,
      "between35And37": 52.2,
      "between38And40": 38.1
    },
    "medicaldirector": "Ashim V. Kumar, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 50,
      "between35And37": 56.7
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 62.4
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "359",
    "name": "Zouves Fertility Center",
    "address": {
      "id": "addr-359",
      "address1": "1241 E. Hillsdale Blvd, Suite 100",
      "city": "Foster City",
      "state": "CA",
      "postalCode": "94404",
      "country": "US"
    },
    "headline": "Zouves Fertility Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(650) 378-1000",
    "bookingUrl": null,
    "location": {
      "latitude": 37.5679,
      "longitude": -122.268
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 202,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 44,
      "between35And37": 48.3,
      "between38And40": 51.9
    },
    "medicaldirector": "Christo G. Zouves, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 37.5,
      "between35And37": 33.3,
      "between38And40": 16.7
    },
    "newPatientSuccessRateDenominators": {
      "under35": 16
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 38,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "153",
    "name": "CNY Fertility Colorado",
    "address": {
      "id": "addr-153",
      "address1": "265 S. Parkside Dr, Suite 200",
      "city": "Colorado Springs",
      "state": "CO",
      "postalCode": "80910",
      "country": "US"
    },
    "headline": "CNY Fertility Colorado",
    "images": [],
    "tags": [],
    "services": [
      "Acupuncture",
      "Massage therapy",
      "Yoga",
      "Counseling",
      "Support groups",
      "Wellness program",
      "Patient portal",
      "Support resources"
    ],
    "languages": ["en"],
    "clinicType": "Network & group",
    "conditions": [
      "PCOS",
      "Endometriosis",
      "Male Factor",
      "Diminished ovarian reserve",
      "Unexplained infertility",
      "Recurrent pregnancy loss"
    ],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Embryo Freezing",
      "PGT",
      "Ovulation Induction",
      "Sperm Freezing",
      "Donor programs",
      "Surrogacy",
      "Fertility preservation",
      "miniIVF",
      "PRP"
    ],
    "website": "https://www.cnyfertility.com/location/colorado-springs/",
    "email": "submissions@cnyfertility.com",
    "phone": "(719) 475-2229",
    "bookingUrl": "https://schedule.cnyfertility.com/",
    "location": {
      "latitude": 38.8283,
      "longitude": -104.789
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [
      "Payment plans",
      "Loans",
      "Discount pricing",
      "Future Family",
      "CapexMD"
    ],
    "consultationTypes": ["In person", "Telehealth"],
    "patientGroups": ["LGBTQIA+", "Single Parents", "Same sex couples"],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 1389,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": "Known for making fertility treatment affordable at a fraction of the national average, with in-house payment plans and a holistic wellness approach including acupuncture and yoga.",
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 21.4,
      "between35And37": 19,
      "between38And40": 11
    },
    "medicaldirector": "Robert J. Kiltz, MD",
    "clinicStatus": "Reorganized",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 28.5,
      "between35And37": 22.8,
      "between38And40": 10.8
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 17.4,
      "frozenEmbryos": 9.2,
      "donatedEmbryos": 8.6
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "49",
    "name": "Colorado Center for Reproductive Medicine",
    "address": {
      "id": "addr-49",
      "address1": "10290 RidgeGate Cir",
      "city": "Lone Tree",
      "state": "CO",
      "postalCode": "80124",
      "country": "US"
    },
    "headline": "Colorado Center for Reproductive Medicine",
    "images": [],
    "tags": [],
    "services": [
      "Mind/Body",
      "Counseling",
      "Support groups",
      "Patient portal",
      "Yoga"
    ],
    "languages": ["en", "es"],
    "clinicType": "Network & group",
    "conditions": ["Diminished ovarian reserve", "Oncofertility"],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Embryo Freezing",
      "PGT",
      "Sperm Freezing",
      "Donor programs",
      "Surrogacy",
      "Fertility preservation"
    ],
    "website": "https://www.ccrmivf.com",
    "email": null,
    "phone": "(303) 788-8300",
    "bookingUrl": "https://www.ccrmivf.com/schedule-appointment/",
    "location": {
      "latitude": 39.5293,
      "longitude": -104.875
    },
    "insurances": [],
    "insuranceAccepted": true,
    "insuranceName": null,
    "financiers": [
      "Payment plans",
      "Package pricing",
      "Discount pricing",
      "Future Family",
      "CapexMD"
    ],
    "consultationTypes": ["In person", "Telehealth"],
    "patientGroups": ["LGBTQIA+", "Same sex couples"],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 1830,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": "A nationally recognized fertility network with an all-inclusive Lone Tree facility housing an on-site clinic, surgery center, IVF lab, and genetics lab.",
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 62.9,
      "between35And37": 60.7,
      "between38And40": 54.8
    },
    "medicaldirector": "William B. Schoolcraft, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 60.7,
      "between35And37": 52.6,
      "between38And40": 31.5
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "frozenEmbryos": 57.6,
      "donatedEmbryos": 53.84615384615385
    },
    "donorSuccessRateDenominators": {
      "donatedEmbryos": 13
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "91",
    "name": "Conceptions Reproductive Associates of Colorado",
    "address": {
      "id": "addr-91",
      "address1": "271 W. County Line Rd",
      "city": "Littleton",
      "state": "CO",
      "postalCode": "80129",
      "country": "US"
    },
    "headline": "Conceptions Reproductive Associates of Colorado",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(303) 794-0045",
    "bookingUrl": null,
    "location": {
      "latitude": 39.5673,
      "longitude": -104.993
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 1153,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 70.1,
      "between35And37": 67,
      "between38And40": 69.6
    },
    "medicaldirector": "Robert Greene, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 47.2,
      "between35And37": 30.2,
      "between38And40": 13.6
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 58.7
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "36",
    "name": "Denver Fertility-Albrecht Women's Care",
    "address": {
      "id": "addr-36",
      "address1": "9780 Pyramid Ct, Suite 260",
      "city": "Englewood",
      "state": "CO",
      "postalCode": "80112",
      "country": "US"
    },
    "headline": "Denver Fertility-Albrecht Women's Care",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(720) 420-1570",
    "bookingUrl": null,
    "location": {
      "latitude": 39.5387,
      "longitude": -104.865
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 143,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 56.8,
      "between35And37": 59.4,
      "between38And40": 35.294117647058826
    },
    "medicaldirector": "Bruce H. Albrecht, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between38And40": 17
    },
    "newPatientSuccessRates": {
      "under35": 54.5,
      "between35And37": 34.3,
      "between38And40": 13.6
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 53.3,
      "donatedEmbryos": 42.857142857142854
    },
    "donorSuccessRateDenominators": {
      "donatedEmbryos": 14
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "897",
    "name": "Kindbody - Denver",
    "address": {
      "id": "addr-897",
      "address1": "220 Josephine St",
      "city": "Denver",
      "state": "CO",
      "postalCode": "80206",
      "country": "US"
    },
    "headline": "Kindbody - Denver",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(720) 370-5671",
    "bookingUrl": null,
    "location": {
      "latitude": 39.7191,
      "longitude": -104.9569
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 0,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 0,
      "between35And37": 0,
      "between38And40": 0
    },
    "medicaldirector": "Natalia Grob, MD",
    "clinicStatus": "Reorganized",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 0,
      "between35And37": 0,
      "between38And40": 0
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "110",
    "name": "Rocky Mountain Center for Reproductive Medicine",
    "address": {
      "id": "addr-110",
      "address1": "1080 E. Elizabeth St",
      "city": "Fort Collins",
      "state": "CO",
      "postalCode": "80524",
      "country": "US"
    },
    "headline": "Rocky Mountain Center for Reproductive Medicine",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(970) 493-6353",
    "bookingUrl": null,
    "location": {
      "latitude": 40.5745,
      "longitude": -105.059
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 58,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 51.5,
      "between35And37": 45.5
    },
    "medicaldirector": "Kevin E. Bachus, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 59.3,
      "between35And37": 60
    },
    "newPatientSuccessRateDenominators": {
      "between35And37": 15
    },
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "299",
    "name": "Rocky Mountain Fertility Center",
    "address": {
      "id": "addr-299",
      "address1": "12770 Lynnfield Dr",
      "city": "Englewood",
      "state": "CO",
      "postalCode": "80112",
      "country": "US"
    },
    "headline": "Rocky Mountain Fertility Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(303) 999-3877",
    "bookingUrl": null,
    "location": {
      "latitude": 39.5367,
      "longitude": -104.842
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 43,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 75,
      "between38And40": 0
    },
    "medicaldirector": "Deborah L. Smith, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 65.2
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "719",
    "name": "Shady Grove Fertility Colorado",
    "address": {
      "id": "addr-719",
      "address1": "8200 E. Belleview Ave, Suite 615-E",
      "city": "Greenwood Village",
      "state": "CO",
      "postalCode": "80111",
      "country": "US"
    },
    "headline": "Shady Grove Fertility Colorado",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(720) 704-8221",
    "bookingUrl": null,
    "location": {
      "latitude": 39.7604,
      "longitude": -104.901
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 191,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 58.2,
      "between35And37": 45.5,
      "between38And40": 47.05882352941176
    },
    "medicaldirector": "Alex J. Polotsky, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between38And40": 17
    },
    "newPatientSuccessRates": {
      "under35": 59.7,
      "between35And37": 47.8,
      "between38And40": 28
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 52.63157894736842
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 19
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "235",
    "name": "Center for Advanced Reproductive Services",
    "address": {
      "id": "addr-235",
      "address1": "2 Batterson Park Rd",
      "city": "Farmington",
      "state": "CT",
      "postalCode": "6032",
      "country": "US"
    },
    "headline": "Center for Advanced Reproductive Services",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(844) 467-3483",
    "bookingUrl": null,
    "location": {
      "latitude": 41.7069,
      "longitude": -72.8001
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 1154,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 51.7,
      "between35And37": 55.6,
      "between38And40": 44.5
    },
    "medicaldirector": "Claudio Benadiva, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 64.7,
      "between35And37": 47.5,
      "between38And40": 32.7
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 43.3,
      "frozenEmbryos": 57.5
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "313",
    "name": "Greenwich Fertility and IVF Center, PC",
    "address": {
      "id": "addr-313",
      "address1": "55 Holly Hill Ln, Suite 270",
      "city": "Greenwich",
      "state": "CT",
      "postalCode": "6830",
      "country": "US"
    },
    "headline": "Greenwich Fertility and IVF Center, PC",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(203) 863-2990",
    "bookingUrl": null,
    "location": {
      "latitude": 41.0163,
      "longitude": -73.6467
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 241,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 47.6,
      "between35And37": 63.2,
      "between38And40": 50
    },
    "medicaldirector": "Barry R. Witt, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 51.4,
      "between35And37": 58.3,
      "between38And40": 46.2
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 66.66666666666666,
      "frozenEmbryos": 66.66666666666666,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFrozenEggs": 12,
      "frozenEmbryos": 12
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "273",
    "name": "Illume Fertility",
    "address": {
      "id": "addr-273",
      "address1": "761 Main Ave, Suite 200",
      "city": "Norwalk",
      "state": "CT",
      "postalCode": "6851",
      "country": "US"
    },
    "headline": "Illume Fertility",
    "images": [],
    "tags": [],
    "services": [
      "Acupuncture",
      "Mind/Body",
      "Nutrition counseling",
      "Counseling",
      "Support groups",
      "Yoga",
      "Wellness program",
      "Patient portal",
      "Support resources"
    ],
    "languages": ["en"],
    "clinicType": "Network & group",
    "conditions": [
      "PCOS",
      "Endometriosis",
      "Male Factor",
      "Tubal factor",
      "Unexplained infertility",
      "Oncofertility"
    ],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Embryo Freezing",
      "PGT",
      "Donor programs",
      "Surrogacy",
      "Fertility preservation"
    ],
    "website": "https://www.illumefertility.com/",
    "email": "care@illumefertility.com",
    "phone": "(203) 750-7400",
    "bookingUrl": "https://www.illumefertility.com/schedule-your-consultation",
    "location": {
      "latitude": 41.1597,
      "longitude": -73.4209
    },
    "insurances": [],
    "insuranceAccepted": true,
    "insuranceName": null,
    "financiers": ["Payment plans", "Future Family"],
    "consultationTypes": ["In person", "Telehealth"],
    "patientGroups": ["LGBTQIA+", "Single Parents", "Same sex couples"],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 1511,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": "Award-winning fertility clinic and first U.S. practice in The Fertility Partners network, recognized as an LGBTQ Healthcare Equality Leader seven years running.",
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 53.2,
      "between35And37": 56.5,
      "between38And40": 54.6
    },
    "medicaldirector": "Mark P. Leondires, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 57.3,
      "between35And37": 47.2,
      "between38And40": 24.5
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 45.45454545454545,
      "frozenEmbryos": 66.5
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFrozenEggs": 11
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "315",
    "name": "New England Fertility Institute",
    "address": {
      "id": "addr-315",
      "address1": "1275 Summer St, Suite 201",
      "city": "Stamford",
      "state": "CT",
      "postalCode": "6905",
      "country": "US"
    },
    "headline": "New England Fertility Institute",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(203) 325-3200",
    "bookingUrl": null,
    "location": {
      "latitude": 41.062,
      "longitude": -73.5415
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 194,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {},
    "medicaldirector": "Gad Lavy, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 0,
      "between38And40": 0
    },
    "newPatientSuccessRateDenominators": {
      "under35": 5,
      "between38And40": 6
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 36.9,
      "donatedEmbryos": 17.6
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "414",
    "name": "Park Avenue Fertility and Reproductive Medicine",
    "address": {
      "id": "addr-414",
      "address1": "5520 Park Ave, Suite WPG-250",
      "city": "Trumbull",
      "state": "CT",
      "postalCode": "6611",
      "country": "US"
    },
    "headline": "Park Avenue Fertility and Reproductive Medicine",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(203) 372-6700",
    "bookingUrl": null,
    "location": {
      "latitude": 41.2274,
      "longitude": -73.2432
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 179,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 84.2,
      "between35And37": 72.72727272727273,
      "between38And40": 33.33333333333333
    },
    "medicaldirector": "Andrew J. Levi, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between35And37": 11,
      "between38And40": 15
    },
    "newPatientSuccessRates": {
      "under35": 61.9
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 71.42857142857143
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 14
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "868",
    "name": "Rejuvenating Fertility Center",
    "address": {
      "id": "addr-868",
      "address1": "225 Main St, Suite 101",
      "city": "Westport",
      "state": "CT",
      "postalCode": "6880",
      "country": "US"
    },
    "headline": "Rejuvenating Fertility Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(203) 557-9696",
    "bookingUrl": null,
    "location": {
      "latitude": 41.1446,
      "longitude": -73.3625
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 4,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 0,
      "between35And37": 0,
      "between38And40": 0
    },
    "medicaldirector": "Zaher  Merhi, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 0,
      "between35And37": 0,
      "between38And40": 0
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "431",
    "name": "Yale Fertility Center",
    "address": {
      "id": "addr-431",
      "address1": "200 W. Campus Dr, 2nd Floor",
      "city": "Orange",
      "state": "CT",
      "postalCode": "6477",
      "country": "US"
    },
    "headline": "Yale Fertility Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(877) 925-3483",
    "bookingUrl": null,
    "location": {
      "latitude": 41.2538,
      "longitude": -72.997
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 435,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 48.9,
      "between35And37": 34.7,
      "between38And40": 49.3
    },
    "medicaldirector": "Emre Seli, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 44.6,
      "between35And37": 24.5,
      "between38And40": 31
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 35.714285714285715,
      "frozenEmbryos": 42.9
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFrozenEggs": 14
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "370",
    "name": "Columbia Fertility Associates",
    "address": {
      "id": "addr-370",
      "address1": "2440 M St N.W., Suite 401",
      "city": "Washington",
      "state": "DC",
      "postalCode": "20037",
      "country": "US"
    },
    "headline": "Columbia Fertility Associates",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(202) 293-6567",
    "bookingUrl": null,
    "location": {
      "latitude": 38.9049,
      "longitude": -77.053
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 488,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 40.9,
      "between35And37": 44.4,
      "between38And40": 38.5
    },
    "medicaldirector": "Preston Sacks, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 45.7,
      "between35And37": 33.3,
      "between38And40": 25.9
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 57.9
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "900",
    "name": "Kindbody - Washington DC",
    "address": {
      "id": "addr-900",
      "address1": "1111 19th Street NW",
      "city": "Washington",
      "state": "DC",
      "postalCode": "20036",
      "country": "US"
    },
    "headline": "Kindbody - Washington DC",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(855) 563-2639",
    "bookingUrl": null,
    "location": {
      "latitude": 38.9048,
      "longitude": -77.0432
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 2,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 0,
      "between35And37": 0,
      "between38And40": 0
    },
    "medicaldirector": "Lynn Westphal, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 0,
      "between35And37": 0,
      "between38And40": 0
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "20",
    "name": "Delaware Institute for Reproductive Medicine, PA",
    "address": {
      "id": "addr-20",
      "address1": "Medical Arts Pavilion 1, 4745 Ogletown-Stanton Rd, Suite 111",
      "city": "Newark",
      "state": "DE",
      "postalCode": "19713",
      "country": "US"
    },
    "headline": "Delaware Institute for Reproductive Medicine, PA",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(302) 738-4600",
    "bookingUrl": null,
    "location": {
      "latitude": 39.686,
      "longitude": -75.6732
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 203,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 31.1,
      "between35And37": 34.2
    },
    "medicaldirector": "Jeffrey B. Russell, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 43.1,
      "between35And37": 26.9
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "488",
    "name": "RADfertility",
    "address": {
      "id": "addr-488",
      "address1": "Medical Arts Pavilion 2, 4735 Ogletown-Stanton Rd, Suite 3217",
      "city": "Newark",
      "state": "DE",
      "postalCode": "19713",
      "country": "US"
    },
    "headline": "RADfertility",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(302) 602-8822",
    "bookingUrl": null,
    "location": {
      "latitude": 39.6856,
      "longitude": -75.6731
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 500,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 56.3,
      "between35And37": 61,
      "between38And40": 48.3
    },
    "medicaldirector": "Ronald F. Feinberg, MD, PHD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 64.3,
      "between35And37": 53.4,
      "between38And40": 29.6
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 51.1
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "4",
    "name": "Advanced Reproductive Specialists, Jacksonville Center for Reproductive Medicine",
    "address": {
      "id": "addr-4",
      "address1": "7051 Southpoint Pkwy, Suite 200",
      "city": "Jacksonville",
      "state": "FL",
      "postalCode": "32216",
      "country": "US"
    },
    "headline": "Advanced Reproductive Specialists, Jacksonville Center for Reproductive Medicine",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(904) 493-2229",
    "bookingUrl": null,
    "location": {
      "latitude": 30.2577,
      "longitude": -81.5907
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 203,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 53.6,
      "between35And37": 44.2,
      "between38And40": 50
    },
    "medicaldirector": "Michael D. Fox, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 53.4,
      "between35And37": 46.7,
      "between38And40": 32
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {},
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "190",
    "name": "Assisted Fertility Program",
    "address": {
      "id": "addr-190",
      "address1": "3627 University Blvd South, Suite 450",
      "city": "Jacksonville",
      "state": "FL",
      "postalCode": "32216",
      "country": "US"
    },
    "headline": "Assisted Fertility Program",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(904) 398-1473",
    "bookingUrl": null,
    "location": {
      "latitude": 30.2873,
      "longitude": -81.601
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 102,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 37.8,
      "between35And37": 24
    },
    "medicaldirector": "Marwan M. Shaykh, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 36.4
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {},
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "462",
    "name": "Boca Fertility",
    "address": {
      "id": "addr-462",
      "address1": "875 Meadows Rd, Suite 334",
      "city": "Boca Raton",
      "state": "FL",
      "postalCode": "33486",
      "country": "US"
    },
    "headline": "Boca Fertility",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(561) 368-5500",
    "bookingUrl": null,
    "location": {
      "latitude": 26.3596,
      "longitude": -80.1043
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 182,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 38.7,
      "between35And37": 45,
      "between38And40": 38.5
    },
    "medicaldirector": "Moshe (Maurice) R. Peress, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 35.2,
      "between35And37": 20.7,
      "between38And40": 26.7
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "frozenEmbryos": 40.5,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "329",
    "name": "Brown Fertility",
    "address": {
      "id": "addr-329",
      "address1": "14540 Old Saint Augustine Rd, Bldg 2, Suite 2497",
      "city": "Jacksonville",
      "state": "FL",
      "postalCode": "32258",
      "country": "US"
    },
    "headline": "Brown Fertility",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(877) 260-0352",
    "bookingUrl": null,
    "location": {
      "latitude": 30.1392,
      "longitude": -81.5354
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 513,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 37.7,
      "between35And37": 37,
      "between38And40": 16.9
    },
    "medicaldirector": "Samuel E. Brown, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 54,
      "between35And37": 49.4,
      "between38And40": 16.7
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 33.33333333333333,
      "freshEmbryosFrozenEggs": 42.4,
      "frozenEmbryos": 27.9,
      "donatedEmbryos": 35.9
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFreshEggs": 15
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "899",
    "name": "Center for Living Well, Gaea Center",
    "address": {
      "id": "addr-899",
      "address1": "1530 Celebration Blvd, Suite 200",
      "city": "Celebration",
      "state": "FL",
      "postalCode": "34747",
      "country": "US"
    },
    "headline": "Center for Living Well, Gaea Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(407) 934-4100",
    "bookingUrl": null,
    "location": {
      "latitude": 28.3099,
      "longitude": -81.5648
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 4,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "between35And37": 0,
      "between38And40": 0
    },
    "medicaldirector": "Nanette Rollene, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "between38And40": 0
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "109",
    "name": "Center for Reproductive Medicine, PA",
    "address": {
      "id": "addr-109",
      "address1": "1500 S. Orlando Ave, Suite 200",
      "city": "Winter Park",
      "state": "FL",
      "postalCode": "32789",
      "country": "US"
    },
    "headline": "Center for Reproductive Medicine, PA",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(407) 740-0909",
    "bookingUrl": null,
    "location": {
      "latitude": 28.5836,
      "longitude": -81.3646
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 596,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 49.4,
      "between35And37": 54,
      "between38And40": 42.6
    },
    "medicaldirector": "Randall A. Loy, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 47.1,
      "between35And37": 39.2,
      "between38And40": 12.1
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 35.7
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "450",
    "name": "Conceptions Florida: Center for Fertility and Genetics",
    "address": {
      "id": "addr-450",
      "address1": "4425 Ponce de Leon Blvd, Suite 110",
      "city": "Coral Gables",
      "state": "FL",
      "postalCode": "33146",
      "country": "US"
    },
    "headline": "Conceptions Florida: Center for Fertility and Genetics",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(305) 446-4673",
    "bookingUrl": null,
    "location": {
      "latitude": 25.7312,
      "longitude": -80.2577
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 231,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 55.6,
      "between35And37": 57.5,
      "between38And40": 40
    },
    "medicaldirector": "Armando E. Hernandez-Rey, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 52.2,
      "between35And37": 42.1,
      "between38And40": 21.4
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 55.3,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "216",
    "name": "F.I.R.S.T., Florida Institute for Reproductive Sciences and Technologies",
    "address": {
      "id": "addr-216",
      "address1": "2300 N. Commerce Pkwy, Suite 319",
      "city": "Weston",
      "state": "FL",
      "postalCode": "33326",
      "country": "US"
    },
    "headline": "F.I.R.S.T., Florida Institute for Reproductive Sciences and Technologies",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(954) 217-3456",
    "bookingUrl": null,
    "location": {
      "latitude": 26.092,
      "longitude": -80.3674
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 85,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "between35And37": 53.333333333333336
    },
    "medicaldirector": "Minna R. Selub, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between35And37": 15
    },
    "newPatientSuccessRates": {},
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 24
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "241",
    "name": "Fertility & IVF Center of Miami, Inc., Fertility Center of Miami",
    "address": {
      "id": "addr-241",
      "address1": "8950 N. Kendall Dr, Suite 103",
      "city": "Miami",
      "state": "FL",
      "postalCode": "33176",
      "country": "US"
    },
    "headline": "Fertility & IVF Center of Miami, Inc., Fertility Center of Miami",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(305) 596-4013",
    "bookingUrl": null,
    "location": {
      "latitude": 25.683,
      "longitude": -80.3407
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 358,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 54.7,
      "between35And37": 41.2,
      "between38And40": 43.8
    },
    "medicaldirector": "Fernando Akerman, MD",
    "clinicStatus": "Reorganized",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 65,
      "between35And37": 43.4,
      "between38And40": 30
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 42.1,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "149",
    "name": "Fertility Center & Applied Genetics of Florida",
    "address": {
      "id": "addr-149",
      "address1": "5100 Station Way",
      "city": "Sarasota",
      "state": "FL",
      "postalCode": "34233",
      "country": "US"
    },
    "headline": "Fertility Center & Applied Genetics of Florida",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(941) 342-1568",
    "bookingUrl": null,
    "location": {
      "latitude": 27.2724,
      "longitude": -82.4663
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 129,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 41.7,
      "between35And37": 55.55555555555556,
      "between38And40": 66.66666666666666
    },
    "medicaldirector": "Julio E. Pabon, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between35And37": 18,
      "between38And40": 12
    },
    "newPatientSuccessRates": {
      "under35": 29.2
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 53.84615384615385,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 13
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "624",
    "name": "Fertility Center of Orlando",
    "address": {
      "id": "addr-624",
      "address1": "1912 Boothe Circle, Suite 200",
      "city": "Longwood",
      "state": "FL",
      "postalCode": "32750",
      "country": "US"
    },
    "headline": "Fertility Center of Orlando",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(407) 345-9006",
    "bookingUrl": null,
    "location": {
      "latitude": 28.6361,
      "longitude": -81.3653
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 24,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 0,
      "between35And37": 0,
      "between38And40": 0
    },
    "medicaldirector": "Milton McNichol, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 0,
      "between35And37": 0,
      "between38And40": 0
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 38.1,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "383",
    "name": "Florida Fertility Institute",
    "address": {
      "id": "addr-383",
      "address1": "2454 N. McMullen Booth Rd, Suite 601",
      "city": "Clearwater",
      "state": "FL",
      "postalCode": "33759",
      "country": "US"
    },
    "headline": "Florida Fertility Institute",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(727) 669-3414",
    "bookingUrl": null,
    "location": {
      "latitude": 28.0104,
      "longitude": -82.7075
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 282,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 47.1,
      "between35And37": 37.2,
      "between38And40": 35.7
    },
    "medicaldirector": "Mark D. Sanchez, MD",
    "clinicStatus": "Reorganized",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 46.2,
      "between35And37": 19.1,
      "between38And40": 14.9
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 44.8
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "231",
    "name": "Florida Institute for Reproductive Medicine",
    "address": {
      "id": "addr-231",
      "address1": "836 Prudential Dr, Suite 902",
      "city": "Jacksonville",
      "state": "FL",
      "postalCode": "32207",
      "country": "US"
    },
    "headline": "Florida Institute for Reproductive Medicine",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(904) 399-5620",
    "bookingUrl": null,
    "location": {
      "latitude": 30.316,
      "longitude": -81.6628
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 555,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 40.4,
      "between35And37": 48.2,
      "between38And40": 30.8
    },
    "medicaldirector": "Kevin L. Winslow, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 38.7,
      "between35And37": 39.1,
      "between38And40": 18
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 40.9,
      "frozenEmbryos": 45,
      "donatedEmbryos": 32.1
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "192",
    "name": "IVF Florida Reproductive Associates",
    "address": {
      "id": "addr-192",
      "address1": "3251 N. State Rd 7, Suite 200",
      "city": "Margate",
      "state": "FL",
      "postalCode": "33063",
      "country": "US"
    },
    "headline": "IVF Florida Reproductive Associates",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(954) 247-6235",
    "bookingUrl": null,
    "location": {
      "latitude": 26.2642,
      "longitude": -80.2008
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 1123,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 50.9,
      "between35And37": 61.5,
      "between38And40": 45.3
    },
    "medicaldirector": "David I. Hoffman, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 42.5,
      "between35And37": 38.2,
      "between38And40": 21.6
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 30.6,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "45",
    "name": "IVFMD/South Florida Institute for Reproductive Medicine",
    "address": {
      "id": "addr-45",
      "address1": "7300 S.W. 62nd Pl, 4th Floor",
      "city": "South Miami",
      "state": "FL",
      "postalCode": "33143",
      "country": "US"
    },
    "headline": "IVFMD/South Florida Institute for Reproductive Medicine",
    "images": [],
    "tags": [],
    "services": [
      "Nutrition counseling",
      "Counseling",
      "Patient portal",
      "Support resources"
    ],
    "languages": ["en", "es", "fr", "de"],
    "clinicType": "Network & group",
    "conditions": [
      "PCOS",
      "Endometriosis",
      "Male Factor",
      "Uterine factor",
      "Oncofertility"
    ],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Embryo Freezing",
      "PGT",
      "Ovulation Induction",
      "Sperm Freezing",
      "Donor programs",
      "Surrogacy",
      "Fertility preservation",
      "Male factor"
    ],
    "website": "https://www.ivfmd.com",
    "email": null,
    "phone": "(305) 662-7901",
    "bookingUrl": "https://book.ivfmd.com/",
    "location": {
      "latitude": 25.7028,
      "longitude": -80.2952
    },
    "insurances": [],
    "insuranceAccepted": true,
    "insuranceName": null,
    "financiers": ["Loans", "Package pricing", "Discount pricing", "CapexMD"],
    "consultationTypes": ["In person", "Telehealth"],
    "patientGroups": ["LGBTQIA+"],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 1274,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": "Premier South Florida fertility network with six locations, over 10,000 families created since 1991, part of the Prelude Network.",
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 54.5,
      "between35And37": 48.6,
      "between38And40": 46.6
    },
    "medicaldirector": "Juergen Eisermann, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 48.1,
      "between35And37": 35.7,
      "between38And40": 18.9
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 33.8,
      "frozenEmbryos": 37
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "55",
    "name": "New Leaders in Fertility & Endocrinology, LLC",
    "address": {
      "id": "addr-55",
      "address1": "4400 Bayou Blvd, Suite 36",
      "city": "Pensacola",
      "state": "FL",
      "postalCode": "32503",
      "country": "US"
    },
    "headline": "New Leaders in Fertility & Endocrinology, LLC",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(850) 857-0033",
    "bookingUrl": null,
    "location": {
      "latitude": 30.4674,
      "longitude": -87.204
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 201,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 41.5,
      "between35And37": 42.2,
      "between38And40": 28.6
    },
    "medicaldirector": "Barry A. Ripps, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 57.1,
      "between35And37": 37,
      "between38And40": 30
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "257",
    "name": "Polcz Fertility Center",
    "address": {
      "id": "addr-257",
      "address1": "9868 S. State Rd 7, Suite 320",
      "city": "Boynton Beach",
      "state": "FL",
      "postalCode": "33472",
      "country": "US"
    },
    "headline": "Polcz Fertility Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(561) 736-6006",
    "bookingUrl": null,
    "location": {
      "latitude": 26.541,
      "longitude": -80.1987
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 20,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {},
    "medicaldirector": "Tibor E. Polcz, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {},
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "815",
    "name": "Reproductive Medicine Associates of Florida, LLC",
    "address": {
      "id": "addr-815",
      "address1": "400 Colonial Center Pkwy, Suite 150",
      "city": "Lake Mary",
      "state": "FL",
      "postalCode": "32746",
      "country": "US"
    },
    "headline": "Reproductive Medicine Associates of Florida, LLC",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(407) 804-9670",
    "bookingUrl": null,
    "location": {
      "latitude": 28.7911,
      "longitude": -81.3532
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 174,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 66.2,
      "between35And37": 67.6,
      "between38And40": 41.7
    },
    "medicaldirector": "George Patounakis, MD, PHD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 66.7,
      "between35And37": 59.4,
      "between38And40": 20
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 26.31578947368421,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 19
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "823",
    "name": "Shady Grove Fertility Tampa Bay",
    "address": {
      "id": "addr-823",
      "address1": "5016 W. Cypress St, Suite 302",
      "city": "Tampa",
      "state": "FL",
      "postalCode": "33607",
      "country": "US"
    },
    "headline": "Shady Grove Fertility Tampa Bay",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(813) 906-2285",
    "bookingUrl": null,
    "location": {
      "latitude": 27.9518,
      "longitude": -82.5295
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 600,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 48.1,
      "between35And37": 45.7,
      "between38And40": 44.2
    },
    "medicaldirector": "Shayne Plosker, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 60.6,
      "between35And37": 37.3,
      "between38And40": 28.6
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "frozenEmbryos": 48.7,
      "donatedEmbryos": 50
    },
    "donorSuccessRateDenominators": {
      "donatedEmbryos": 18
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "284",
    "name": "Southwest Florida Fertility Center, PA",
    "address": {
      "id": "addr-284",
      "address1": "15730 New Hampshire Ct, Suite 101",
      "city": "Fort Myers",
      "state": "FL",
      "postalCode": "33908",
      "country": "US"
    },
    "headline": "Southwest Florida Fertility Center, PA",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(239) 561-3430",
    "bookingUrl": null,
    "location": {
      "latitude": 26.5151,
      "longitude": -81.8972
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 82,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 65.2,
      "between35And37": 58.333333333333336
    },
    "medicaldirector": "Jacob L. Glock, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between35And37": 12
    },
    "newPatientSuccessRates": {
      "under35": 48.1,
      "between35And37": 36.84210526315789
    },
    "newPatientSuccessRateDenominators": {
      "between35And37": 19
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "87",
    "name": "Specialists in Reproductive Medicine & Surgery, PA, Embryo Donation International, PL",
    "address": {
      "id": "addr-87",
      "address1": "12611 World Plaza Ln, Bldg 53",
      "city": "Fort Myers",
      "state": "FL",
      "postalCode": "33907",
      "country": "US"
    },
    "headline": "Specialists in Reproductive Medicine & Surgery, PA, Embryo Donation International, PL",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(239) 275-8118",
    "bookingUrl": null,
    "location": {
      "latitude": 26.5597,
      "longitude": -81.8778
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 59,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 29
    },
    "medicaldirector": "Craig R. Sweet, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 29.2
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "295",
    "name": "The IVF Center",
    "address": {
      "id": "addr-295",
      "address1": "5901 Brick Ct",
      "city": "Winter Park",
      "state": "FL",
      "postalCode": "32792",
      "country": "US"
    },
    "headline": "The IVF Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(407) 672-1106",
    "bookingUrl": null,
    "location": {
      "latitude": 28.6119,
      "longitude": -81.2757
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 198,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 28.3,
      "between35And37": 37.8,
      "between38And40": 26.7
    },
    "medicaldirector": "Mark P. Trolice, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 43.6,
      "between35And37": 50,
      "between38And40": 28.6
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 0
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 5
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "267",
    "name": "The Reproductive Medicine Group",
    "address": {
      "id": "addr-267",
      "address1": "5245 E. Fletcher Ave, Suite 1",
      "city": "Tampa",
      "state": "FL",
      "postalCode": "33617",
      "country": "US"
    },
    "headline": "The Reproductive Medicine Group",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(813) 676-8844",
    "bookingUrl": null,
    "location": {
      "latitude": 28.0686,
      "longitude": -82.3963
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 546,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 49.5,
      "between35And37": 49,
      "between38And40": 38.6
    },
    "medicaldirector": "Timothy R. Yeko, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 50.6,
      "between35And37": 39.6,
      "between38And40": 27.3
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "frozenEmbryos": 55,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "434",
    "name": "UF Health Reproductive Medicine at Springhill",
    "address": {
      "id": "addr-434",
      "address1": "4037 N.W. 86th Terrace, 1st Floor",
      "city": "Gainesville",
      "state": "FL",
      "postalCode": "32606",
      "country": "US"
    },
    "headline": "UF Health Reproductive Medicine at Springhill",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(352) 265-2229",
    "bookingUrl": null,
    "location": {
      "latitude": 29.6903,
      "longitude": -82.4338
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 68,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 22.6,
      "between35And37": 31.25,
      "between38And40": 29.411764705882355
    },
    "medicaldirector": "Alice S. Rhoton-Vlasak, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between35And37": 16,
      "between38And40": 17
    },
    "newPatientSuccessRates": {
      "under35": 30.4,
      "between38And40": 0
    },
    "newPatientSuccessRateDenominators": {
      "between38And40": 6
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "215",
    "name": "University of Miami Infertility Center",
    "address": {
      "id": "addr-215",
      "address1": "1400 N.W. 12th Ave, Suite 5",
      "city": "Miami",
      "state": "FL",
      "postalCode": "33136",
      "country": "US"
    },
    "headline": "University of Miami Infertility Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(305) 243-1622",
    "bookingUrl": null,
    "location": {
      "latitude": 25.7887,
      "longitude": -80.2158
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 193,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 47.1,
      "between35And37": 44,
      "between38And40": 26.5
    },
    "medicaldirector": "George R. Attia, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 52.5,
      "between35And37": 50,
      "between38And40": 30.6
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 54.5,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "21",
    "name": "Viera Fertility Center",
    "address": {
      "id": "addr-21",
      "address1": "3160 Alzante Cir",
      "city": "Melbourne",
      "state": "FL",
      "postalCode": "32940",
      "country": "US"
    },
    "headline": "Viera Fertility Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(321) 751-4673",
    "bookingUrl": null,
    "location": {
      "latitude": 28.2091,
      "longitude": -80.6735
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 75,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 34.1,
      "between35And37": 46.666666666666664
    },
    "medicaldirector": "Diran J. Chamoun, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between35And37": 15
    },
    "newPatientSuccessRates": {
      "under35": 38.5,
      "between35And37": 55.55555555555556
    },
    "newPatientSuccessRateDenominators": {
      "between35And37": 9
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "94",
    "name": "Atlanta Center for Reproductive Medicine",
    "address": {
      "id": "addr-94",
      "address1": "5909 Peachtree Dunwoody Rd, Suite 600",
      "city": "Atlanta",
      "state": "GA",
      "postalCode": "30328",
      "country": "US"
    },
    "headline": "Atlanta Center for Reproductive Medicine",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(770) 928-2276",
    "bookingUrl": null,
    "location": {
      "latitude": 33.9171,
      "longitude": -84.3495
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 1046,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 66.9,
      "between35And37": 61.6,
      "between38And40": 61
    },
    "medicaldirector": "Kathryn C. Calhoun, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 67,
      "between35And37": 47.3,
      "between38And40": 37.3
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 54.3,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "118",
    "name": "Columbus Center for Reproductive Endocrinology & Infertility, LLC",
    "address": {
      "id": "addr-118",
      "address1": "2323 Whittlesey Rd",
      "city": "Columbus",
      "state": "GA",
      "postalCode": "31909",
      "country": "US"
    },
    "headline": "Columbus Center for Reproductive Endocrinology & Infertility, LLC",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(706) 653-6344",
    "bookingUrl": null,
    "location": {
      "latitude": 32.5408,
      "longitude": -84.959
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 89,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 37.7,
      "between35And37": 33.33333333333333
    },
    "medicaldirector": "Prakash J. Thiruppathi, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between35And37": 15
    },
    "newPatientSuccessRates": {
      "under35": 38.3
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "511",
    "name": "Emory Reproductive Center",
    "address": {
      "id": "addr-511",
      "address1": "550 Peachtree St N.E., Suite 1800",
      "city": "Atlanta",
      "state": "GA",
      "postalCode": "30308",
      "country": "US"
    },
    "headline": "Emory Reproductive Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(404) 778-3401",
    "bookingUrl": null,
    "location": {
      "latitude": 33.7848,
      "longitude": -84.382
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 570,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 54.5,
      "between35And37": 51.3,
      "between38And40": 46
    },
    "medicaldirector": "Jennifer F. Kawwass, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 57.4,
      "between35And37": 40.9,
      "between38And40": 23.1
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 61.9,
      "frozenEmbryos": 39.3
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "865",
    "name": "Hope Fertility",
    "address": {
      "id": "addr-865",
      "address1": "3005 Royal Boulevard South, Suite 220",
      "city": "Alpharetta",
      "state": "GA",
      "postalCode": "30022",
      "country": "US"
    },
    "headline": "Hope Fertility",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(404) 410-5055",
    "bookingUrl": null,
    "location": {
      "latitude": 34.0542,
      "longitude": -84.2725
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 135,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 54.2,
      "between35And37": 54.2,
      "between38And40": 35.714285714285715
    },
    "medicaldirector": "Obehi A. Asemota, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between38And40": 14
    },
    "newPatientSuccessRates": {
      "under35": 56.4,
      "between35And37": 57.89473684210527
    },
    "newPatientSuccessRateDenominators": {
      "between35And37": 19
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "878",
    "name": "Kindbody Atlanta",
    "address": {
      "id": "addr-878",
      "address1": "3005 Peachtree Rd N.E., Suite 100",
      "city": "Atlanta",
      "state": "GA",
      "postalCode": "30305",
      "country": "US"
    },
    "headline": "Kindbody Atlanta",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(470) 765-6347",
    "bookingUrl": null,
    "location": {
      "latitude": 33.8367,
      "longitude": -84.3811
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 25,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {},
    "medicaldirector": "Kristen Cain, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {},
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "837",
    "name": "Massey Fertility Services",
    "address": {
      "id": "addr-837",
      "address1": "371 E. Paces Ferry Rd, Suite 400",
      "city": "Atlanta",
      "state": "GA",
      "postalCode": "30305",
      "country": "US"
    },
    "headline": "Massey Fertility Services",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(404) 228-7199",
    "bookingUrl": null,
    "location": {
      "latitude": 33.749,
      "longitude": -84.388
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 208,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 38.3,
      "between35And37": 43.5,
      "between38And40": 43.75
    },
    "medicaldirector": "Nestor E. Dourron, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between38And40": 16
    },
    "newPatientSuccessRates": {
      "under35": 23.5,
      "between35And37": 26.9,
      "between38And40": 18.5
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 38.88888888888889
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 18
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "196",
    "name": "Reproductive Biology Associates",
    "address": {
      "id": "addr-196",
      "address1": "1100 Johnson Ferry Rd N.E., Suite 200",
      "city": "Atlanta",
      "state": "GA",
      "postalCode": "30342",
      "country": "US"
    },
    "headline": "Reproductive Biology Associates",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(404) 257-1900",
    "bookingUrl": null,
    "location": {
      "latitude": 33.907,
      "longitude": -84.3495
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 1022,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 55.5,
      "between35And37": 56.4,
      "between38And40": 37.8
    },
    "medicaldirector": "Daniel B. Shapiro, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 56.3,
      "between35And37": 43,
      "between38And40": 22.7
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 46
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "286",
    "name": "Reproductive Medicine and Infertility Associates",
    "address": {
      "id": "addr-286",
      "address1": "810 Chafee Ave",
      "city": "Augusta",
      "state": "GA",
      "postalCode": "30904",
      "country": "US"
    },
    "headline": "Reproductive Medicine and Infertility Associates",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(706) 722-4434",
    "bookingUrl": null,
    "location": {
      "latitude": 33.4747,
      "longitude": -81.9903
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 97,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 51.8,
      "between35And37": 75
    },
    "medicaldirector": "Larisa Gavrilova-Jordan, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between35And37": 16
    },
    "newPatientSuccessRates": {
      "under35": 65.7,
      "between35And37": 75
    },
    "newPatientSuccessRateDenominators": {
      "between35And37": 12
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "394",
    "name": "Shady Grove Fertility-Atlanta",
    "address": {
      "id": "addr-394",
      "address1": "1100 Lake Hearn Dr, Suite 400",
      "city": "Atlanta",
      "state": "GA",
      "postalCode": "30342",
      "country": "US"
    },
    "headline": "Shady Grove Fertility-Atlanta",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(404) 843-2229",
    "bookingUrl": null,
    "location": {
      "latitude": 33.9036,
      "longitude": -84.354
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 650,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 39.7,
      "between35And37": 28.1,
      "between38And40": 39
    },
    "medicaldirector": "Desireé McCarthy-Keith, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 54.3,
      "between35And37": 30,
      "between38And40": 30.7
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 50,
      "frozenEmbryos": 29.3,
      "donatedEmbryos": 27.3
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFrozenEggs": 10
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "144",
    "name": "The Georgia Center for Reproductive Medicine",
    "address": {
      "id": "addr-144",
      "address1": "5354 Reynolds St, Suite 510",
      "city": "Savannah",
      "state": "GA",
      "postalCode": "31405",
      "country": "US"
    },
    "headline": "The Georgia Center for Reproductive Medicine",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(912) 352-8588",
    "bookingUrl": null,
    "location": {
      "latitude": 32.0276,
      "longitude": -81.0996
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 178,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 66.7,
      "between35And37": 35,
      "between38And40": 45.9
    },
    "medicaldirector": "Patrick L. Blohm, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 76.1,
      "between35And37": 40.9,
      "between38And40": 41.7
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "277",
    "name": "Advanced Reproductive Center of Hawaii",
    "address": {
      "id": "addr-277",
      "address1": "1319 Punahou St, Suite 1180",
      "city": "Honolulu",
      "state": "HI",
      "postalCode": "96826",
      "country": "US"
    },
    "headline": "Advanced Reproductive Center of Hawaii",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(808) 949-6611",
    "bookingUrl": null,
    "location": {
      "latitude": 21.2999,
      "longitude": -157.834
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 98,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 69.7,
      "between35And37": 76.92307692307693,
      "between38And40": 50
    },
    "medicaldirector": "Christopher T. Huang, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between35And37": 13,
      "between38And40": 12
    },
    "newPatientSuccessRates": {
      "under35": 73.1,
      "between35And37": 50
    },
    "newPatientSuccessRateDenominators": {
      "between35And37": 18
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 100,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 6
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "219",
    "name": "Fertility Institute of Hawaii",
    "address": {
      "id": "addr-219",
      "address1": "1401 S. Beretania St, Suite 250",
      "city": "Honolulu",
      "state": "HI",
      "postalCode": "96814",
      "country": "US"
    },
    "headline": "Fertility Institute of Hawaii",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(808) 545-2800",
    "bookingUrl": null,
    "location": {
      "latitude": 21.2996,
      "longitude": -157.839
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 337,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 61.1,
      "between35And37": 63.8,
      "between38And40": 43.8
    },
    "medicaldirector": "John L. Frattarelli, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 60.4,
      "between35And37": 44.1,
      "between38And40": 29.1
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 50.8,
      "donatedEmbryos": 44.44444444444444
    },
    "donorSuccessRateDenominators": {
      "donatedEmbryos": 18
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "23",
    "name": "IVF Hawaii",
    "address": {
      "id": "addr-23",
      "address1": "1329 Lusitana St, Suite 607",
      "city": "Honolulu",
      "state": "HI",
      "postalCode": "96813",
      "country": "US"
    },
    "headline": "IVF Hawaii",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(808) 538-6655",
    "bookingUrl": null,
    "location": {
      "latitude": 21.3076,
      "longitude": -157.852
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 74,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 57.89473684210527,
      "between35And37": 28.6
    },
    "medicaldirector": "Benton H. Chun, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "under35": 19
    },
    "newPatientSuccessRates": {
      "under35": 52.63157894736842
    },
    "newPatientSuccessRateDenominators": {
      "under35": 19
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 38.46153846153847,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 13
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "115",
    "name": "Pacific In Vitro Fertilization Institute",
    "address": {
      "id": "addr-115",
      "address1": "Kapi`olani Medical Center, 1319 Punahou St, Suite 980",
      "city": "Honolulu",
      "state": "HI",
      "postalCode": "96826",
      "country": "US"
    },
    "headline": "Pacific In Vitro Fertilization Institute",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(808) 946-2226",
    "bookingUrl": null,
    "location": {
      "latitude": 21.2998,
      "longitude": -157.833
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 181,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 39.5,
      "between35And37": 37.8,
      "between38And40": 22.9
    },
    "medicaldirector": "Thomas S. Kosasa, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 40,
      "between35And37": 35.5,
      "between38And40": 16.7
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 70,
      "frozenEmbryos": 27.8
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFreshEggs": 10
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "474",
    "name": "Tripler Army Medical Center IVF Institute",
    "address": {
      "id": "addr-474",
      "address1": "Department of Obstetrics and Gynecology, 1 Jarrett White Rd",
      "city": "Tripler Amc",
      "state": "HI",
      "postalCode": "96859",
      "country": "US"
    },
    "headline": "Tripler Army Medical Center IVF Institute",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(808) 433-5925",
    "bookingUrl": null,
    "location": {
      "latitude": 21.3596,
      "longitude": -157.89
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 115,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 31.6,
      "between35And37": 30,
      "between38And40": 0
    },
    "medicaldirector": "Gary Levy, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between38And40": 16
    },
    "newPatientSuccessRates": {
      "under35": 38.5,
      "between35And37": 33.33333333333333,
      "between38And40": 0
    },
    "newPatientSuccessRateDenominators": {
      "between35And37": 18,
      "between38And40": 17
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "37",
    "name": "Mid-Iowa Fertility, PC",
    "address": {
      "id": "addr-37",
      "address1": "1371 N.W. 121st St",
      "city": "Clive",
      "state": "IA",
      "postalCode": "50325",
      "country": "US"
    },
    "headline": "Mid-Iowa Fertility, PC",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(515) 222-3060",
    "bookingUrl": null,
    "location": {
      "latitude": 41.6024,
      "longitude": -93.784
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 554,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 47.7,
      "between35And37": 36.4,
      "between38And40": 44.8
    },
    "medicaldirector": "Donald C. Young, DO",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 41.2,
      "between35And37": 28.1,
      "between38And40": 20.7
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 42.857142857142854,
      "frozenEmbryos": 57.1,
      "donatedEmbryos": 40.7
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFrozenEggs": 14
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "255",
    "name": "University of Iowa Hospitals and Clinics, Center for Advanced Reproductive Care",
    "address": {
      "id": "addr-255",
      "address1": "Department of Obstetrics and Gynecology, 1360 N. Dodge St, Suite 2000",
      "city": "Iowa City",
      "state": "IA",
      "postalCode": "52245",
      "country": "US"
    },
    "headline": "University of Iowa Hospitals and Clinics, Center for Advanced Reproductive Care",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(319) 356-8483",
    "bookingUrl": null,
    "location": {
      "latitude": 41.6778,
      "longitude": -91.5162
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 650,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 47.6,
      "between35And37": 50.4,
      "between38And40": 41
    },
    "medicaldirector": "Rachel B. Mejia, DO",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 63.6,
      "between35And37": 64.5,
      "between38And40": 46.2
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 40,
      "frozenEmbryos": 51.9,
      "donatedEmbryos": 51.6
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "35",
    "name": "Idaho Center for Reproductive Medicine",
    "address": {
      "id": "addr-35",
      "address1": "1000 E. Park Blvd, Suite 110",
      "city": "Boise",
      "state": "ID",
      "postalCode": "83712",
      "country": "US"
    },
    "headline": "Idaho Center for Reproductive Medicine",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(208) 342-5900",
    "bookingUrl": null,
    "location": {
      "latitude": 43.6032,
      "longitude": -116.188
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 340,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 64.6,
      "between35And37": 49.3,
      "between38And40": 50
    },
    "medicaldirector": "Cristin C. Slater, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 66.4,
      "between35And37": 47.3,
      "between38And40": 12.1
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "frozenEmbryos": 66.5,
      "donatedEmbryos": 53.7
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "300",
    "name": "Advanced Fertility Center of Chicago",
    "address": {
      "id": "addr-300",
      "address1": "30 Tower Ct, Suite F",
      "city": "Gurnee",
      "state": "IL",
      "postalCode": "60031",
      "country": "US"
    },
    "headline": "Advanced Fertility Center of Chicago",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(847) 662-1818",
    "bookingUrl": null,
    "location": {
      "latitude": 42.3574,
      "longitude": -87.8993
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 848,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 53.4,
      "between35And37": 45.2,
      "between38And40": 46.7
    },
    "medicaldirector": "Michelle Catenacci, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 66.5,
      "between35And37": 54.9,
      "between38And40": 37.4
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 66.66666666666666,
      "freshEmbryosFrozenEggs": 51.2,
      "frozenEmbryos": 52.5,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFreshEggs": 15
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "100",
    "name": "Chicago Infertility Associates, LTD",
    "address": {
      "id": "addr-100",
      "address1": "396 Remington Blvd, Suite 250",
      "city": "Bolingbrook",
      "state": "IL",
      "postalCode": "60440",
      "country": "US"
    },
    "headline": "Chicago Infertility Associates, LTD",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(630) 759-2966",
    "bookingUrl": null,
    "location": {
      "latitude": 42.0047,
      "longitude": -88.0164
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 16,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {},
    "medicaldirector": "Ketan N. Jobanputra, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {},
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "323",
    "name": "Chicago IVF",
    "address": {
      "id": "addr-323",
      "address1": "5225 Old Orchard Rd, Suite 21",
      "city": "Skokie",
      "state": "IL",
      "postalCode": "60077",
      "country": "US"
    },
    "headline": "Chicago IVF",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(847) 213-5064",
    "bookingUrl": null,
    "location": {
      "latitude": 42.0619,
      "longitude": -87.7584
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 389,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 32.3,
      "between35And37": 41.7,
      "between38And40": 30.6
    },
    "medicaldirector": "Joel G. Brasch, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 34,
      "between35And37": 36.4,
      "between38And40": 27.1
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 75,
      "frozenEmbryos": 43.8
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFreshEggs": 8
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "444",
    "name": "Daniel Rostein, MD, SC",
    "address": {
      "id": "addr-444",
      "address1": "2208 Midwest Rd, Suite 102",
      "city": "Oak Brook",
      "state": "IL",
      "postalCode": "60523",
      "country": "US"
    },
    "headline": "Daniel Rostein, MD, SC",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(630) 472-9100",
    "bookingUrl": null,
    "location": {
      "latitude": 41.8452,
      "longitude": -87.9729
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 20,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "between38And40": 0
    },
    "medicaldirector": "Daniel A. Rostein, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "between35And37": 0,
      "between38And40": 0
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "518",
    "name": "Davies Fertility & IVF Specialists, SC",
    "address": {
      "id": "addr-518",
      "address1": "2640 Patriot Blvd, Suite 260",
      "city": "Glenview",
      "state": "IL",
      "postalCode": "60026",
      "country": "US"
    },
    "headline": "Davies Fertility & IVF Specialists, SC",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(847) 972-0300",
    "bookingUrl": null,
    "location": {
      "latitude": 42.1029,
      "longitude": -87.8242
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 292,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 57.1,
      "between35And37": 65.7,
      "between38And40": 52
    },
    "medicaldirector": "Susan A. Davies, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 53.7,
      "between35And37": 35.7,
      "between38And40": 16.7
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 69.23076923076923,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 13
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "63",
    "name": "Fertility Centers of Illinois-Highland Park IVF Center",
    "address": {
      "id": "addr-63",
      "address1": "767 Park Ave West, Suite B400",
      "city": "Highland Park",
      "state": "IL",
      "postalCode": "60035",
      "country": "US"
    },
    "headline": "Fertility Centers of Illinois-Highland Park IVF Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(847) 266-3535",
    "bookingUrl": null,
    "location": {
      "latitude": 42.1897,
      "longitude": -87.8081
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 619,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 55.2,
      "between35And37": 51.7,
      "between38And40": 37.3
    },
    "medicaldirector": "Brian R. Kaplan, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 57.4,
      "between35And37": 42.9,
      "between38And40": 16.3
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 48.6
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "275",
    "name": "Fertility Centers of Illinois-River North IVF",
    "address": {
      "id": "addr-275",
      "address1": "900 N. Kingsbury St, River Walk 6",
      "city": "Chicago",
      "state": "IL",
      "postalCode": "60610",
      "country": "US"
    },
    "headline": "Fertility Centers of Illinois-River North IVF",
    "images": [],
    "tags": [],
    "services": [
      "Acupuncture",
      "Mind/Body",
      "Counseling",
      "Support resources",
      "Patient portal"
    ],
    "languages": ["en"],
    "clinicType": "Network & group",
    "conditions": [
      "PCOS",
      "Endometriosis",
      "Male Factor",
      "Unexplained infertility",
      "Recurrent pregnancy loss"
    ],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "PGT",
      "Donor programs",
      "Surrogacy",
      "Fertility preservation"
    ],
    "website": "https://www.fcionline.com",
    "email": null,
    "phone": "(312) 222-8230",
    "bookingUrl": "https://www.fcionline.com/appointment/",
    "location": {
      "latitude": 41.899,
      "longitude": -87.6444
    },
    "insurances": [],
    "insuranceAccepted": true,
    "insuranceName": null,
    "financiers": [
      "Payment plans",
      "Discount pricing",
      "CapexMD",
      "Future Family"
    ],
    "consultationTypes": ["In person", "Telehealth"],
    "patientGroups": ["LGBTQIA+"],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 1904,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": "One of the leading US Fertility Network practices, providing advanced reproductive care in Chicago since 1976 with over 42,000 babies born.",
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 50.7,
      "between35And37": 43.7,
      "between38And40": 46.8
    },
    "medicaldirector": "Jennifer E. Hirshfeld-Cytron, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 54.8,
      "between35And37": 42.1,
      "between38And40": 25.4
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 50,
      "freshEmbryosFrozenEggs": 68.2,
      "frozenEmbryos": 46.7,
      "donatedEmbryos": 35.714285714285715
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFreshEggs": 10,
      "donatedEmbryos": 14
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "1",
    "name": "Institute for Human Reproduction (IHR)",
    "address": {
      "id": "addr-1",
      "address1": "680 N. Lake Shore Dr, Suite 117",
      "city": "Chicago",
      "state": "IL",
      "postalCode": "60611",
      "country": "US"
    },
    "headline": "Institute for Human Reproduction (IHR)",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(312) 288-6420",
    "bookingUrl": null,
    "location": {
      "latitude": 41.8945,
      "longitude": -87.639
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 634,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 56.1,
      "between35And37": 50.8,
      "between38And40": 31.4
    },
    "medicaldirector": "David P. Cohen, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 40.9,
      "between35And37": 29.3,
      "between38And40": 13
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 53.8
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "425",
    "name": "InVia Fertility Specialists",
    "address": {
      "id": "addr-425",
      "address1": "1585 N. Barrington Rd, Bldg 2, Suite 406",
      "city": "Hoffman Estates",
      "state": "IL",
      "postalCode": "60169",
      "country": "US"
    },
    "headline": "InVia Fertility Specialists",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(847) 884-8884",
    "bookingUrl": null,
    "location": {
      "latitude": 42.0542,
      "longitude": -88.1412
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 551,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 52.6,
      "between35And37": 44.8,
      "between38And40": 34.1
    },
    "medicaldirector": "Vishvanath C. Karande, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 60.6,
      "between35And37": 46.5,
      "between38And40": 21.7
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 54.3,
      "donatedEmbryos": 54.54545454545454
    },
    "donorSuccessRateDenominators": {
      "donatedEmbryos": 11
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "17",
    "name": "IVF1",
    "address": {
      "id": "addr-17",
      "address1": "3 N. Washington St",
      "city": "Naperville",
      "state": "IL",
      "postalCode": "60540",
      "country": "US"
    },
    "headline": "IVF1",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(630) 357-6540",
    "bookingUrl": null,
    "location": {
      "latitude": 41.7754,
      "longitude": -88.148
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 459,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 50.5,
      "between35And37": 49.3,
      "between38And40": 43.9
    },
    "medicaldirector": "Randy S. Morris, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 67,
      "between35And37": 43.8,
      "between38And40": 24
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 47.1,
      "donatedEmbryos": 50
    },
    "donorSuccessRateDenominators": {
      "donatedEmbryos": 16
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "807",
    "name": "Kindbody-Chicago West Loop",
    "address": {
      "id": "addr-807",
      "address1": "333 S. Desplaines St, Suite 201",
      "city": "Chicago",
      "state": "IL",
      "postalCode": "60661",
      "country": "US"
    },
    "headline": "Kindbody-Chicago West Loop",
    "images": [],
    "tags": [],
    "services": [
      "Acupuncture",
      "Counseling",
      "Nutrition counseling",
      "Wellness program",
      "Patient portal"
    ],
    "languages": ["en", "es"],
    "clinicType": "Network & group",
    "conditions": [
      "PCOS",
      "Endometriosis",
      "Diminished ovarian reserve",
      "Male Factor",
      "Ovulatory dysfunction"
    ],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Embryo Freezing",
      "PGT",
      "Sperm Freezing",
      "Donor programs",
      "Surrogacy",
      "Fertility preservation"
    ],
    "website": "https://kindbody.com/location/west-loop-chicago/",
    "email": "navigator@kindbody.com",
    "phone": "(773) 435-9036",
    "bookingUrl": "https://kindbody.com/scheduling/location-select/fertility/",
    "location": {
      "latitude": 41.877,
      "longitude": -87.6436
    },
    "insurances": [],
    "insuranceAccepted": true,
    "insuranceName": null,
    "financiers": ["Payment plans", "Future Family", "PatientFi"],
    "consultationTypes": ["In person", "Telehealth"],
    "patientGroups": ["LGBTQIA+", "Single Parents", "Same sex couples"],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 1508,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": "Part of Kindbody's 31-clinic national network offering full-spectrum reproductive care with a whole-person approach from fertility through menopause.",
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 59.7,
      "between35And37": 51.8,
      "between38And40": 35.8
    },
    "medicaldirector": "Angeline Beltsos, MD",
    "clinicStatus": "Reorganized",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 44.7,
      "between35And37": 26.8,
      "between38And40": 12.1
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 53.84615384615385,
      "frozenEmbryos": 60
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFrozenEggs": 13
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "261",
    "name": "Kindbody-Crest Hill",
    "address": {
      "id": "addr-261",
      "address1": "2246 Weber Rd",
      "city": "Crest Hill",
      "state": "IL",
      "postalCode": "60403",
      "country": "US"
    },
    "headline": "Kindbody-Crest Hill",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(815) 725-4161",
    "bookingUrl": null,
    "location": {
      "latitude": 41.5628,
      "longitude": -88.1206
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 102,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 39.1
    },
    "medicaldirector": "Angie Beltsos, MD",
    "clinicStatus": "Reorganized",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 40.7,
      "between35And37": 0
    },
    "newPatientSuccessRateDenominators": {
      "between35And37": 5
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "391",
    "name": "Midwest Fertility Center",
    "address": {
      "id": "addr-391",
      "address1": "4333 Main St",
      "city": "Downers Grove",
      "state": "IL",
      "postalCode": "60515",
      "country": "US"
    },
    "headline": "Midwest Fertility Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(630) 810-0212",
    "bookingUrl": null,
    "location": {
      "latitude": 41.8082,
      "longitude": -88.0108
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 105,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 23.8,
      "between35And37": 28.6
    },
    "medicaldirector": "Amos E. Madanes, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 16.3
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "520",
    "name": "North Shore Fertility",
    "address": {
      "id": "addr-520",
      "address1": "5225 Old Orchard Rd, Suite 17",
      "city": "Skokie",
      "state": "IL",
      "postalCode": "60077",
      "country": "US"
    },
    "headline": "North Shore Fertility",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(847) 763-8850",
    "bookingUrl": null,
    "location": {
      "latitude": 42.041,
      "longitude": -87.7349
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 104,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 39,
      "between35And37": 35.294117647058826,
      "between38And40": 41.66666666666667
    },
    "medicaldirector": "Anne Borkowski, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between35And37": 17,
      "between38And40": 12
    },
    "newPatientSuccessRates": {
      "under35": 46.4
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "390",
    "name": "Northwestern Fertility and Reproductive Medicine",
    "address": {
      "id": "addr-390",
      "address1": "259 E. Erie St, Suite 2400",
      "city": "Chicago",
      "state": "IL",
      "postalCode": "60611",
      "country": "US"
    },
    "headline": "Northwestern Fertility and Reproductive Medicine",
    "images": [],
    "tags": [],
    "services": ["Counseling", "Support resources", "Patient portal"],
    "languages": ["en"],
    "clinicType": "Hospital-based",
    "conditions": ["PCOS", "Endometriosis", "Oncofertility"],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Embryo Freezing",
      "PGT",
      "Sperm Freezing",
      "Donor programs",
      "Fertility preservation"
    ],
    "website": "https://fertility.nm.org",
    "email": null,
    "phone": "(312) 695-1364",
    "bookingUrl": "https://fertility.nm.org/locations-and-appointments.html",
    "location": {
      "latitude": 41.8939,
      "longitude": -87.6208
    },
    "insurances": [],
    "insuranceAccepted": true,
    "insuranceName": null,
    "financiers": ["Payment plans"],
    "consultationTypes": ["In person"],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 1587,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": "Part of the #1 hospital in Illinois, with a pioneering oncofertility program and comprehensive fertility preservation services led by the Oncofertility Consortium.",
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 49.2,
      "between35And37": 50.6,
      "between38And40": 42.6
    },
    "medicaldirector": "Mary Ellen Pavone, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 48.5,
      "between35And37": 38.3,
      "between38And40": 19.7
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 40.9,
      "frozenEmbryos": 46.8
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "14",
    "name": "Reproductive Medicine Institute",
    "address": {
      "id": "addr-14",
      "address1": "2425 W. 22nd St, Suite 102",
      "city": "Oak Brook",
      "state": "IL",
      "postalCode": "60523",
      "country": "US"
    },
    "headline": "Reproductive Medicine Institute",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(630) 954-0094",
    "bookingUrl": null,
    "location": {
      "latitude": 41.8454,
      "longitude": -87.9783
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 754,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 36.5,
      "between35And37": 34.1,
      "between38And40": 27.8
    },
    "medicaldirector": "Elena Trukhacheva, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 44.6,
      "between35And37": 33.3,
      "between38And40": 13.5
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 50,
      "frozenEmbryos": 47.368421052631575
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFrozenEggs": 14,
      "frozenEmbryos": 19
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "848",
    "name": "RUSH Center for Advanced Reproductive Care",
    "address": {
      "id": "addr-848",
      "address1": "Professional Building I, 1725 West Harrison St, Suite 217",
      "city": "Chicago",
      "state": "IL",
      "postalCode": "60612",
      "country": "US"
    },
    "headline": "RUSH Center for Advanced Reproductive Care",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(630) 366-5100",
    "bookingUrl": null,
    "location": {
      "latitude": 41.8001,
      "longitude": -87.9287
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 159,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 42.4,
      "between35And37": 35.9,
      "between38And40": 33.3
    },
    "medicaldirector": "John S. Rinehart, MD, PHD",
    "clinicStatus": "Reorganized",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 34.8,
      "between35And37": 30.4
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "174",
    "name": "Southern Illinois University School of Medicine Fertility and IVF Center",
    "address": {
      "id": "addr-174",
      "address1": "751 N. Rutledge St, Suite 0100",
      "city": "Springfield",
      "state": "IL",
      "postalCode": "62702",
      "country": "US"
    },
    "headline": "Southern Illinois University School of Medicine Fertility and IVF Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(217) 545-8000",
    "bookingUrl": null,
    "location": {
      "latitude": 39.8094,
      "longitude": -89.6582
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 127,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 61.9,
      "between35And37": 58.3
    },
    "medicaldirector": "J. Ricardo Loret de Mola, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 70.2,
      "between35And37": 58.333333333333336
    },
    "newPatientSuccessRateDenominators": {
      "between35And37": 12
    },
    "donorSuccessRates": {
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "173",
    "name": "The Advanced IVF Institute, Charles E. Miller, MD, SC & Associates",
    "address": {
      "id": "addr-173",
      "address1": "120 Osler Dr, Suite 100",
      "city": "Naperville",
      "state": "IL",
      "postalCode": "60540",
      "country": "US"
    },
    "headline": "The Advanced IVF Institute, Charles E. Miller, MD, SC & Associates",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(630) 428-2229",
    "bookingUrl": null,
    "location": {
      "latitude": 41.761,
      "longitude": -88.1521
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 444,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 61,
      "between35And37": 41.6,
      "between38And40": 35
    },
    "medicaldirector": "Charles E. Miller, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 48.1,
      "between35And37": 34.1,
      "between38And40": 32
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 44.8
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "119",
    "name": "University of Chicago Medicine Center for Reproductive Medicine and Fertility",
    "address": {
      "id": "addr-119",
      "address1": "1101 S. Canal St, Suite 202A",
      "city": "Chicago",
      "state": "IL",
      "postalCode": "60607",
      "country": "US"
    },
    "headline": "University of Chicago Medicine Center for Reproductive Medicine and Fertility",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(773) 702-6642",
    "bookingUrl": null,
    "location": {
      "latitude": 41.8675,
      "longitude": -87.6389
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 188,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 51.1,
      "between35And37": 36.6,
      "between38And40": 22.6
    },
    "medicaldirector": "A. Musa Zamah, MD, PHD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 51.6,
      "between35And37": 35.7,
      "between38And40": 19.4
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 55.55555555555556,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFrozenEggs": 9
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "26",
    "name": "University of Illinois at Chicago IVF Program",
    "address": {
      "id": "addr-26",
      "address1": "1801 W. Taylor St, Suite 4A",
      "city": "Chicago",
      "state": "IL",
      "postalCode": "60612",
      "country": "US"
    },
    "headline": "University of Illinois at Chicago IVF Program",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(312) 355-2634",
    "bookingUrl": null,
    "location": {
      "latitude": 41.8695,
      "longitude": -87.6718
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 51,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "between35And37": 26.31578947368421
    },
    "medicaldirector": "Frank Gonzalez, MD",
    "clinicStatus": "Reorganized",
    "successRateDenominators": {
      "between35And37": 19
    },
    "newPatientSuccessRates": {
      "between35And37": 38.46153846153847
    },
    "newPatientSuccessRateDenominators": {
      "between35And37": 13
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "116",
    "name": "Advanced Fertility Group",
    "address": {
      "id": "addr-116",
      "address1": "201 Pennsylvania Pkwy, Suite 205",
      "city": "Indianapolis",
      "state": "IN",
      "postalCode": "46280",
      "country": "US"
    },
    "headline": "Advanced Fertility Group",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(317) 817-1300",
    "bookingUrl": null,
    "location": {
      "latitude": 39.9315,
      "longitude": -86.1539
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 48,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 57.1,
      "between38And40": 0
    },
    "medicaldirector": "William L. Gentry, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between38And40": 8
    },
    "newPatientSuccessRates": {
      "under35": 68.75,
      "between38And40": 0
    },
    "newPatientSuccessRateDenominators": {
      "under35": 16,
      "between38And40": 6
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "514",
    "name": "Boston IVF Fertility Services at The Women's Hospital, LLC",
    "address": {
      "id": "addr-514",
      "address1": "4199 Gateway Blvd, Suite 2600",
      "city": "Newburgh",
      "state": "IN",
      "postalCode": "47630",
      "country": "US"
    },
    "headline": "Boston IVF Fertility Services at The Women's Hospital, LLC",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(812) 842-4530",
    "bookingUrl": null,
    "location": {
      "latitude": 37.9739,
      "longitude": -87.4475
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 286,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 48.2,
      "between35And37": 50,
      "between38And40": 50
    },
    "medicaldirector": "Daniel W. Griffin, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between38And40": 18
    },
    "newPatientSuccessRates": {
      "under35": 61.4,
      "between35And37": 50
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 54.54545454545454,
      "frozenEmbryos": 41.66666666666667
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFrozenEggs": 11,
      "frozenEmbryos": 12
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "72",
    "name": "Community Fertility Specialty Care",
    "address": {
      "id": "addr-72",
      "address1": "7250 Clearvista Dr, Suite 190",
      "city": "Indianapolis",
      "state": "IN",
      "postalCode": "46256",
      "country": "US"
    },
    "headline": "Community Fertility Specialty Care",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(317) 621-0600",
    "bookingUrl": null,
    "location": {
      "latitude": 39.9003,
      "longitude": -86.0399
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 80,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 42.5,
      "between35And37": 66.66666666666666
    },
    "medicaldirector": "David E. Carnovale, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between35And37": 12
    },
    "newPatientSuccessRates": {
      "under35": 48.1,
      "between35And37": 63.63636363636363
    },
    "newPatientSuccessRateDenominators": {
      "between35And37": 11
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "352",
    "name": "Family Beginnings, PC",
    "address": {
      "id": "addr-352",
      "address1": "8435 Clearvista Pl, Suite 104",
      "city": "Indianapolis",
      "state": "IN",
      "postalCode": "46256",
      "country": "US"
    },
    "headline": "Family Beginnings, PC",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(317) 595-3665",
    "bookingUrl": null,
    "location": {
      "latitude": 39.9099,
      "longitude": -86.0409
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 78,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 34.2
    },
    "medicaldirector": "James G. Donahue, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 34.6
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "464",
    "name": "Henry Fertility dba, Reproductive Care of Indiana",
    "address": {
      "id": "addr-464",
      "address1": "201 Pennsylvania Pkwy, Suite 325",
      "city": "Indianapolis",
      "state": "IN",
      "postalCode": "46280",
      "country": "US"
    },
    "headline": "Henry Fertility dba, Reproductive Care of Indiana",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(317) 817-1800",
    "bookingUrl": null,
    "location": {
      "latitude": 39.9315,
      "longitude": -86.1539
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 129,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 58.3,
      "between35And37": 50
    },
    "medicaldirector": "Michael A. Henry, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between35And37": 18
    },
    "newPatientSuccessRates": {
      "under35": 62.5,
      "between35And37": 33.33333333333333
    },
    "newPatientSuccessRateDenominators": {
      "between35And37": 18
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 100
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFreshEggs": 5
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "704",
    "name": "Indiana Fertility Institute",
    "address": {
      "id": "addr-704",
      "address1": "10610 N. Pennsylvania St, Suite 101",
      "city": "Indianapolis",
      "state": "IN",
      "postalCode": "46280",
      "country": "US"
    },
    "headline": "Indiana Fertility Institute",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(317) 575-6565",
    "bookingUrl": null,
    "location": {
      "latitude": 39.9423,
      "longitude": -86.1562
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 453,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 38.8,
      "between35And37": 34.5,
      "between38And40": 33.8
    },
    "medicaldirector": "John C. Jarrett II, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 40.5,
      "between35And37": 30,
      "between38And40": 23.8
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 71.42857142857143,
      "freshEmbryosFrozenEggs": 35.714285714285715,
      "frozenEmbryos": 38.3
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFreshEggs": 7,
      "freshEmbryosFrozenEggs": 14
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "373",
    "name": "Midwest Fertility Specialists",
    "address": {
      "id": "addr-373",
      "address1": "12188-A N. Meridian St, Suite 250",
      "city": "Carmel",
      "state": "IN",
      "postalCode": "46032",
      "country": "US"
    },
    "headline": "Midwest Fertility Specialists",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(317) 571-1637",
    "bookingUrl": null,
    "location": {
      "latitude": 39.967,
      "longitude": -86.1588
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 717,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 46.2,
      "between35And37": 39.6,
      "between38And40": 51.7
    },
    "medicaldirector": "Matthew A. Will, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 56.7,
      "between35And37": 37.5,
      "between38And40": 21.1
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 47.368421052631575,
      "frozenEmbryos": 45.3,
      "donatedEmbryos": 43.8
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFrozenEggs": 19
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "803",
    "name": "Blue Sky Fertility",
    "address": {
      "id": "addr-803",
      "address1": "14253 Metcalf Ave",
      "city": "Overland Park",
      "state": "KS",
      "postalCode": "66223",
      "country": "US"
    },
    "headline": "Blue Sky Fertility",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(913) 218-0162",
    "bookingUrl": null,
    "location": {
      "latitude": 38.8695,
      "longitude": -94.6661
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 230,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 61.9,
      "between35And37": 51.3,
      "between38And40": 70
    },
    "medicaldirector": "Ryan M. Riggs, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 48.8,
      "between35And37": 38.2,
      "between38And40": 25
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 75
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "508",
    "name": "Center for Advanced Reproductive Medicine",
    "address": {
      "id": "addr-508",
      "address1": "10777 Nall Ave, Suite 200",
      "city": "Overland Park",
      "state": "KS",
      "postalCode": "66211",
      "country": "US"
    },
    "headline": "Center for Advanced Reproductive Medicine",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(913) 588-2229",
    "bookingUrl": null,
    "location": {
      "latitude": 38.9331,
      "longitude": -94.6482
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 392,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 44.9,
      "between35And37": 39.5,
      "between38And40": 32.5
    },
    "medicaldirector": "Courtney A. Marsh, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 54.1,
      "between35And37": 47.3,
      "between38And40": 25.7
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 27.1,
      "donatedEmbryos": 34.1
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "243",
    "name": "Midwest Reproductive Center, PA",
    "address": {
      "id": "addr-243",
      "address1": "Doctors Building 1, 20375 W. 151st St, Suite 403",
      "city": "Olathe",
      "state": "KS",
      "postalCode": "66061",
      "country": "US"
    },
    "headline": "Midwest Reproductive Center, PA",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(913) 780-4300",
    "bookingUrl": null,
    "location": {
      "latitude": 38.8528,
      "longitude": -94.8245
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 257,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 37.7,
      "between35And37": 25,
      "between38And40": 21.9
    },
    "medicaldirector": "Dan L. Gehlbach, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 52.8,
      "between35And37": 37.9,
      "between38And40": 13.6
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "frozenEmbryos": 31.57894736842105
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 19
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "386",
    "name": "Reproductive Resource Center of Greater Kansas City",
    "address": {
      "id": "addr-386",
      "address1": "6650 W. 110th St, Suite 320",
      "city": "Overland Park",
      "state": "KS",
      "postalCode": "66211",
      "country": "US"
    },
    "headline": "Reproductive Resource Center of Greater Kansas City",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(913) 894-2323",
    "bookingUrl": null,
    "location": {
      "latitude": 38.9301,
      "longitude": -94.6619
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 180,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 61.4,
      "between35And37": 33.3
    },
    "medicaldirector": "Celeste Brabec, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 54.5,
      "between35And37": 24
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 77.77777777777779,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFrozenEggs": 9
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "846",
    "name": "The Center for Reproductive Medicine",
    "address": {
      "id": "addr-846",
      "address1": "9300 E. 29th St North, Suite 102",
      "city": "Wichita",
      "state": "KS",
      "postalCode": "67226",
      "country": "US"
    },
    "headline": "The Center for Reproductive Medicine",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(316) 687-2112",
    "bookingUrl": null,
    "location": {
      "latitude": 37.6922,
      "longitude": -97.3375
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 160,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 47.5,
      "between35And37": 35.5
    },
    "medicaldirector": "David Grainger, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 50.8,
      "between35And37": 28.6,
      "between38And40": 0
    },
    "newPatientSuccessRateDenominators": {
      "between38And40": 17
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 100,
      "frozenEmbryos": 46.15384615384615,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFrozenEggs": 5,
      "frozenEmbryos": 13
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "328",
    "name": "Bluegrass Fertility Center",
    "address": {
      "id": "addr-328",
      "address1": "1760 Nicholasville Rd, Suite 501",
      "city": "Lexington",
      "state": "KY",
      "postalCode": "40503",
      "country": "US"
    },
    "headline": "Bluegrass Fertility Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(859) 260-1515",
    "bookingUrl": null,
    "location": {
      "latitude": 38.0182,
      "longitude": -84.5137
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 97,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 33.3
    },
    "medicaldirector": "James W. Akin, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 42.9
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "281",
    "name": "Fertility & Endocrine Associates, Louisville Reproductive Center",
    "address": {
      "id": "addr-281",
      "address1": "4123 Dutchmans Ln, Suite 414",
      "city": "Louisville",
      "state": "KY",
      "postalCode": "40207",
      "country": "US"
    },
    "headline": "Fertility & Endocrine Associates, Louisville Reproductive Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(502) 897-2144",
    "bookingUrl": null,
    "location": {
      "latitude": 38.2354,
      "longitude": -85.6322
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 161,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 29.8,
      "between35And37": 34.6,
      "between38And40": 17.4
    },
    "medicaldirector": "Miriam S. Krause, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 42.6,
      "between38And40": 5
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "frozenEmbryos": 50,
      "donatedEmbryos": 46.2
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 18
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "717",
    "name": "Kentucky Fertility Institute, LLC",
    "address": {
      "id": "addr-717",
      "address1": "4612 Chamberlain Ln, Suite 200",
      "city": "Louisville",
      "state": "KY",
      "postalCode": "40241",
      "country": "US"
    },
    "headline": "Kentucky Fertility Institute, LLC",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(502) 996-4480",
    "bookingUrl": null,
    "location": {
      "latitude": 38.3105,
      "longitude": -85.5672
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 220,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 47.5,
      "between35And37": 50,
      "between38And40": 52
    },
    "medicaldirector": "Robert K. Hunter, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 68.4,
      "between35And37": 62.8,
      "between38And40": 16.7
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 56.25
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 16
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "102",
    "name": "The Lexington Fertility Center",
    "address": {
      "id": "addr-102",
      "address1": "170 N. Eagle Creek Dr, Suite 101",
      "city": "Lexington",
      "state": "KY",
      "postalCode": "40509",
      "country": "US"
    },
    "headline": "The Lexington Fertility Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(859) 277-5736",
    "bookingUrl": null,
    "location": {
      "latitude": 38.0008,
      "longitude": -84.439
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 32,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {},
    "medicaldirector": "George M. Veloudis, DO",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {},
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 0
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 5
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "129",
    "name": "ArkLaTex Fertility and Reproductive Medicine",
    "address": {
      "id": "addr-129",
      "address1": "2401 Greenwood Rd, Suite A",
      "city": "Shreveport",
      "state": "LA",
      "postalCode": "71103",
      "country": "US"
    },
    "headline": "ArkLaTex Fertility and Reproductive Medicine",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(318) 841-5800",
    "bookingUrl": null,
    "location": {
      "latitude": 32.4845,
      "longitude": -93.7765
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 94,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 51.1,
      "between35And37": 35
    },
    "medicaldirector": "David T. Vandermolen, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 60,
      "between35And37": 50,
      "between38And40": 0
    },
    "newPatientSuccessRateDenominators": {
      "between35And37": 12,
      "between38And40": 7
    },
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "228",
    "name": "Audubon Fertility",
    "address": {
      "id": "addr-228",
      "address1": "4321 Magnolia St",
      "city": "New Orleans",
      "state": "LA",
      "postalCode": "70115",
      "country": "US"
    },
    "headline": "Audubon Fertility",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(504) 891-1390",
    "bookingUrl": null,
    "location": {
      "latitude": 29.9375,
      "longitude": -90.1025
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 229,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 55.6,
      "between35And37": 57.8,
      "between38And40": 66.66666666666666
    },
    "medicaldirector": "Lindsay Wells, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between38And40": 15
    },
    "newPatientSuccessRates": {
      "under35": 61.8,
      "between35And37": 31.7,
      "between38And40": 27.3
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 30,
      "donatedEmbryos": 55.55555555555556
    },
    "donorSuccessRateDenominators": {
      "donatedEmbryos": 9
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "606",
    "name": "Fertility Answers, LLC",
    "address": {
      "id": "addr-606",
      "address1": "500 Rue de La Vie, Suite 510",
      "city": "Baton Rouge",
      "state": "LA",
      "postalCode": "70817",
      "country": "US"
    },
    "headline": "Fertility Answers, LLC",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(225) 926-6886",
    "bookingUrl": null,
    "location": {
      "latitude": 30.3858,
      "longitude": -91.0373
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 428,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 48.3,
      "between35And37": 43.5,
      "between38And40": 37
    },
    "medicaldirector": "John M. Storment, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 52,
      "between35And37": 27.4,
      "between38And40": 20
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "frozenEmbryos": 31.3
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "496",
    "name": "Fertility Institute of New Orleans",
    "address": {
      "id": "addr-496",
      "address1": "800 N. Causeway Blvd, Suite 2C",
      "city": "Mandeville",
      "state": "LA",
      "postalCode": "70448",
      "country": "US"
    },
    "headline": "Fertility Institute of New Orleans",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(985) 892-7621",
    "bookingUrl": null,
    "location": {
      "latitude": 30.377,
      "longitude": -90.0924
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 432,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 43.3,
      "between35And37": 33.3,
      "between38And40": 42.9
    },
    "medicaldirector": "Warren Huber, MD, PHD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 49.6,
      "between35And37": 29.4,
      "between38And40": 29.2
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "frozenEmbryos": 41.66666666666667,
      "donatedEmbryos": 33.3
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 12
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "154",
    "name": "Baystate Reproductive Medicine",
    "address": {
      "id": "addr-154",
      "address1": "Tolosky Center, 3300 Main St, Suite 4C",
      "city": "Springfield",
      "state": "MA",
      "postalCode": "1199",
      "country": "US"
    },
    "headline": "Baystate Reproductive Medicine",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(413) 794-1950",
    "bookingUrl": null,
    "location": {
      "latitude": 42.123,
      "longitude": -72.61
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 386,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 39.4,
      "between35And37": 35.4,
      "between38And40": 30.4
    },
    "medicaldirector": "Cynthia Sites, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 55.2,
      "between35And37": 49.3,
      "between38And40": 30.8
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "490",
    "name": "Boston IVF, LLC",
    "address": {
      "id": "addr-490",
      "address1": "130 Second Ave",
      "city": "Waltham",
      "state": "MA",
      "postalCode": "2451",
      "country": "US"
    },
    "headline": "Boston IVF, LLC",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(781) 434-6500",
    "bookingUrl": null,
    "location": {
      "latitude": 42.3928,
      "longitude": -71.2638
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 510,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 46.3,
      "between35And37": 40.5,
      "between38And40": 38
    },
    "medicaldirector": "Michael M. Alper, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 57.9,
      "between35And37": 43.4,
      "between38And40": 30.2
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 46.1,
      "frozenEmbryos": 38.4,
      "donatedEmbryos": 53.333333333333336
    },
    "donorSuccessRateDenominators": {
      "donatedEmbryos": 15
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "473",
    "name": "Brigham and Women's Hospital Center for Assisted Reproductive Technology",
    "address": {
      "id": "addr-473",
      "address1": "75 Francis St",
      "city": "Boston",
      "state": "MA",
      "postalCode": "2115",
      "country": "US"
    },
    "headline": "Brigham and Women's Hospital Center for Assisted Reproductive Technology",
    "images": [],
    "tags": [],
    "services": ["Counseling", "Support groups", "Support resources"],
    "languages": ["en", "es"],
    "clinicType": "Hospital-based",
    "conditions": [
      "PCOS",
      "Endometriosis",
      "Male Factor",
      "Diminished ovarian reserve",
      "Unexplained infertility",
      "Tubal factor",
      "Uterine factor"
    ],
    "treatments": [
      "IVF & ICSI",
      "Egg Freezing",
      "Embryo Freezing",
      "PGT",
      "Donor programs",
      "Surrogacy",
      "Fertility preservation"
    ],
    "website": "https://www.brighamandwomens.org/obgyn/center-for-infertility-and-reproductive-surgery",
    "email": null,
    "phone": "(617) 732-5570",
    "bookingUrl": "https://www.brighamandwomens.org/forms/landing/infertility/contact",
    "location": {
      "latitude": 42.3362,
      "longitude": -71.1067
    },
    "insurances": [],
    "insuranceAccepted": true,
    "insuranceName": null,
    "financiers": ["Payment plans"],
    "consultationTypes": ["In person", "Telehealth"],
    "patientGroups": ["LGBTQIA+", "Same sex couples"],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 1270,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": "One of the largest academic medical center-based fertility programs in the US, part of Mass General Brigham, with nationally-certified in-house laboratories.",
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 46.2,
      "between35And37": 41,
      "between38And40": 41.5
    },
    "medicaldirector": "Serene S. Srouji, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 55.1,
      "between35And37": 47.9,
      "between38And40": 45.7
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 87,
      "freshEmbryosFrozenEggs": 52,
      "frozenEmbryos": 41.7,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "801",
    "name": "CCRM Boston",
    "address": {
      "id": "addr-801",
      "address1": "300 Boylston St, Suite 300",
      "city": "Newton",
      "state": "MA",
      "postalCode": "2459",
      "country": "US"
    },
    "headline": "CCRM Boston",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(617) 449-9750",
    "bookingUrl": null,
    "location": {
      "latitude": 42.3186,
      "longitude": -71.18
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 869,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 65.5,
      "between35And37": 57.4,
      "between38And40": 60.4
    },
    "medicaldirector": "Alison E. Zimon, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 59.5,
      "between35And37": 35.8,
      "between38And40": 26
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "frozenEmbryos": 70
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "720",
    "name": "Fertility Centers of New England, Inc., New England Clinics of Reproductive Medicine, Inc.",
    "address": {
      "id": "addr-720",
      "address1": "20 Pond Meadow Dr, Suite 101",
      "city": "Reading",
      "state": "MA",
      "postalCode": "1867",
      "country": "US"
    },
    "headline": "Fertility Centers of New England, Inc., New England Clinics of Reproductive Medicine, Inc.",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(781) 942-7000",
    "bookingUrl": null,
    "location": {
      "latitude": 42.5166,
      "longitude": -71.0992
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 833,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 45.3,
      "between35And37": 44.6,
      "between38And40": 41
    },
    "medicaldirector": "Danielle Vitiello, MD, PHD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 53.2,
      "between35And37": 47.6,
      "between38And40": 26
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 44.2
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "341",
    "name": "Fertility Solutions, PC",
    "address": {
      "id": "addr-341",
      "address1": "45 Stergis Way",
      "city": "Dedham",
      "state": "MA",
      "postalCode": "2026",
      "country": "US"
    },
    "headline": "Fertility Solutions, PC",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(781) 326-2451",
    "bookingUrl": null,
    "location": {
      "latitude": 42.2343,
      "longitude": -71.1764
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 380,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 37.9,
      "between35And37": 43.9,
      "between38And40": 25.3
    },
    "medicaldirector": "Ania Kowalik, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 58.1,
      "between35And37": 44.7,
      "between38And40": 28.3
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "frozenEmbryos": 60,
      "donatedEmbryos": 100
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 15,
      "donatedEmbryos": 6
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "226",
    "name": "Massachusetts General Hospital Fertility Center",
    "address": {
      "id": "addr-226",
      "address1": "32 Fruit St, Yawkey 10A",
      "city": "Boston",
      "state": "MA",
      "postalCode": "2114",
      "country": "US"
    },
    "headline": "Massachusetts General Hospital Fertility Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(617) 726-8868",
    "bookingUrl": null,
    "location": {
      "latitude": 42.362,
      "longitude": -71.0695
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 943,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 42.4,
      "between35And37": 42.2,
      "between38And40": 32
    },
    "medicaldirector": "John C. Petrozza, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 53.9,
      "between35And37": 52.6,
      "between38And40": 28.2
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 71.42857142857143,
      "frozenEmbryos": 51.2,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFrozenEggs": 14
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "856",
    "name": "UMass Memorial IVF Center",
    "address": {
      "id": "addr-856",
      "address1": "33 Kendall St, Levine 2",
      "city": "Worcester",
      "state": "MA",
      "postalCode": "1605",
      "country": "US"
    },
    "headline": "UMass Memorial IVF Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(508) 334-9849",
    "bookingUrl": null,
    "location": {
      "latitude": 42.274,
      "longitude": -71.7933
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 70,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 30.8,
      "between35And37": 40
    },
    "medicaldirector": "Meaghan Delaney, MD",
    "clinicStatus": "Reorganized",
    "successRateDenominators": {
      "between35And37": 15
    },
    "newPatientSuccessRates": {
      "under35": 36.4,
      "between35And37": 50
    },
    "newPatientSuccessRateDenominators": {
      "between35And37": 10
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "58",
    "name": "Johns Hopkins Fertility Center",
    "address": {
      "id": "addr-58",
      "address1": "10755 Falls Rd, Pavilion I, Suite 480",
      "city": "Lutherville",
      "state": "MD",
      "postalCode": "21093",
      "country": "US"
    },
    "headline": "Johns Hopkins Fertility Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(410) 847-3835",
    "bookingUrl": null,
    "location": {
      "latitude": 39.4207,
      "longitude": -76.6666
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 565,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 50.9,
      "between35And37": 58.9,
      "between38And40": 42
    },
    "medicaldirector": "Valerie L. Baker, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 51.9,
      "between35And37": 43.6,
      "between38And40": 17
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 60,
      "frozenEmbryos": 38.2
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFrozenEggs": 15
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "353",
    "name": "Montgomery Fertility Center",
    "address": {
      "id": "addr-353",
      "address1": "3202 Tower Oaks Blvd, Suite 370",
      "city": "Rockville",
      "state": "MD",
      "postalCode": "20852",
      "country": "US"
    },
    "headline": "Montgomery Fertility Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(301) 946-6962",
    "bookingUrl": null,
    "location": {
      "latitude": 39.0594,
      "longitude": -77.1507
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 62,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 41.17647058823529
    },
    "medicaldirector": "Oluyemisi Adesanya-Famuyiwa, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "under35": 17
    },
    "newPatientSuccessRates": {
      "under35": 45.45454545454545,
      "between38And40": 0
    },
    "newPatientSuccessRateDenominators": {
      "under35": 11,
      "between38And40": 8
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 8
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "179",
    "name": "Shady Grove Fertility-Rockville",
    "address": {
      "id": "addr-179",
      "address1": "9601 Blackwell Rd, 4th Floor",
      "city": "Rockville",
      "state": "MD",
      "postalCode": "20850",
      "country": "US"
    },
    "headline": "Shady Grove Fertility-Rockville",
    "images": [],
    "tags": [],
    "services": [
      "Acupuncture",
      "Mind/Body",
      "Massage therapy",
      "Nutrition counseling",
      "Counseling",
      "Support groups",
      "Wellness program",
      "Patient portal",
      "Support resources"
    ],
    "languages": ["en", "es"],
    "clinicType": "Network & group",
    "conditions": [
      "PCOS",
      "Endometriosis",
      "Male Factor",
      "Diminished ovarian reserve",
      "Recurrent pregnancy loss",
      "Unexplained infertility",
      "Tubal factor",
      "Ovulatory dysfunction",
      "Uterine factor"
    ],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Embryo Freezing",
      "PGT",
      "Ovulation Induction",
      "Sperm Freezing",
      "Donor programs",
      "Surrogacy",
      "Fertility preservation",
      "Male factor"
    ],
    "website": "https://www.shadygrovefertility.com",
    "email": null,
    "phone": "(301) 340-1188",
    "bookingUrl": "https://www.shadygrovefertility.com/appointment/",
    "location": {
      "latitude": 39.1017,
      "longitude": -77.1928
    },
    "insurances": [],
    "insuranceAccepted": true,
    "insuranceName": null,
    "financiers": [
      "Payment plans",
      "Package pricing",
      "Future Family",
      "CapexMD"
    ],
    "consultationTypes": ["In person", "Telehealth"],
    "patientGroups": ["LGBTQIA+", "Single Parents", "Same sex couples"],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 5717,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": "Flagship location of one of the nation's largest fertility networks with 49 locations, home to their largest IVF and embryology laboratory.",
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 47.2,
      "between35And37": 44.6,
      "between38And40": 41.5
    },
    "medicaldirector": "Michael J. Levy, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 59,
      "between35And37": 44.3,
      "between38And40": 30.6
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 58.1,
      "freshEmbryosFrozenEggs": 62.3,
      "frozenEmbryos": 42.7,
      "donatedEmbryos": 43.8
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "108",
    "name": "Shady Grove Fertility-Towson",
    "address": {
      "id": "addr-108",
      "address1": "901 Dulaney Valley Rd, Suite 616",
      "city": "Towson",
      "state": "MD",
      "postalCode": "21204",
      "country": "US"
    },
    "headline": "Shady Grove Fertility-Towson",
    "images": [],
    "tags": [],
    "services": [
      "Acupuncture",
      "Mind/Body",
      "Massage therapy",
      "Nutrition counseling",
      "Counseling",
      "Wellness program",
      "Patient portal",
      "Support resources"
    ],
    "languages": ["en"],
    "clinicType": "Network & group",
    "conditions": [
      "PCOS",
      "Endometriosis",
      "Male Factor",
      "Diminished ovarian reserve",
      "Recurrent pregnancy loss",
      "Unexplained infertility",
      "Tubal factor",
      "Ovulatory dysfunction"
    ],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Embryo Freezing",
      "PGT",
      "Ovulation Induction",
      "Sperm Freezing",
      "Donor programs",
      "Surrogacy",
      "Fertility preservation"
    ],
    "website": "https://www.shadygrovefertility.com/locations/maryland/towson-fertility-center/",
    "email": null,
    "phone": "(410) 512-8300",
    "bookingUrl": "https://www.shadygrovefertility.com/appointment/",
    "location": {
      "latitude": 39.4068,
      "longitude": -76.6003
    },
    "insurances": [],
    "insuranceAccepted": true,
    "insuranceName": null,
    "financiers": ["Payment plans", "CapexMD"],
    "consultationTypes": ["In person", "Telehealth"],
    "patientGroups": ["LGBTQIA+", "Single Parents", "Same sex couples"],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 1547,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": "Part of US Fertility, one of the nation's largest physician-led fertility networks, with a dedicated Wellness Center offering holistic support services.",
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 44.7,
      "between35And37": 44.4,
      "between38And40": 41.9
    },
    "medicaldirector": "Jeffrey L. McKeeby, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 54.6,
      "between35And37": 41.8,
      "between38And40": 26.3
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 63.6,
      "frozenEmbryos": 33,
      "donatedEmbryos": 35.294117647058826
    },
    "donorSuccessRateDenominators": {
      "donatedEmbryos": 17
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "15",
    "name": "Shady Grove Fertility-Walter Reed, Walter Reed National Military Medical Center",
    "address": {
      "id": "addr-15",
      "address1": "8901 Rockville Pike, Bldg 10, Rm 2104",
      "city": "Bethesda",
      "state": "MD",
      "postalCode": "20889",
      "country": "US"
    },
    "headline": "Shady Grove Fertility-Walter Reed, Walter Reed National Military Medical Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(301) 400-2151",
    "bookingUrl": null,
    "location": {
      "latitude": 39.0018,
      "longitude": -77.0935
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 277,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 48.9,
      "between35And37": 54.9,
      "between38And40": 30.6
    },
    "medicaldirector": "Micah J. Hill, DO",
    "clinicStatus": "Reorganized",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 51.4,
      "between35And37": 47.8,
      "between38And40": 11.1
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 60
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFrozenEggs": 10
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "103",
    "name": "Boston IVF, LLC The Maine Center",
    "address": {
      "id": "addr-103",
      "address1": "778 Main St, Suite 2",
      "city": "South Portland",
      "state": "ME",
      "postalCode": "4106",
      "country": "US"
    },
    "headline": "Boston IVF, LLC The Maine Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(207) 358-7600",
    "bookingUrl": null,
    "location": {
      "latitude": 43.6166,
      "longitude": -70.3087
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 369,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 47.4,
      "between35And37": 47.9,
      "between38And40": 51.7
    },
    "medicaldirector": "Benjamin M. Lannon, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 60,
      "between35And37": 41.8,
      "between38And40": 45.3
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 54.54545454545454
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 11
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "59",
    "name": "Gago IVF",
    "address": {
      "id": "addr-59",
      "address1": "2250 Genoa Business Park Dr, Suite 110",
      "city": "Brighton",
      "state": "MI",
      "postalCode": "48114",
      "country": "US"
    },
    "headline": "Gago IVF",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(810) 227-3232",
    "bookingUrl": null,
    "location": {
      "latitude": 42.5696,
      "longitude": -83.8063
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 234,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 43.6,
      "between35And37": 36.4,
      "between38And40": 47.6
    },
    "medicaldirector": "Laura A. Gago, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 48.8,
      "between35And37": 21.9,
      "between38And40": 28
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {},
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "631",
    "name": "Henry Ford Health Center for Reproductive Medicine",
    "address": {
      "id": "addr-631",
      "address1": "3950 S. Rochester Rd, Suite 2300",
      "city": "Rochester Hills",
      "state": "MI",
      "postalCode": "48307",
      "country": "US"
    },
    "headline": "Henry Ford Health Center for Reproductive Medicine",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(248) 845-8845",
    "bookingUrl": null,
    "location": {
      "latitude": 42.6236,
      "longitude": -83.1317
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 323,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 52.3,
      "between35And37": 47.7,
      "between38And40": 43.8
    },
    "medicaldirector": "Mostafa I. Abuzeid, MD",
    "clinicStatus": "Closed",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 49.6,
      "between35And37": 45.2,
      "between38And40": 25
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "632",
    "name": "Henry Ford Reproductive Medicine",
    "address": {
      "id": "addr-632",
      "address1": "2825 Livernois Rd, Suite A",
      "city": "Troy",
      "state": "MI",
      "postalCode": "48083",
      "country": "US"
    },
    "headline": "Henry Ford Reproductive Medicine",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(248) 637-4050",
    "bookingUrl": null,
    "location": {
      "latitude": 42.5601,
      "longitude": -83.1487
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 62,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 81,
      "between35And37": 70
    },
    "medicaldirector": "Ahmad Hammoud, MD",
    "clinicStatus": "Closed",
    "successRateDenominators": {
      "between35And37": 10
    },
    "newPatientSuccessRates": {
      "under35": 56.5,
      "between35And37": 87.5
    },
    "newPatientSuccessRateDenominators": {
      "between35And37": 8
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "633",
    "name": "IVF Michigan Fertility Centers",
    "address": {
      "id": "addr-633",
      "address1": "37000 Woodward Ave, Suite 350",
      "city": "Bloomfield Hills",
      "state": "MI",
      "postalCode": "48304",
      "country": "US"
    },
    "headline": "IVF Michigan Fertility Centers",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(248) 952-9600",
    "bookingUrl": null,
    "location": {
      "latitude": 42.5596,
      "longitude": -83.2227
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 1001,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 54.7,
      "between35And37": 45.2,
      "between38And40": 39.4
    },
    "medicaldirector": "Ahmad O. Hammoud, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 57.9,
      "between35And37": 38.7,
      "between38And40": 26.4
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 50,
      "freshEmbryosFrozenEggs": 38.88888888888889,
      "frozenEmbryos": 46.8
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFreshEggs": 12,
      "freshEmbryosFrozenEggs": 18
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "894",
    "name": "Kindbody-Detroit",
    "address": {
      "id": "addr-894",
      "address1": "26400 W 12th Mile Rd, Ste 140",
      "city": "Southfield",
      "state": "MI",
      "postalCode": "48034",
      "country": "US"
    },
    "headline": "Kindbody-Detroit",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(248) 780-2070",
    "bookingUrl": null,
    "location": {
      "latitude": 42.5019,
      "longitude": -83.2839
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 3,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 0,
      "between35And37": 0,
      "between38And40": 0
    },
    "medicaldirector": "Roohi Jeelani, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 0,
      "between35And37": 0,
      "between38And40": 0
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "318",
    "name": "Michigan Center for Fertility and Women's Health, PLC",
    "address": {
      "id": "addr-318",
      "address1": "4700 E. 13 Mile Rd",
      "city": "Warren",
      "state": "MI",
      "postalCode": "48092",
      "country": "US"
    },
    "headline": "Michigan Center for Fertility and Women's Health, PLC",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(586) 576-0431",
    "bookingUrl": null,
    "location": {
      "latitude": 42.5202,
      "longitude": -83.0604
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 242,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 42.2,
      "between35And37": 39.4,
      "between38And40": 46.15384615384615
    },
    "medicaldirector": "Carole L. Kowalczyk, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between38And40": 13
    },
    "newPatientSuccessRates": {
      "under35": 42.3,
      "between35And37": 31.3,
      "between38And40": 16.7
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "frozenEmbryos": 37.9
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "56",
    "name": "Michigan Reproductive & IVF Center, PC",
    "address": {
      "id": "addr-56",
      "address1": "3230 Eagle Park Dr N.E., Suite 100",
      "city": "Grand Rapids",
      "state": "MI",
      "postalCode": "49525",
      "country": "US"
    },
    "headline": "Michigan Reproductive & IVF Center, PC",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(616) 988-2229",
    "bookingUrl": null,
    "location": {
      "latitude": 42.9879,
      "longitude": -85.5892
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 645,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 44.7,
      "between35And37": 34.6,
      "between38And40": 28.2
    },
    "medicaldirector": "Valerie I. Shavell, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 57.7,
      "between35And37": 37.3,
      "between38And40": 23.1
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 60,
      "frozenEmbryos": 53.6,
      "donatedEmbryos": 44.4
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFreshEggs": 10
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "364",
    "name": "Michigan Reproductive Medicine",
    "address": {
      "id": "addr-364",
      "address1": "41000 Woodward Ave, Suite 100E",
      "city": "Bloomfield Hills",
      "state": "MI",
      "postalCode": "48304",
      "country": "US"
    },
    "headline": "Michigan Reproductive Medicine",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(248) 593-6990",
    "bookingUrl": null,
    "location": {
      "latitude": 42.5906,
      "longitude": -83.2485
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 137,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 38.2,
      "between35And37": 35.714285714285715,
      "between38And40": 20
    },
    "medicaldirector": "Michael S. Mersol-Barg, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between35And37": 14
    },
    "newPatientSuccessRates": {
      "under35": 20,
      "between38And40": 10
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 46.666666666666664,
      "frozenEmbryos": 25,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFrozenEggs": 15
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "320",
    "name": "Reproductive Medicine Associates of Michigan",
    "address": {
      "id": "addr-320",
      "address1": "130 Town Center Dr, Suite 106",
      "city": "Troy",
      "state": "MI",
      "postalCode": "48084",
      "country": "US"
    },
    "headline": "Reproductive Medicine Associates of Michigan",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(248) 619-3100",
    "bookingUrl": null,
    "location": {
      "latitude": 42.5682,
      "longitude": -83.1509
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 442,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 54.6,
      "between35And37": 53.8,
      "between38And40": 39.3
    },
    "medicaldirector": "Brad T. Miller, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 65.9,
      "between35And37": 55.8,
      "between38And40": 27.6
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "frozenEmbryos": 48.9
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "707",
    "name": "University of Michigan Center for Reproductive Medicine",
    "address": {
      "id": "addr-707",
      "address1": "475 Market Pl, Bldg 1, Suite B",
      "city": "Ann Arbor",
      "state": "MI",
      "postalCode": "48108",
      "country": "US"
    },
    "headline": "University of Michigan Center for Reproductive Medicine",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(734) 763-6295",
    "bookingUrl": null,
    "location": {
      "latitude": 42.2431,
      "longitude": -83.7419
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 423,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 47.8,
      "between35And37": 44.9,
      "between38And40": 42
    },
    "medicaldirector": "Marie Menke, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 51.4,
      "between35And37": 41,
      "between38And40": 25
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 46.15384615384615,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFrozenEggs": 13
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "611",
    "name": "CCRM Minneapolis",
    "address": {
      "id": "addr-611",
      "address1": "6565 France Ave South, Suite 400",
      "city": "Edina",
      "state": "MN",
      "postalCode": "55435",
      "country": "US"
    },
    "headline": "CCRM Minneapolis",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(952) 225-1630",
    "bookingUrl": null,
    "location": {
      "latitude": 44.8841,
      "longitude": -93.3272
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 840,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 63.4,
      "between35And37": 58.9,
      "between38And40": 57.9
    },
    "medicaldirector": "April E. Batcheller, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 61.2,
      "between35And37": 48.9,
      "between38And40": 27.1
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 44.9
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "70",
    "name": "Center for Reproductive Medicine, Advanced Reproductive Technologies",
    "address": {
      "id": "addr-70",
      "address1": "2828 Chicago Ave South, Suite 400",
      "city": "Minneapolis",
      "state": "MN",
      "postalCode": "55407",
      "country": "US"
    },
    "headline": "Center for Reproductive Medicine, Advanced Reproductive Technologies",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(612) 863-5390",
    "bookingUrl": null,
    "location": {
      "latitude": 44.951,
      "longitude": -93.263
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 598,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 46.1,
      "between35And37": 52.1,
      "between38And40": 42.2
    },
    "medicaldirector": "Mark A. Damario, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 60.7,
      "between35And37": 58.9,
      "between38And40": 33.3
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 48.1,
      "freshEmbryosFrozenEggs": 75,
      "frozenEmbryos": 53.7,
      "donatedEmbryos": 56.3
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFrozenEggs": 8
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "898",
    "name": "Kindbody Minneapolis",
    "address": {
      "id": "addr-898",
      "address1": "138 N. 2nd St",
      "city": "Minneapolis",
      "state": "MN",
      "postalCode": "55401",
      "country": "US"
    },
    "headline": "Kindbody Minneapolis",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(612) 230-4090",
    "bookingUrl": null,
    "location": {
      "latitude": 44.9846,
      "longitude": -93.27
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 3,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 0,
      "between35And37": 0,
      "between38And40": 0
    },
    "medicaldirector": "Fabiola Balmir, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 0,
      "between35And37": 0,
      "between38And40": 0
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "523",
    "name": "Mayo Clinic Assisted Reproductive Technologies",
    "address": {
      "id": "addr-523",
      "address1": "200 First St S.W., Eisenberg 2A",
      "city": "Rochester",
      "state": "MN",
      "postalCode": "55905",
      "country": "US"
    },
    "headline": "Mayo Clinic Assisted Reproductive Technologies",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(507) 284-9792",
    "bookingUrl": null,
    "location": {
      "latitude": 44.0227,
      "longitude": -92.4668
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 321,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 55,
      "between35And37": 23.5,
      "between38And40": 19.7
    },
    "medicaldirector": "Samir N. Babayev, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 69.5,
      "between35And37": 20.6,
      "between38And40": 22.6
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 42.9,
      "frozenEmbryos": 20
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "140",
    "name": "Midwest Center for Reproductive Health, PA",
    "address": {
      "id": "addr-140",
      "address1": "Arbor Lakes Medical Building, 12000 Elm Creek Blvd North, Suite 350",
      "city": "Maple Grove",
      "state": "MN",
      "postalCode": "55369",
      "country": "US"
    },
    "headline": "Midwest Center for Reproductive Health, PA",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(763) 458-2939",
    "bookingUrl": null,
    "location": {
      "latitude": 45.0957,
      "longitude": -93.4333
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 182,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 58.8,
      "between35And37": 52.1
    },
    "medicaldirector": "Randle S. Corfman, MD, PHD",
    "clinicStatus": "Closed",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 74.3,
      "between35And37": 60
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 37.5,
      "frozenEmbryos": 41.17647058823529
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 17
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "82",
    "name": "Reproductive Medicine & Infertility Associates",
    "address": {
      "id": "addr-82",
      "address1": "Woodbury Medical Arts Building, 2101 Woodwinds Dr, Suite 100",
      "city": "Woodbury",
      "state": "MN",
      "postalCode": "55125",
      "country": "US"
    },
    "headline": "Reproductive Medicine & Infertility Associates",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(651) 222-6050",
    "bookingUrl": null,
    "location": {
      "latitude": 44.9176,
      "longitude": -92.9798
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 645,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 54,
      "between35And37": 42.4,
      "between38And40": 40.7
    },
    "medicaldirector": "Jacques P. Stassart, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 65.6,
      "between35And37": 45.5,
      "between38And40": 18.8
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 33.3,
      "frozenEmbryos": 28.1
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "187",
    "name": "Center for Reproductive Medicine & Robotic Surgery",
    "address": {
      "id": "addr-187",
      "address1": "844 N. New Ballas Ct, Suite 300",
      "city": "St. Louis",
      "state": "MO",
      "postalCode": "63141",
      "country": "US"
    },
    "headline": "Center for Reproductive Medicine & Robotic Surgery",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(314) 473-1285",
    "bookingUrl": null,
    "location": {
      "latitude": 38.6731,
      "longitude": -90.4443
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 32,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 46.666666666666664,
      "between38And40": 0
    },
    "medicaldirector": "Saji Jacob, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "under35": 15,
      "between38And40": 5
    },
    "newPatientSuccessRates": {},
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "389",
    "name": "Fertility and Reproductive Medicine Center, at Washington University School of Medicine and Barnes-Jewish Hospital",
    "address": {
      "id": "addr-389",
      "address1": "4444 Forest Park Ave, Suite 3100",
      "city": "St. Louis",
      "state": "MO",
      "postalCode": "63108",
      "country": "US"
    },
    "headline": "Fertility and Reproductive Medicine Center, at Washington University School of Medicine and Barnes-Jewish Hospital",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(314) 286-2400",
    "bookingUrl": null,
    "location": {
      "latitude": 38.6372,
      "longitude": -90.257
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 503,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 47.8,
      "between35And37": 49,
      "between38And40": 21.4
    },
    "medicaldirector": "Kenan R. Omurtag, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 64.8,
      "between35And37": 55.2,
      "between38And40": 17.6
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 62.5,
      "freshEmbryosFrozenEggs": 75,
      "frozenEmbryos": 53.1
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFreshEggs": 8,
      "freshEmbryosFrozenEggs": 8
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "387",
    "name": "Fertility Partnership",
    "address": {
      "id": "addr-387",
      "address1": "5401 Veterans Memorial Pkwy, Suite 201",
      "city": "Saint Peters",
      "state": "MO",
      "postalCode": "63376",
      "country": "US"
    },
    "headline": "Fertility Partnership",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(636) 441-7770",
    "bookingUrl": null,
    "location": {
      "latitude": 38.7971,
      "longitude": -90.595
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 220,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 44.3,
      "between35And37": 36.7,
      "between38And40": 28.1
    },
    "medicaldirector": "David E. Simckes, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 49.4,
      "between35And37": 41.2,
      "between38And40": 28.6
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {
      "donatedEmbryos": 7
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "420",
    "name": "Infertility Center of St. Louis",
    "address": {
      "id": "addr-420",
      "address1": "224 S. Woods Mill Rd, Suite 730",
      "city": "Chesterfield",
      "state": "MO",
      "postalCode": "63017",
      "country": "US"
    },
    "headline": "Infertility Center of St. Louis",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(314) 576-1400",
    "bookingUrl": null,
    "location": {
      "latitude": 38.652,
      "longitude": -90.5026
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 38,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 0,
      "between35And37": 0,
      "between38And40": 0
    },
    "medicaldirector": "Sherman J. Silber, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 0,
      "between35And37": 0,
      "between38And40": 0
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "frozenEmbryos": 50
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "702",
    "name": "Kindbody Fertility Institute-St Louis",
    "address": {
      "id": "addr-702",
      "address1": "347 N Lindbergh Blvd",
      "city": "St Louis",
      "state": "MO",
      "postalCode": "63141",
      "country": "US"
    },
    "headline": "Kindbody Fertility Institute-St Louis",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(314) 266-2062",
    "bookingUrl": null,
    "location": {
      "latitude": 38.5662,
      "longitude": -89.9868
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 790,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 46.9,
      "between35And37": 36.8,
      "between38And40": 28.6
    },
    "medicaldirector": "Amber Cooper, MD",
    "clinicStatus": "Reorganized",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 45.8,
      "between35And37": 32.4,
      "between38And40": 17
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 61.9,
      "frozenEmbryos": 55,
      "donatedEmbryos": 55.55555555555556
    },
    "donorSuccessRateDenominators": {
      "donatedEmbryos": 9
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "609",
    "name": "MCRM Fertility",
    "address": {
      "id": "addr-609",
      "address1": "17300 N. Outer 40 Rd, Suite 101",
      "city": "Chesterfield",
      "state": "MO",
      "postalCode": "63005",
      "country": "US"
    },
    "headline": "MCRM Fertility",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(636) 778-9899",
    "bookingUrl": null,
    "location": {
      "latitude": 38.672,
      "longitude": -90.6008
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 661,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 62.6,
      "between35And37": 50.6,
      "between38And40": 52.8
    },
    "medicaldirector": "Mira Aubuchon, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 61.3,
      "between35And37": 38.2,
      "between38And40": 33.3
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 50,
      "donatedEmbryos": 25
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "365",
    "name": "Missouri Fertility",
    "address": {
      "id": "addr-365",
      "address1": "1506 E. Broadway, Suite 220",
      "city": "Columbia",
      "state": "MO",
      "postalCode": "65201",
      "country": "US"
    },
    "headline": "Missouri Fertility",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(573) 443-4511",
    "bookingUrl": null,
    "location": {
      "latitude": 38.9505,
      "longitude": -92.3174
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 98,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 41,
      "between35And37": 52.2,
      "between38And40": 66.66666666666666
    },
    "medicaldirector": "Gilbert B. Wilshire, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between38And40": 12
    },
    "newPatientSuccessRates": {
      "under35": 47.5,
      "between35And37": 75,
      "between38And40": 70
    },
    "newPatientSuccessRateDenominators": {
      "between35And37": 16,
      "between38And40": 10
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 3.3
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "268",
    "name": "MU Healthcare, Reproductive Health and Fertility Center",
    "address": {
      "id": "addr-268",
      "address1": "500 N. Keene St, Suite 203",
      "city": "Columbia",
      "state": "MO",
      "postalCode": "65201",
      "country": "US"
    },
    "headline": "MU Healthcare, Reproductive Health and Fertility Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(573) 817-3101",
    "bookingUrl": null,
    "location": {
      "latitude": 38.9582,
      "longitude": -92.2878
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 60,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 42.3
    },
    "medicaldirector": "Albert L. Hsu, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 39.1
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "164",
    "name": "STL Fertility",
    "address": {
      "id": "addr-164",
      "address1": "555 N. New Ballas Rd, Suite 150",
      "city": "St. Louis",
      "state": "MO",
      "postalCode": "63141",
      "country": "US"
    },
    "headline": "STL Fertility",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(314) 983-9000",
    "bookingUrl": null,
    "location": {
      "latitude": 38.6659,
      "longitude": -90.4439
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 201,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 50,
      "between35And37": 29.2,
      "between38And40": 52.94117647058824
    },
    "medicaldirector": "Molina B. Dayal, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between38And40": 17
    },
    "newPatientSuccessRates": {
      "under35": 50.8,
      "between35And37": 33.3,
      "between38And40": 38.88888888888889
    },
    "newPatientSuccessRateDenominators": {
      "between38And40": 18
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 40
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "410",
    "name": "Mississippi Reproductive Medicine, PLLC",
    "address": {
      "id": "addr-410",
      "address1": "2500 Lakeland Dr",
      "city": "Flowood",
      "state": "MS",
      "postalCode": "39232",
      "country": "US"
    },
    "headline": "Mississippi Reproductive Medicine, PLLC",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(601) 936-3650",
    "bookingUrl": null,
    "location": {
      "latitude": 32.3306,
      "longitude": -90.1223
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 115,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 59.5,
      "between35And37": 66.66666666666666,
      "between38And40": 60
    },
    "medicaldirector": "Randall S. Hines, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between35And37": 15,
      "between38And40": 10
    },
    "newPatientSuccessRates": {
      "under35": 41.9,
      "between35And37": 62.5
    },
    "newPatientSuccessRateDenominators": {
      "between35And37": 16
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 54.54545454545454
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 11
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "809",
    "name": "Positive Steps Fertility",
    "address": {
      "id": "addr-809",
      "address1": "149 Fountains Blvd",
      "city": "Madison",
      "state": "MS",
      "postalCode": "39110",
      "country": "US"
    },
    "headline": "Positive Steps Fertility",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(833) 767-7837",
    "bookingUrl": null,
    "location": {
      "latitude": 32.4707,
      "longitude": -90.1451
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 231,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 41.8,
      "between35And37": 25
    },
    "medicaldirector": "John P. Parry, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 65.7,
      "between35And37": 30
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 48,
      "donatedEmbryos": 75
    },
    "donorSuccessRateDenominators": {
      "donatedEmbryos": 8
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "114",
    "name": "University of Mississippi Medical Center",
    "address": {
      "id": "addr-114",
      "address1": "2925 Layfair Dr, Room 146",
      "city": "Flowood",
      "state": "MS",
      "postalCode": "39232",
      "country": "US"
    },
    "headline": "University of Mississippi Medical Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(601) 984-5330",
    "bookingUrl": null,
    "location": {
      "latitude": 32.3276,
      "longitude": -90.1128
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 32,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 38.1
    },
    "medicaldirector": "John D. Isaacs, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "between38And40": 0
    },
    "newPatientSuccessRateDenominators": {
      "between38And40": 5
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "614",
    "name": "Billings Clinic, Reproductive Medicine and Fertility Care",
    "address": {
      "id": "addr-614",
      "address1": "3319 Gabel Rd",
      "city": "Billings",
      "state": "MT",
      "postalCode": "59102",
      "country": "US"
    },
    "headline": "Billings Clinic, Reproductive Medicine and Fertility Care",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(406) 551-6008",
    "bookingUrl": null,
    "location": {
      "latitude": 45.7906,
      "longitude": -108.517
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 198,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 50.9,
      "between35And37": 66.7,
      "between38And40": 57.14285714285714
    },
    "medicaldirector": "Stacy Shomento, MD",
    "clinicStatus": "Reorganized",
    "successRateDenominators": {
      "between38And40": 14
    },
    "newPatientSuccessRates": {
      "under35": 54.3,
      "between35And37": 40.7,
      "between38And40": 15
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "frozenEmbryos": 40
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "155",
    "name": "Atlantic Reproductive Medicine Specialists, PA",
    "address": {
      "id": "addr-155",
      "address1": "10208 Cerny St, Suite 306",
      "city": "Raleigh",
      "state": "NC",
      "postalCode": "27617",
      "country": "US"
    },
    "headline": "Atlantic Reproductive Medicine Specialists, PA",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(919) 248-8777",
    "bookingUrl": null,
    "location": {
      "latitude": 35.9016,
      "longitude": -78.8006
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 168,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 53.3,
      "between35And37": 60.9,
      "between38And40": 61.9
    },
    "medicaldirector": "Susannah D. Copland, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 55.3,
      "between35And37": 39.1,
      "between38And40": 25
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "frozenEmbryos": 50,
      "donatedEmbryos": 51.4
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "358",
    "name": "Carolina Conceptions, PA",
    "address": {
      "id": "addr-358",
      "address1": "2601 Lake Dr, Suite 301",
      "city": "Raleigh",
      "state": "NC",
      "postalCode": "27607",
      "country": "US"
    },
    "headline": "Carolina Conceptions, PA",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(919) 782-5911",
    "bookingUrl": null,
    "location": {
      "latitude": 35.8162,
      "longitude": -78.7071
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 639,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 52.6,
      "between35And37": 42.9,
      "between38And40": 57.3
    },
    "medicaldirector": "Meaghan R. Bowling, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 62.1,
      "between35And37": 51.2,
      "between38And40": 40.3
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 61.111111111111114,
      "frozenEmbryos": 61.5,
      "donatedEmbryos": 68.75
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFreshEggs": 18,
      "donatedEmbryos": 16
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "601",
    "name": "Carolinas Fertility Institute",
    "address": {
      "id": "addr-601",
      "address1": "3821 Forrestgate Dr",
      "city": "Winston-salem",
      "state": "NC",
      "postalCode": "27103",
      "country": "US"
    },
    "headline": "Carolinas Fertility Institute",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(336) 448-9100",
    "bookingUrl": null,
    "location": {
      "latitude": 36.0727,
      "longitude": -80.3142
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 790,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 61.3,
      "between35And37": 60.7,
      "between38And40": 57.7
    },
    "medicaldirector": "Tamer M. Yalcinkaya, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 80.5,
      "between35And37": 61.2,
      "between38And40": 39.1
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 85.71428571428571,
      "freshEmbryosFrozenEggs": 47.8,
      "frozenEmbryos": 52.7,
      "donatedEmbryos": 58.333333333333336
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFreshEggs": 7,
      "donatedEmbryos": 12
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "333",
    "name": "Duke Fertility Center, Duke University Medical Center",
    "address": {
      "id": "addr-333",
      "address1": "5601 Arringdon Park Dr, Suite 210",
      "city": "Morrisville",
      "state": "NC",
      "postalCode": "27560",
      "country": "US"
    },
    "headline": "Duke Fertility Center, Duke University Medical Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(919) 572-4673",
    "bookingUrl": null,
    "location": {
      "latitude": 35.9224,
      "longitude": -78.9283
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 255,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 52.4,
      "between35And37": 41.7,
      "between38And40": 48.1
    },
    "medicaldirector": "Shelby A. Neal, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 61.9,
      "between35And37": 45.5,
      "between38And40": 35.7
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "frozenEmbryos": 50
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "347",
    "name": "North Carolina Center for Reproductive Medicine, The Talbert Fertility Institute",
    "address": {
      "id": "addr-347",
      "address1": "400 Ashville Ave, Suite 200",
      "city": "Cary",
      "state": "NC",
      "postalCode": "27518",
      "country": "US"
    },
    "headline": "North Carolina Center for Reproductive Medicine, The Talbert Fertility Institute",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(919) 233-1680",
    "bookingUrl": null,
    "location": {
      "latitude": 35.7375,
      "longitude": -78.7866
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 176,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 54.3,
      "between35And37": 61.3,
      "between38And40": 64.3
    },
    "medicaldirector": "Sameh K. Toma, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 47.5,
      "between35And37": 53.1,
      "between38And40": 46.9
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "frozenEmbryos": 28.6
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "217",
    "name": "Program for Assisted Reproduction at Atrium Health's Carolinas Medical Center, CMC Women's Institute",
    "address": {
      "id": "addr-217",
      "address1": "1025 Morehead Medical Dr, Suite 500",
      "city": "Charlotte",
      "state": "NC",
      "postalCode": "28204",
      "country": "US"
    },
    "headline": "Program for Assisted Reproduction at Atrium Health's Carolinas Medical Center, CMC Women's Institute",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(704) 355-3149",
    "bookingUrl": null,
    "location": {
      "latitude": 35.205,
      "longitude": -80.8389
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 385,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 52.2,
      "between35And37": 51.2,
      "between38And40": 42.9
    },
    "medicaldirector": "Bradley S. Hurst, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 70,
      "between35And37": 55.9,
      "between38And40": 34.1
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 60,
      "frozenEmbryos": 29.411764705882355
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFrozenEggs": 15,
      "frozenEmbryos": 17
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "452",
    "name": "Reproductive Endocrinology Associates of Charlotte",
    "address": {
      "id": "addr-452",
      "address1": "1524 E. Morehead St",
      "city": "Charlotte",
      "state": "NC",
      "postalCode": "28207",
      "country": "US"
    },
    "headline": "Reproductive Endocrinology Associates of Charlotte",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(704) 343-3400",
    "bookingUrl": null,
    "location": {
      "latitude": 35.2041,
      "longitude": -80.8352
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 512,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 45.4,
      "between35And37": 51,
      "between38And40": 42.3
    },
    "medicaldirector": "Seth Katz, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 51,
      "between35And37": 43.7,
      "between38And40": 28.8
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 39.1,
      "donatedEmbryos": 85.71428571428571
    },
    "donorSuccessRateDenominators": {
      "donatedEmbryos": 7
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "871",
    "name": "Reproductive Specialists of the Carolinas",
    "address": {
      "id": "addr-871",
      "address1": "1918 Randolph Rd, Suite 410",
      "city": "Charlotte",
      "state": "NC",
      "postalCode": "28207",
      "country": "US"
    },
    "headline": "Reproductive Specialists of the Carolinas",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(704) 247-2209",
    "bookingUrl": null,
    "location": {
      "latitude": 35.2096,
      "longitude": -80.8251
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 39,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 30,
      "between38And40": 66.66666666666666
    },
    "medicaldirector": "Matrika Johnson, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between38And40": 9
    },
    "newPatientSuccessRates": {
      "under35": 50,
      "between38And40": 50
    },
    "newPatientSuccessRateDenominators": {
      "under35": 10,
      "between38And40": 12
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "344",
    "name": "UNC Fertility",
    "address": {
      "id": "addr-344",
      "address1": "7920 ACC Blvd, Suite 300",
      "city": "Raleigh",
      "state": "NC",
      "postalCode": "27617",
      "country": "US"
    },
    "headline": "UNC Fertility",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(919) 908-0000",
    "bookingUrl": null,
    "location": {
      "latitude": 35.9067,
      "longitude": -78.7637
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 424,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 45.1,
      "between35And37": 37,
      "between38And40": 40.9
    },
    "medicaldirector": "Colleen Milroy, MD",
    "clinicStatus": "Reorganized",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 57.8,
      "between35And37": 38.3,
      "between38And40": 28.6
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 36.84210526315789,
      "frozenEmbryos": 53.333333333333336
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFrozenEggs": 19,
      "frozenEmbryos": 15
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "605",
    "name": "Wake Forest University Center for Reproductive Medicine",
    "address": {
      "id": "addr-605",
      "address1": "111 Hanestown Ct, Suite 351",
      "city": "Winston-salem",
      "state": "NC",
      "postalCode": "27103",
      "country": "US"
    },
    "headline": "Wake Forest University Center for Reproductive Medicine",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(336) 716-6476",
    "bookingUrl": null,
    "location": {
      "latitude": 36.0881,
      "longitude": -80.2941
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 174,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 70.6,
      "between35And37": 60.9,
      "between38And40": 60.9
    },
    "medicaldirector": "Jeffrey L. Deaton, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 58.3,
      "between35And37": 40,
      "between38And40": 21.7
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 62.5
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "209",
    "name": "Womack Army Medical Center",
    "address": {
      "id": "addr-209",
      "address1": "WAMC MCXC-OB, 2817 Reilly Rd, Mailstop A",
      "city": "Fort Liberty",
      "state": "NC",
      "postalCode": "28310",
      "country": "US"
    },
    "headline": "Womack Army Medical Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(910) 907-9270",
    "bookingUrl": null,
    "location": {
      "latitude": 35.1461,
      "longitude": -79.0021
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 96,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 31,
      "between35And37": 21.4
    },
    "medicaldirector": "Luiz F. Correa, DO",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 26.9
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "360",
    "name": "Sanford Health Reproductive Medicine Institute",
    "address": {
      "id": "addr-360",
      "address1": "1111 Harwood Dr South",
      "city": "Fargo",
      "state": "ND",
      "postalCode": "58104",
      "country": "US"
    },
    "headline": "Sanford Health Reproductive Medicine Institute",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(701) 234-2700",
    "bookingUrl": null,
    "location": {
      "latitude": 46.8304,
      "longitude": -96.7981
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 178,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 59.4,
      "between35And37": 51.4,
      "between38And40": 58.333333333333336
    },
    "medicaldirector": "Christina Broadwell, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between38And40": 12
    },
    "newPatientSuccessRates": {
      "under35": 69.6,
      "between35And37": 48.3,
      "between38And40": 58.333333333333336
    },
    "newPatientSuccessRateDenominators": {
      "between38And40": 12
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "455",
    "name": "Heartland Center for Reproductive Medicine, PC",
    "address": {
      "id": "addr-455",
      "address1": "7308 S. 142nd St",
      "city": "Omaha",
      "state": "NE",
      "postalCode": "68138",
      "country": "US"
    },
    "headline": "Heartland Center for Reproductive Medicine, PC",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(402) 717-4200",
    "bookingUrl": null,
    "location": {
      "latitude": 41.1885,
      "longitude": -96.138
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 359,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 43.1,
      "between35And37": 32.3,
      "between38And40": 35.714285714285715
    },
    "medicaldirector": "Stephanie L. Gustin, MD",
    "clinicStatus": "Reorganized",
    "successRateDenominators": {
      "between38And40": 14
    },
    "newPatientSuccessRates": {
      "under35": 45.4,
      "between35And37": 34.1,
      "between38And40": 12
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 49.3
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "363",
    "name": "Reproductive Health Specialists",
    "address": {
      "id": "addr-363",
      "address1": "717 N. 190th Plaza, Suite 2500",
      "city": "Elkhorn",
      "state": "NE",
      "postalCode": "68022",
      "country": "US"
    },
    "headline": "Reproductive Health Specialists",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(402) 815-1915",
    "bookingUrl": null,
    "location": {
      "latitude": 41.2646,
      "longitude": -96.2125
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 438,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 49.3,
      "between35And37": 44,
      "between38And40": 43.2
    },
    "medicaldirector": "Carolyn M. Doherty, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 61.1,
      "between35And37": 36.1,
      "between38And40": 20.9
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 19.4,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "867",
    "name": "Boston IVF - The NH Center",
    "address": {
      "id": "addr-867",
      "address1": "18 Constitution Dr, Suite 9",
      "city": "Bedford",
      "state": "NH",
      "postalCode": "3110",
      "country": "US"
    },
    "headline": "Boston IVF - The NH Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(603) 637-9736",
    "bookingUrl": null,
    "location": {
      "latitude": 42.9561,
      "longitude": -71.5036
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 141,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 50.7,
      "between35And37": 45.3,
      "between38And40": 53.84615384615385
    },
    "medicaldirector": "Kristen P. Wright, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between38And40": 13
    },
    "newPatientSuccessRates": {
      "under35": 61.2,
      "between35And37": 42.4,
      "between38And40": 40
    },
    "newPatientSuccessRateDenominators": {
      "between38And40": 15
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "412",
    "name": "Center for Advanced Reproductive Medicine & Fertility",
    "address": {
      "id": "addr-412",
      "address1": "4 Ethel Rd, Suite 405A",
      "city": "Edison",
      "state": "NJ",
      "postalCode": "8817",
      "country": "US"
    },
    "headline": "Center for Advanced Reproductive Medicine & Fertility",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(732) 339-9300",
    "bookingUrl": null,
    "location": {
      "latitude": 40.5412,
      "longitude": -74.396
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 35,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 60.6,
      "between35And37": 59.5,
      "between38And40": 42.9
    },
    "medicaldirector": "Suna M. Qasim, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 52.8,
      "between35And37": 42,
      "between38And40": 22.2
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 52
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "485",
    "name": "Center for Reproductive Medicine and Fertility, Louis R. Manara, DO",
    "address": {
      "id": "addr-485",
      "address1": "200 Route 73, Suite A",
      "city": "Voorhees",
      "state": "NJ",
      "postalCode": "8043",
      "country": "US"
    },
    "headline": "Center for Reproductive Medicine and Fertility, Louis R. Manara, DO",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(856) 767-0009",
    "bookingUrl": null,
    "location": {
      "latitude": 39.8426,
      "longitude": -74.9233
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 140,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 47.1,
      "between35And37": 37.7,
      "between38And40": 46.15384615384615
    },
    "medicaldirector": "Louis R. Manara, DO",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between38And40": 13
    },
    "newPatientSuccessRates": {
      "under35": 58.5,
      "between35And37": 53.6,
      "between38And40": 75
    },
    "newPatientSuccessRateDenominators": {
      "between38And40": 8
    },
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "186",
    "name": "Cooper Institute for Reproductive Hormonal Disorders, PC",
    "address": {
      "id": "addr-186",
      "address1": "17000 Commerce Pkwy, Suite C",
      "city": "Mount Laurel",
      "state": "NJ",
      "postalCode": "8054",
      "country": "US"
    },
    "headline": "Cooper Institute for Reproductive Hormonal Disorders, PC",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(856) 751-5575",
    "bookingUrl": null,
    "location": {
      "latitude": 39.9183,
      "longitude": -74.942
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 445,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 33,
      "between35And37": 29.9,
      "between38And40": 14.8
    },
    "medicaldirector": "Jerome H. Check, MD, PHD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 43.3,
      "between35And37": 40,
      "between38And40": 17.6
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "frozenEmbryos": 40.9
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "381",
    "name": "Damien Fertility Partners",
    "address": {
      "id": "addr-381",
      "address1": "655 Shrewsbury Ave, Suite 300",
      "city": "Shrewsbury",
      "state": "NJ",
      "postalCode": "7702",
      "country": "US"
    },
    "headline": "Damien Fertility Partners",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(732) 758-6511",
    "bookingUrl": null,
    "location": {
      "latitude": 40.3263,
      "longitude": -74.0724
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 329,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 52.2,
      "between35And37": 50.7,
      "between38And40": 32.7
    },
    "medicaldirector": "Miguel Damien, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 59.4,
      "between35And37": 50,
      "between38And40": 20
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 64.28571428571429,
      "frozenEmbryos": 52.4,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFrozenEggs": 14
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "463",
    "name": "Diamond Institute for Infertility & Menopause",
    "address": {
      "id": "addr-463",
      "address1": "89 Millburn Ave",
      "city": "Millburn",
      "state": "NJ",
      "postalCode": "7041",
      "country": "US"
    },
    "headline": "Diamond Institute for Infertility & Menopause",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(973) 761-5600",
    "bookingUrl": null,
    "location": {
      "latitude": 40.723,
      "longitude": -74.2868
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 188,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 42.5,
      "between35And37": 22.9,
      "between38And40": 28.1
    },
    "medicaldirector": "Matan Yemini, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 52.9,
      "between35And37": 25,
      "between38And40": 28.6
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 40.7,
      "donatedEmbryos": 64.28571428571429
    },
    "donorSuccessRateDenominators": {
      "donatedEmbryos": 14
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "266",
    "name": "Fertility Institute of New Jersey and New York",
    "address": {
      "id": "addr-266",
      "address1": "680 Kinderkamack Rd, Suite 200",
      "city": "Oradell",
      "state": "NJ",
      "postalCode": "7649",
      "country": "US"
    },
    "headline": "Fertility Institute of New Jersey and New York",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(201) 666-4200",
    "bookingUrl": null,
    "location": {
      "latitude": 40.9634,
      "longitude": -74.0301
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 277,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 62.8,
      "between35And37": 73.2,
      "between38And40": 58.1
    },
    "medicaldirector": "Zalman Levine, MD",
    "clinicStatus": "Reorganized",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 69.8,
      "between35And37": 58.3,
      "between38And40": 30.8
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 66.7,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "54",
    "name": "Institute for Reproductive Medicine and Science, Saint Barnabas Medical Center",
    "address": {
      "id": "addr-54",
      "address1": "94 Old Short Hills Rd, East Wing, Suite 403",
      "city": "Livingston",
      "state": "NJ",
      "postalCode": "7039",
      "country": "US"
    },
    "headline": "Institute for Reproductive Medicine and Science, Saint Barnabas Medical Center",
    "images": [],
    "tags": [],
    "services": ["Counseling", "Patient portal", "Support resources"],
    "languages": ["en", "es"],
    "clinicType": "Network & group",
    "conditions": [
      "PCOS",
      "Endometriosis",
      "Male Factor",
      "Diminished ovarian reserve",
      "Recurrent pregnancy loss",
      "Oncofertility"
    ],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Embryo Freezing",
      "PGT",
      "Sperm Freezing",
      "Donor programs",
      "Surrogacy",
      "Fertility preservation"
    ],
    "website": "https://sbivf.com",
    "email": null,
    "phone": "(973) 322-8286",
    "bookingUrl": "https://sbivf.com/contact-us/",
    "location": {
      "latitude": 40.7631,
      "longitude": -74.3048
    },
    "insurances": [],
    "insuranceAccepted": true,
    "insuranceName": null,
    "financiers": ["Loans", "Future Family", "CapexMD"],
    "consultationTypes": ["In person", "Telehealth"],
    "patientGroups": ["LGBTQIA+", "Same sex couples"],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 1248,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": "Leading New Jersey fertility center at Saint Barnabas Medical Center, part of the CCRM network, with dedicated financial counselors and 24-48 hour oncofertility consults.",
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 59,
      "between35And37": 55.7,
      "between38And40": 55.2
    },
    "medicaldirector": "Debbra A. Keegan, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 60.5,
      "between35And37": 46.2,
      "between38And40": 31.3
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 38.2,
      "frozenEmbryos": 40.9,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "147",
    "name": "North Hudson IVF, Center for Fertility and Gynecology",
    "address": {
      "id": "addr-147",
      "address1": "385 Sylvan Ave",
      "city": "Englewood Cliffs",
      "state": "NJ",
      "postalCode": "7632",
      "country": "US"
    },
    "headline": "North Hudson IVF, Center for Fertility and Gynecology",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(201) 871-1999",
    "bookingUrl": null,
    "location": {
      "latitude": 40.8747,
      "longitude": -73.9522
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 28,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "between38And40": 0
    },
    "medicaldirector": "Jane E. Miller, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 0
    },
    "newPatientSuccessRateDenominators": {
      "under35": 9
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "416",
    "name": "Reproductive Medicine Associates of New Jersey",
    "address": {
      "id": "addr-416",
      "address1": "140 Allen Rd",
      "city": "Basking Ridge",
      "state": "NJ",
      "postalCode": "7920",
      "country": "US"
    },
    "headline": "Reproductive Medicine Associates of New Jersey",
    "images": [],
    "tags": [],
    "services": ["Patient portal", "Support resources", "Outside monitoring"],
    "languages": ["en", "es"],
    "clinicType": "Network & group",
    "conditions": [
      "PCOS",
      "Endometriosis",
      "Male Factor",
      "Diminished ovarian reserve",
      "Recurrent pregnancy loss",
      "Unexplained infertility",
      "Tubal factor",
      "Ovulatory dysfunction",
      "Uterine factor",
      "Oncofertility"
    ],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Embryo Freezing",
      "PGT",
      "Ovulation Induction",
      "Sperm Freezing",
      "Donor programs",
      "Surrogacy",
      "Fertility preservation",
      "Male factor"
    ],
    "website": "https://rmanetwork.com/our-locations/rma-new-jersey/",
    "email": null,
    "phone": "(973) 971-4600",
    "bookingUrl": "https://rmanetwork.com/contact-us/",
    "location": {
      "latitude": 40.6473,
      "longitude": -74.5852
    },
    "insurances": [],
    "insuranceAccepted": true,
    "insuranceName": null,
    "financiers": [
      "Payment plans",
      "Loans",
      "Future Family",
      "Gaia",
      "CapexMD"
    ],
    "consultationTypes": ["In person", "Telehealth"],
    "patientGroups": ["LGBTQIA+", "Single Parents", "Same sex couples"],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 4583,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": "Ranked #1 fertility clinic in New Jersey with over 25 years of experience and pioneering research in preimplantation genetic testing.",
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 59.5,
      "between35And37": 54.8,
      "between38And40": 57.7
    },
    "medicaldirector": "Michael R. Drews, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 65.5,
      "between35And37": 48.9,
      "between38And40": 35.3
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 50.7,
      "donatedEmbryos": 45.2
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "239",
    "name": "Reproductive Science Center of New Jersey",
    "address": {
      "id": "addr-239",
      "address1": "234 Industrial Way West, Suite A104",
      "city": "Eatontown",
      "state": "NJ",
      "postalCode": "7724",
      "country": "US"
    },
    "headline": "Reproductive Science Center of New Jersey",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(732) 918-2500",
    "bookingUrl": null,
    "location": {
      "latitude": 40.2765,
      "longitude": -74.0561
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 295,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 47.2,
      "between35And37": 35.2,
      "between38And40": 25
    },
    "medicaldirector": "William Ziegler, DO",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 47.8,
      "between35And37": 28.6,
      "between38And40": 15.2
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 57.14285714285714,
      "frozenEmbryos": 33.3
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFrozenEggs": 14
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "319",
    "name": "Shore Institute for Reproductive Medicine dba, Morgan Fertility and Reproductive Medicine",
    "address": {
      "id": "addr-319",
      "address1": "475 Route 70 West, Suite 201",
      "city": "Lakewood",
      "state": "NJ",
      "postalCode": "8701",
      "country": "US"
    },
    "headline": "Shore Institute for Reproductive Medicine dba, Morgan Fertility and Reproductive Medicine",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(732) 363-4777",
    "bookingUrl": null,
    "location": {
      "latitude": 40.0506,
      "longitude": -74.2006
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 28,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 41.1,
      "between35And37": 32,
      "between38And40": 40.5
    },
    "medicaldirector": "Allen Morgan, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 45.1,
      "between35And37": 23.3,
      "between38And40": 22.9
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 43.75
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFrozenEggs": 16
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "43",
    "name": "South Jersey Fertility Center",
    "address": {
      "id": "addr-43",
      "address1": "400 Lippincott Dr, Suite 130",
      "city": "Marlton",
      "state": "NJ",
      "postalCode": "8053",
      "country": "US"
    },
    "headline": "South Jersey Fertility Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(856) 596-2233",
    "bookingUrl": null,
    "location": {
      "latitude": 39.8847,
      "longitude": -74.9247
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 417,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 46,
      "between35And37": 33.3,
      "between38And40": 35.7
    },
    "medicaldirector": "Peter G. Van Deerlin, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 53.1,
      "between35And37": 38.5,
      "between38And40": 25
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 46.8
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "133",
    "name": "University Reproductive Associates, PC",
    "address": {
      "id": "addr-133",
      "address1": "214 Terrace Ave",
      "city": "Hasbrouck Heights",
      "state": "NJ",
      "postalCode": "7604",
      "country": "US"
    },
    "headline": "University Reproductive Associates, PC",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(201) 288-6330",
    "bookingUrl": null,
    "location": {
      "latitude": 40.8585,
      "longitude": -74.0737
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 557,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 40.4,
      "between35And37": 40.7,
      "between38And40": 36.4
    },
    "medicaldirector": "Peter G. McGovern, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 47.3,
      "between35And37": 37.8,
      "between38And40": 22.6
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 41.66666666666667,
      "frozenEmbryos": 27.6,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFrozenEggs": 12
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "106",
    "name": "Valley Hospital Fertility Center",
    "address": {
      "id": "addr-106",
      "address1": "140 E. Ridgewood Ave, 5th Floor, Suite 590S",
      "city": "Paramus",
      "state": "NJ",
      "postalCode": "7652",
      "country": "US"
    },
    "headline": "Valley Hospital Fertility Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(201) 634-5534",
    "bookingUrl": null,
    "location": {
      "latitude": 40.9646,
      "longitude": -74.0688
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 256,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 53.3,
      "between35And37": 53.8,
      "between38And40": 56.4
    },
    "medicaldirector": "Ali Nasseri, MD, PHD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 61.4,
      "between35And37": 39.3,
      "between38And40": 38.9
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 50
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 16
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "722",
    "name": "Caperton Fertility Institute, LLC",
    "address": {
      "id": "addr-722",
      "address1": "6500 Jefferson St N.E., Suite 250",
      "city": "Albuquerque",
      "state": "NM",
      "postalCode": "87109",
      "country": "US"
    },
    "headline": "Caperton Fertility Institute, LLC",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(505) 702-8020",
    "bookingUrl": null,
    "location": {
      "latitude": 35.1545,
      "longitude": -106.593
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 272,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 57.6,
      "between35And37": 46.2,
      "between38And40": 57.14285714285714
    },
    "medicaldirector": "Charles L. Caperton, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between38And40": 14
    },
    "newPatientSuccessRates": {
      "under35": 32.2,
      "between35And37": 19,
      "between38And40": 18.5
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 40
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 15
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "263",
    "name": "The Fertility Center of New Mexico, LLC",
    "address": {
      "id": "addr-263",
      "address1": "201 Cedar St S.E., Suite S1-20",
      "city": "Albuquerque",
      "state": "NM",
      "postalCode": "87106",
      "country": "US"
    },
    "headline": "The Fertility Center of New Mexico, LLC",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(505) 248-0000",
    "bookingUrl": null,
    "location": {
      "latitude": 35.0808,
      "longitude": -106.635
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 136,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 43.5,
      "between35And37": 68,
      "between38And40": 50
    },
    "medicaldirector": "Douglas J. Thompson, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between38And40": 14
    },
    "newPatientSuccessRates": {
      "under35": 53.5,
      "between35And37": 52,
      "between38And40": 40
    },
    "newPatientSuccessRateDenominators": {
      "between38And40": 15
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 52.94117647058824
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFrozenEggs": 17
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "233",
    "name": "Fertility Center of Las Vegas",
    "address": {
      "id": "addr-233",
      "address1": "5365 S. Durango Dr",
      "city": "Las Vegas",
      "state": "NV",
      "postalCode": "89113",
      "country": "US"
    },
    "headline": "Fertility Center of Las Vegas",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(702) 254-1777",
    "bookingUrl": null,
    "location": {
      "latitude": 36.143,
      "longitude": -115.29
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 357,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 60.6,
      "between35And37": 55.9,
      "between38And40": 53.5
    },
    "medicaldirector": "Bruce Shapiro, MD, PHD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 60.4,
      "between35And37": 32.8,
      "between38And40": 30.6
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 100,
      "frozenEmbryos": 59
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFrozenEggs": 5
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "501",
    "name": "Green Valley Fertility Partners",
    "address": {
      "id": "addr-501",
      "address1": "2510 Wigwam Pkwy, Suite 201",
      "city": "Henderson",
      "state": "NV",
      "postalCode": "89074",
      "country": "US"
    },
    "headline": "Green Valley Fertility Partners",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(702) 722-2229",
    "bookingUrl": null,
    "location": {
      "latitude": 36.0349,
      "longitude": -115.098
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 224,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 26.7,
      "between35And37": 44.4,
      "between38And40": 50
    },
    "medicaldirector": "Jeffrey D. Fisch, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 45.7,
      "between35And37": 36,
      "between38And40": 29.6
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {},
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "713",
    "name": "Nevada Fertility Center",
    "address": {
      "id": "addr-713",
      "address1": "5320 S. Rainbow Blvd, Suite 300",
      "city": "Las Vegas",
      "state": "NV",
      "postalCode": "89118",
      "country": "US"
    },
    "headline": "Nevada Fertility Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(702) 892-9696",
    "bookingUrl": null,
    "location": {
      "latitude": 36.0918,
      "longitude": -115.242
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 222,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 66.3,
      "between35And37": 60.7,
      "between38And40": 47.4
    },
    "medicaldirector": "Russell A. Foulk, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 73.7,
      "between35And37": 57.1,
      "between38And40": 44.4
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 55.9
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "831",
    "name": "Nevada Fertility Institute",
    "address": {
      "id": "addr-831",
      "address1": "8530 W. Sunset Rd, Suite 310",
      "city": "Las Vegas",
      "state": "NV",
      "postalCode": "89113",
      "country": "US"
    },
    "headline": "Nevada Fertility Institute",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(702) 936-8710",
    "bookingUrl": null,
    "location": {
      "latitude": 36.0714,
      "longitude": -115.278
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 150,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 57.1,
      "between35And37": 50
    },
    "medicaldirector": "Cindy Duke, MD, PHD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between35And37": 16
    },
    "newPatientSuccessRates": {
      "under35": 50
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 31.25,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 16
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "379",
    "name": "Red Rock Fertility Center",
    "address": {
      "id": "addr-379",
      "address1": "9120 W. Russell Rd, Suite 200",
      "city": "Las Vegas",
      "state": "NV",
      "postalCode": "89148",
      "country": "US"
    },
    "headline": "Red Rock Fertility Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(702) 262-0079",
    "bookingUrl": null,
    "location": {
      "latitude": 36.086,
      "longitude": -115.291
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 149,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 57.7,
      "between35And37": 53.84615384615385
    },
    "medicaldirector": "Eva D. Littman, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between35And37": 13
    },
    "newPatientSuccessRates": {
      "under35": 37.9,
      "between35And37": 17.4,
      "between38And40": 4.5
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 47.368421052631575
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 19
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "304",
    "name": "The Nevada Center for Reproductive Medicine",
    "address": {
      "id": "addr-304",
      "address1": "645 Sierra Rose Dr, Suite 205",
      "city": "Reno",
      "state": "NV",
      "postalCode": "89511",
      "country": "US"
    },
    "headline": "The Nevada Center for Reproductive Medicine",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(775) 828-1200",
    "bookingUrl": null,
    "location": {
      "latitude": 39.4746,
      "longitude": -119.798
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 291,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 62.6,
      "between35And37": 64,
      "between38And40": 52.2
    },
    "medicaldirector": "Scott J. Whitten, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 69.7,
      "between35And37": 56.5,
      "between38And40": 27.6
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 57.1,
      "donatedEmbryos": 59.1
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "817",
    "name": "Boston IVF-The Syracuse Center",
    "address": {
      "id": "addr-817",
      "address1": "5792 Widewaters Pkwy",
      "city": "Syracuse",
      "state": "NY",
      "postalCode": "13214",
      "country": "US"
    },
    "headline": "Boston IVF-The Syracuse Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(315) 703-3050",
    "bookingUrl": null,
    "location": {
      "latitude": 43.0494,
      "longitude": -76.0591
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 124,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 46.2,
      "between35And37": 47.8
    },
    "medicaldirector": "Maximillian Klein, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 57.1,
      "between35And37": 44.44444444444444
    },
    "newPatientSuccessRateDenominators": {
      "between35And37": 18
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "507",
    "name": "Boston IVF, The Albany Center",
    "address": {
      "id": "addr-507",
      "address1": "399 Albany Shaker Rd",
      "city": "Loudonville",
      "state": "NY",
      "postalCode": "12211",
      "country": "US"
    },
    "headline": "Boston IVF, The Albany Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(518) 434-9759",
    "bookingUrl": null,
    "location": {
      "latitude": 42.6974,
      "longitude": -73.7675
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 442,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 39.8,
      "between35And37": 36.6,
      "between38And40": 36.4
    },
    "medicaldirector": "Alan Penzias, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 46.7,
      "between35And37": 25.4,
      "between38And40": 4.8
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "708",
    "name": "CCRM New York",
    "address": {
      "id": "addr-708",
      "address1": "810 Seventh Ave, 21st Floor",
      "city": "New York",
      "state": "NY",
      "postalCode": "10019",
      "country": "US"
    },
    "headline": "CCRM New York",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(212) 290-8100",
    "bookingUrl": null,
    "location": {
      "latitude": 40.7628,
      "longitude": -73.9823
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 779,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 58.7,
      "between35And37": 54.6,
      "between38And40": 65.1
    },
    "medicaldirector": "Jaime Knopman, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 42.1,
      "between35And37": 20.3,
      "between38And40": 23.4
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 65.4,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "441",
    "name": "Center for Human Reproduction (CHR)",
    "address": {
      "id": "addr-441",
      "address1": "21 E. 69th St",
      "city": "New York",
      "state": "NY",
      "postalCode": "10021",
      "country": "US"
    },
    "headline": "Center for Human Reproduction (CHR)",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(212) 994-4400",
    "bookingUrl": null,
    "location": {
      "latitude": 40.7698,
      "longitude": -73.9663
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 356,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 33.33333333333333,
      "between38And40": 9.8
    },
    "medicaldirector": "Norbert Gleicher, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "under35": 15
    },
    "newPatientSuccessRates": {
      "between35And37": 0,
      "between38And40": 0
    },
    "newPatientSuccessRateDenominators": {
      "between35And37": 5,
      "between38And40": 12
    },
    "donorSuccessRates": {
      "frozenEmbryos": 37.8
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "607",
    "name": "Chelsea Fertility NYC",
    "address": {
      "id": "addr-607",
      "address1": "105 E. 37th St, Suite 1",
      "city": "New York",
      "state": "NY",
      "postalCode": "10016",
      "country": "US"
    },
    "headline": "Chelsea Fertility NYC",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(212) 685-2229",
    "bookingUrl": null,
    "location": {
      "latitude": 40.7489,
      "longitude": -73.9793
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 72,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 50
    },
    "medicaldirector": "Paul Gindoff, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "under35": 12
    },
    "newPatientSuccessRates": {
      "between35And37": 0,
      "between38And40": 0
    },
    "newPatientSuccessRateDenominators": {
      "between35And37": 7,
      "between38And40": 10
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "377",
    "name": "CNY Fertility Center",
    "address": {
      "id": "addr-377",
      "address1": "195 Intrepid Ln",
      "city": "Syracuse",
      "state": "NY",
      "postalCode": "13205",
      "country": "US"
    },
    "headline": "CNY Fertility Center",
    "images": [],
    "tags": [],
    "services": [
      "Acupuncture",
      "Yoga",
      "Massage therapy",
      "Nutrition counseling",
      "Counseling",
      "Wellness program",
      "Patient portal",
      "Outside monitoring"
    ],
    "languages": ["en"],
    "clinicType": "Network & group",
    "conditions": [
      "Male Factor",
      "Endometriosis",
      "Diminished ovarian reserve",
      "Recurrent pregnancy loss",
      "Unexplained infertility",
      "Tubal factor",
      "Ovulatory dysfunction",
      "Oncofertility"
    ],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Embryo Freezing",
      "PGT",
      "Ovulation Induction",
      "Sperm Freezing",
      "Donor programs",
      "Surrogacy",
      "Tubal / vasectomy reversal",
      "Fertility preservation",
      "Male factor"
    ],
    "website": "https://www.cnyfertility.com",
    "email": "hello@cnyfertility.com",
    "phone": "(315) 469-8700",
    "bookingUrl": "https://schedule.cnyfertility.com/",
    "location": {
      "latitude": 43.0023,
      "longitude": -76.1264
    },
    "insurances": [],
    "insuranceAccepted": true,
    "insuranceName": null,
    "financiers": [
      "Payment plans",
      "Discount pricing",
      "Package pricing",
      "Future Family",
      "CapexMD"
    ],
    "consultationTypes": ["In person", "Telehealth"],
    "patientGroups": ["LGBTQIA+", "Single Parents", "Same sex couples"],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 5750,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": "Known for making fertility treatment affordable with IVF cycles starting at $4,275 and in-house payment plans.",
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 28.1,
      "between35And37": 20.7,
      "between38And40": 15.2
    },
    "medicaldirector": "Robert J. Kiltz, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 37.6,
      "between35And37": 24.4,
      "between38And40": 14
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 42.857142857142854,
      "freshEmbryosFrozenEggs": 13.5,
      "frozenEmbryos": 25.8,
      "donatedEmbryos": 32.9
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFreshEggs": 14
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "75",
    "name": "Columbia University Fertility Center",
    "address": {
      "id": "addr-75",
      "address1": "5 Columbus Cir, PH Floor",
      "city": "New York",
      "state": "NY",
      "postalCode": "10019",
      "country": "US"
    },
    "headline": "Columbia University Fertility Center",
    "images": [],
    "tags": [],
    "services": [
      "Counseling",
      "Support groups",
      "Nutrition counseling",
      "Support resources",
      "Patient portal"
    ],
    "languages": ["en", "es"],
    "clinicType": "Hospital-based",
    "conditions": [
      "PCOS",
      "Endometriosis",
      "Male Factor",
      "Diminished ovarian reserve",
      "Recurrent pregnancy loss",
      "Oncofertility"
    ],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Embryo Freezing",
      "PGT",
      "Donor programs",
      "Fertility preservation"
    ],
    "website": "https://www.columbiadoctors.org/specialties/obstetrics-gynecology/our-services/columbia-university-fertility-center",
    "email": null,
    "phone": "(646) 756-8282",
    "bookingUrl": "https://www.columbiadoctors.org/specialties/obstetrics-gynecology/our-services/columbia-university-fertility-center/patients/make-appointment",
    "location": {
      "latitude": 40.7668,
      "longitude": -73.9815
    },
    "insurances": [],
    "insuranceAccepted": true,
    "insuranceName": null,
    "financiers": ["Payment plans", "Future Family"],
    "consultationTypes": ["In person", "Telehealth"],
    "patientGroups": ["LGBTQIA+", "Single Parents"],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 1571,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": "Ranked #1 by Newsweek, offering the personalized care of a boutique practice with the innovations of a leading academic center and over four decades of experience.",
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 53.7,
      "between35And37": 48.7,
      "between38And40": 50
    },
    "medicaldirector": "Eric J. Forman, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 52.9,
      "between35And37": 41,
      "between38And40": 23.3
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 43.5,
      "donatedEmbryos": 50
    },
    "donorSuccessRateDenominators": {
      "donatedEmbryos": 10
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "805",
    "name": "Extend Fertility",
    "address": {
      "id": "addr-805",
      "address1": "200 W. 57th St, Suite 1101",
      "city": "New York",
      "state": "NY",
      "postalCode": "10019",
      "country": "US"
    },
    "headline": "Extend Fertility",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(212) 810-2828",
    "bookingUrl": null,
    "location": {
      "latitude": 40.7654,
      "longitude": -73.9806
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 340,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 46.6,
      "between35And37": 52.4,
      "between38And40": 39.3
    },
    "medicaldirector": "Joshua U. Klein, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 52.9,
      "between35And37": 23.8,
      "between38And40": 30.4
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "836",
    "name": "Fertility New York",
    "address": {
      "id": "addr-836",
      "address1": "240 Central Park South, Suite 1P",
      "city": "New York",
      "state": "NY",
      "postalCode": "10019",
      "country": "US"
    },
    "headline": "Fertility New York",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(212) 535-5350",
    "bookingUrl": null,
    "location": {
      "latitude": 40.7671,
      "longitude": -73.9811
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 25,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "between35And37": 0,
      "between38And40": 0
    },
    "medicaldirector": "Amir R. Radjabi, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "between35And37": 0
    },
    "newPatientSuccessRateDenominators": {
      "between35And37": 5
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "802",
    "name": "Generation Next Fertility, PLLC",
    "address": {
      "id": "addr-802",
      "address1": "115 E. 57th St, 11th Floor",
      "city": "New York",
      "state": "NY",
      "postalCode": "10022",
      "country": "US"
    },
    "headline": "Generation Next Fertility, PLLC",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(212) 641-0906",
    "bookingUrl": null,
    "location": {
      "latitude": 40.7615,
      "longitude": -73.9699
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 744,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 37.5,
      "between35And37": 27.9,
      "between38And40": 38.8
    },
    "medicaldirector": "Janelle Luk, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 28.1,
      "between35And37": 17.1,
      "between38And40": 20.3
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 35.7
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "81",
    "name": "Genesis Fertility & Reproductive Medicine",
    "address": {
      "id": "addr-81",
      "address1": "6010 Bay Pkwy",
      "city": "Brooklyn",
      "state": "NY",
      "postalCode": "11204",
      "country": "US"
    },
    "headline": "Genesis Fertility & Reproductive Medicine",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(718) 436-3747",
    "bookingUrl": null,
    "location": {
      "latitude": 40.6166,
      "longitude": -73.979
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 618,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 37.8,
      "between35And37": 31.5,
      "between38And40": 32.6
    },
    "medicaldirector": "Richard V. Grazi, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 50,
      "between35And37": 29.7,
      "between38And40": 20.6
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 83.33333333333334,
      "frozenEmbryos": 26.4
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFreshEggs": 6
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "819",
    "name": "Global Fertility & Genetics, NY",
    "address": {
      "id": "addr-819",
      "address1": "115 E. 57th St, Suite 420-430",
      "city": "New York",
      "state": "NY",
      "postalCode": "10022",
      "country": "US"
    },
    "headline": "Global Fertility & Genetics, NY",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(646) 739-4956",
    "bookingUrl": null,
    "location": {
      "latitude": 40.7615,
      "longitude": -73.9699
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 119,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 48.5,
      "between35And37": 50,
      "between38And40": 35.714285714285715
    },
    "medicaldirector": "Melvin Thornton, MD",
    "clinicStatus": "Reorganized",
    "successRateDenominators": {
      "between38And40": 14
    },
    "newPatientSuccessRates": {
      "under35": 56,
      "between35And37": 55
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 33.8
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "78",
    "name": "Gold Coast IVF, Reproductive Medicine and Surgery Center",
    "address": {
      "id": "addr-78",
      "address1": "246 Crossways Park Dr West",
      "city": "Woodbury",
      "state": "NY",
      "postalCode": "11797",
      "country": "US"
    },
    "headline": "Gold Coast IVF, Reproductive Medicine and Surgery Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(516) 682-8900",
    "bookingUrl": null,
    "location": {
      "latitude": 40.8043,
      "longitude": -73.4877
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 219,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 53.6,
      "between35And37": 56.4,
      "between38And40": 35.3
    },
    "medicaldirector": "Steven F. Palter, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 59.3,
      "between35And37": 52,
      "between38And40": 23.1
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 66.66666666666666,
      "frozenEmbryos": 50,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFrozenEggs": 12,
      "frozenEmbryos": 16
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "259",
    "name": "Hudson Valley Fertility, PLLC",
    "address": {
      "id": "addr-259",
      "address1": "400 Westage Business Center Dr, Suite 109",
      "city": "Fishkill",
      "state": "NY",
      "postalCode": "12524",
      "country": "US"
    },
    "headline": "Hudson Valley Fertility, PLLC",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(845) 765-0125",
    "bookingUrl": null,
    "location": {
      "latitude": 41.5243,
      "longitude": -73.8965
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 171,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 45.2,
      "between35And37": 40.7,
      "between38And40": 19.2
    },
    "medicaldirector": "Daniel W. Levine, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 45.5,
      "between35And37": 22.2,
      "between38And40": 13.3
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "440",
    "name": "Infertility & IVF Medical Associates of Western New York, PLLC dba, Buffalo IVF",
    "address": {
      "id": "addr-440",
      "address1": "4510 Main St",
      "city": "Buffalo",
      "state": "NY",
      "postalCode": "14226",
      "country": "US"
    },
    "headline": "Infertility & IVF Medical Associates of Western New York, PLLC dba, Buffalo IVF",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(716) 839-3057",
    "bookingUrl": null,
    "location": {
      "latitude": 42.9639,
      "longitude": -78.7831
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 491,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 35.5,
      "between35And37": 30.6,
      "between38And40": 26.8
    },
    "medicaldirector": "Adam M. Griffin, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 43.5,
      "between35And37": 27.6,
      "between38And40": 21.1
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "835",
    "name": "Island Fertility, Stony Brook Community Medical, PC",
    "address": {
      "id": "addr-835",
      "address1": "500 Commack Rd, Suite 202",
      "city": "Commack",
      "state": "NY",
      "postalCode": "11725",
      "country": "US"
    },
    "headline": "Island Fertility, Stony Brook Community Medical, PC",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(631) 638-4600",
    "bookingUrl": null,
    "location": {
      "latitude": 40.8227,
      "longitude": -73.2917
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 650,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 48,
      "between35And37": 46.8,
      "between38And40": 21.6
    },
    "medicaldirector": "James R. Stelling, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 54.2,
      "between35And37": 47.8,
      "between38And40": 15.4
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "73",
    "name": "Island Reproductive Services, PC",
    "address": {
      "id": "addr-73",
      "address1": "237 Richmond Valley Rd",
      "city": "Staten Island",
      "state": "NY",
      "postalCode": "10309",
      "country": "US"
    },
    "headline": "Island Reproductive Services, PC",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(718) 948-6100",
    "bookingUrl": null,
    "location": {
      "latitude": 40.5216,
      "longitude": -74.2365
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 412,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 48,
      "between35And37": 35.5,
      "between38And40": 30.3
    },
    "medicaldirector": "Eric S. Knochenhauer, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 52.6,
      "between35And37": 32,
      "between38And40": 18.2
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "frozenEmbryos": 37.9
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "814",
    "name": "Kindbody-New York",
    "address": {
      "id": "addr-814",
      "address1": "16 E. 40th St, 2nd Floor",
      "city": "New York",
      "state": "NY",
      "postalCode": "10016",
      "country": "US"
    },
    "headline": "Kindbody-New York",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(855) 563-2639",
    "bookingUrl": null,
    "location": {
      "latitude": 40.737,
      "longitude": -73.9931
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 216,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 56.6,
      "between35And37": 53.3,
      "between38And40": 63
    },
    "medicaldirector": "Aimee Seungdamrong, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 48.8,
      "between35And37": 40.5,
      "between38And40": 25.9
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "337",
    "name": "Kofinas Fertility Group",
    "address": {
      "id": "addr-337",
      "address1": "65 Broadway, 14th Floor",
      "city": "New York",
      "state": "NY",
      "postalCode": "10006",
      "country": "US"
    },
    "headline": "Kofinas Fertility Group",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(212) 348-4000",
    "bookingUrl": null,
    "location": {
      "latitude": 40.7073,
      "longitude": -74.0126
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 435,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 68.8,
      "between35And37": 59.4,
      "between38And40": 54.9
    },
    "medicaldirector": "George D. Kofinas, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 59.5,
      "between35And37": 46.6,
      "between38And40": 27.1
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 54.5
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "25",
    "name": "Manhattan Reproductive Medicine",
    "address": {
      "id": "addr-25",
      "address1": "159 E. 74th St, Suite C",
      "city": "New York",
      "state": "NY",
      "postalCode": "10021",
      "country": "US"
    },
    "headline": "Manhattan Reproductive Medicine",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(212) 794-0080",
    "bookingUrl": null,
    "location": {
      "latitude": 40.7717,
      "longitude": -73.9605
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 16,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "between35And37": 0
    },
    "medicaldirector": "Hanna Jesionowska, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {},
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "421",
    "name": "Metropolitan Reproductive Medicine, PC",
    "address": {
      "id": "addr-421",
      "address1": "422 West End Ave",
      "city": "New York",
      "state": "NY",
      "postalCode": "10024",
      "country": "US"
    },
    "headline": "Metropolitan Reproductive Medicine, PC",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(212) 580-2252",
    "bookingUrl": null,
    "location": {
      "latitude": 40.7853,
      "longitude": -73.9803
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 17,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "between35And37": 0
    },
    "medicaldirector": "Susan Lobel, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "between35And37": 0
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "824",
    "name": "Mingxue Yang Medical, PC",
    "address": {
      "id": "addr-824",
      "address1": "1625 Third Ave",
      "city": "New York",
      "state": "NY",
      "postalCode": "10128",
      "country": "US"
    },
    "headline": "Mingxue Yang Medical, PC",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(212) 230-5711",
    "bookingUrl": null,
    "location": {
      "latitude": 40.7823,
      "longitude": -73.9512
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 484,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 77.4,
      "between35And37": 68.6,
      "between38And40": 38.7
    },
    "medicaldirector": "Mingxue Yang, MD, PHD",
    "clinicStatus": "Reorganized",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 60.4,
      "between35And37": 48.3,
      "between38And40": 13.6
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 64.28571428571429
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 14
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "293",
    "name": "Montefiore's Institute for Reproductive Medicine and Health",
    "address": {
      "id": "addr-293",
      "address1": "141 S. Central Ave, Suite 201",
      "city": "Hartsdale",
      "state": "NY",
      "postalCode": "10530",
      "country": "US"
    },
    "headline": "Montefiore's Institute for Reproductive Medicine and Health",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(914) 997-1060",
    "bookingUrl": null,
    "location": {
      "latitude": 41.0158,
      "longitude": -73.8029
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 180,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 41,
      "between35And37": 60.5,
      "between38And40": 27.3
    },
    "medicaldirector": "Harry J. Lieman, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 52,
      "between35And37": 51.5,
      "between38And40": 17.4
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "frozenEmbryos": 45.45454545454545
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 11
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "31",
    "name": "New Hope Fertility Center",
    "address": {
      "id": "addr-31",
      "address1": "4 Columbus Cir, 4th Floor",
      "city": "New York",
      "state": "NY",
      "postalCode": "10019",
      "country": "US"
    },
    "headline": "New Hope Fertility Center",
    "images": [],
    "tags": [],
    "services": [
      "Acupuncture",
      "Nutrition counseling",
      "Counseling",
      "Support resources"
    ],
    "languages": ["en", "es", "fr", "ja", "ko"],
    "clinicType": "Boutique",
    "conditions": [
      "PCOS",
      "Endometriosis",
      "Male Factor",
      "Diminished ovarian reserve",
      "Recurrent pregnancy loss",
      "Unexplained infertility",
      "Ovulatory dysfunction",
      "Oncofertility"
    ],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Embryo Freezing",
      "PGT",
      "Ovulation Induction",
      "Sperm Freezing",
      "Donor programs",
      "Surrogacy",
      "Fertility preservation",
      "Male factor",
      "miniIVF"
    ],
    "website": "https://www.newhopefertility.com",
    "email": null,
    "phone": "(212) 517-7676",
    "bookingUrl": "https://www.newhopefertility.com/start-fertility-treatment/",
    "location": {
      "latitude": 40.7674,
      "longitude": -73.9829
    },
    "insurances": [],
    "insuranceAccepted": true,
    "insuranceName": null,
    "financiers": ["Payment plans", "Loans", "Future Family", "CapexMD"],
    "consultationTypes": ["In person", "Telehealth"],
    "patientGroups": ["LGBTQIA+", "Single Parents", "Same sex couples"],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 3347,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": "Pioneer of Mini-IVF and Natural Cycle IVF, specializing in low-drug fertility solutions with over 15,000 babies born.",
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 31.9,
      "between35And37": 23.4,
      "between38And40": 26.7
    },
    "medicaldirector": "John Zhang, MD, PHD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 19.2,
      "between35And37": 10.3,
      "between38And40": 9.6
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 15,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "838",
    "name": "New York Fertility Medical Practice, PLLC dba, Shady Grove Fertility New York",
    "address": {
      "id": "addr-838",
      "address1": "110 E. 60th St, Suite 500",
      "city": "New York",
      "state": "NY",
      "postalCode": "10022",
      "country": "US"
    },
    "headline": "New York Fertility Medical Practice, PLLC dba, Shady Grove Fertility New York",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(646) 502-5450",
    "bookingUrl": null,
    "location": {
      "latitude": 40.7649,
      "longitude": -73.9726
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 487,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 62,
      "between35And37": 52.9,
      "between38And40": 33.3
    },
    "medicaldirector": "Anate Brauer, MD",
    "clinicStatus": "Reorganized",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 47.5,
      "between35And37": 34.3,
      "between38And40": 15.3
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "frozenEmbryos": 39.7
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "204",
    "name": "New York Reproductive Wellness",
    "address": {
      "id": "addr-204",
      "address1": "300 S. Oyster Bay Rd",
      "city": "Syosset",
      "state": "NY",
      "postalCode": "11791",
      "country": "US"
    },
    "headline": "New York Reproductive Wellness",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(516) 605-2626",
    "bookingUrl": null,
    "location": {
      "latitude": 40.7963,
      "longitude": -73.5034
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 191,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 55.1,
      "between35And37": 48,
      "between38And40": 42.9
    },
    "medicaldirector": "Gregory Zapantis, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 58.3,
      "between35And37": 45
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 75,
      "frozenEmbryos": 55.55555555555556,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFrozenEggs": 8,
      "frozenEmbryos": 9
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "619",
    "name": "Neway Medical",
    "address": {
      "id": "addr-619",
      "address1": "123 W. 79th St",
      "city": "New York",
      "state": "NY",
      "postalCode": "10024",
      "country": "US"
    },
    "headline": "Neway Medical",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(212) 750-3330",
    "bookingUrl": null,
    "location": {
      "latitude": 40.7825,
      "longitude": -73.9761
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 202,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 53.1,
      "between35And37": 66.66666666666666,
      "between38And40": 44.8
    },
    "medicaldirector": "Jeff Wang, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between35And37": 18
    },
    "newPatientSuccessRates": {
      "under35": 48.3,
      "between35And37": 47.368421052631575,
      "between38And40": 24
    },
    "newPatientSuccessRateDenominators": {
      "between35And37": 19
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "92",
    "name": "Northwell Health Fertility",
    "address": {
      "id": "addr-92",
      "address1": "300 Community Dr",
      "city": "Manhasset",
      "state": "NY",
      "postalCode": "11030",
      "country": "US"
    },
    "headline": "Northwell Health Fertility",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(516) 562-2229",
    "bookingUrl": null,
    "location": {
      "latitude": 40.7753,
      "longitude": -73.701
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 663,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 56.9,
      "between35And37": 50.5,
      "between38And40": 49
    },
    "medicaldirector": "Christine M. Mullin, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 55.9,
      "between35And37": 37.8,
      "between38And40": 32.1
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 44.44444444444444,
      "frozenEmbryos": 42.5,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFrozenEggs": 18
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "828",
    "name": "Northwell Health Fertility-NYC",
    "address": {
      "id": "addr-828",
      "address1": "210 E. 64th St, 1st Floor",
      "city": "New York",
      "state": "NY",
      "postalCode": "10065",
      "country": "US"
    },
    "headline": "Northwell Health Fertility-NYC",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(212) 324-2229",
    "bookingUrl": null,
    "location": {
      "latitude": 40.7641,
      "longitude": -73.9633
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 208,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 49.2,
      "between35And37": 43.6,
      "between38And40": 36.4
    },
    "medicaldirector": "Christine Mullin, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 50,
      "between35And37": 38.7,
      "between38And40": 31
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 45.45454545454545,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 11
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "822",
    "name": "NYC In Vitro Fertilization, PC",
    "address": {
      "id": "addr-822",
      "address1": "693 Fifth Ave, 7th Floor",
      "city": "New York",
      "state": "NY",
      "postalCode": "10022",
      "country": "US"
    },
    "headline": "NYC In Vitro Fertilization, PC",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(800) 853-7595",
    "bookingUrl": null,
    "location": {
      "latitude": 40.7612,
      "longitude": -73.9748
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 63,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 46.15384615384615,
      "between35And37": 50,
      "between38And40": 33.33333333333333
    },
    "medicaldirector": "Alyaa Elassar, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "under35": 13,
      "between35And37": 12,
      "between38And40": 15
    },
    "newPatientSuccessRates": {
      "under35": 55.55555555555556
    },
    "newPatientSuccessRateDenominators": {
      "under35": 9
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "46",
    "name": "NYU Langone Fertility Center",
    "address": {
      "id": "addr-46",
      "address1": "159 E. 53rd St, 3rd Floor",
      "city": "New York",
      "state": "NY",
      "postalCode": "10022",
      "country": "US"
    },
    "headline": "NYU Langone Fertility Center",
    "images": [],
    "tags": [],
    "services": [
      "Acupuncture",
      "Mind/Body",
      "Nutrition counseling",
      "Counseling",
      "Wellness program",
      "Patient portal",
      "Yoga"
    ],
    "languages": ["en", "es"],
    "clinicType": "Hospital-based",
    "conditions": [
      "PCOS",
      "Endometriosis",
      "Male Factor",
      "Recurrent pregnancy loss",
      "Oncofertility"
    ],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Embryo Freezing",
      "PGT",
      "Sperm Freezing",
      "Donor programs",
      "Surrogacy",
      "Fertility preservation"
    ],
    "website": "https://www.fertilityny.org",
    "email": null,
    "phone": "(212) 263-8990",
    "bookingUrl": "https://www.fertilityny.org/appointments",
    "location": {
      "latitude": 40.746,
      "longitude": -73.9715
    },
    "insurances": [],
    "insuranceAccepted": true,
    "insuranceName": null,
    "financiers": ["Payment plans"],
    "consultationTypes": ["In person", "Telehealth"],
    "patientGroups": ["LGBTQIA+", "Single Parents", "Same sex couples"],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 1883,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": "A pioneer in preimplantation genetic testing and egg freezing, offering a comprehensive wellness program with acupuncture, yoga, nutrition, and mind-body classes.",
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 58.9,
      "between35And37": 57.6,
      "between38And40": 55.3
    },
    "medicaldirector": "James A. Grifo, MD, PHD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 50.2,
      "between35And37": 37.3,
      "between38And40": 30.3
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 48.3,
      "frozenEmbryos": 49.4,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "64",
    "name": "NYU Langone Reproductive Specialists of New York",
    "address": {
      "id": "addr-64",
      "address1": "200 Old Country Rd, Suite 350",
      "city": "Mineola",
      "state": "NY",
      "postalCode": "11501",
      "country": "US"
    },
    "headline": "NYU Langone Reproductive Specialists of New York",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(516) 739-2100",
    "bookingUrl": null,
    "location": {
      "latitude": 40.7395,
      "longitude": -73.6389
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 556,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 50.7,
      "between35And37": 48.8,
      "between38And40": 38.3
    },
    "medicaldirector": "Maria Saketos, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 58,
      "between35And37": 52.6,
      "between38And40": 28.4
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 69.23076923076923,
      "frozenEmbryos": 30,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFrozenEggs": 13
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "877",
    "name": "Rejuvenating Fertility Center-New York",
    "address": {
      "id": "addr-877",
      "address1": "315 W. 57th St, Suite 208",
      "city": "New York",
      "state": "NY",
      "postalCode": "10019",
      "country": "US"
    },
    "headline": "Rejuvenating Fertility Center-New York",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(203) 557-9696",
    "bookingUrl": null,
    "location": {
      "latitude": 40.7673,
      "longitude": -73.9838
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 952,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 8.3,
      "between35And37": 5.3,
      "between38And40": 2.3
    },
    "medicaldirector": "Zaher O. Merhi, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 2.3,
      "between35And37": 0,
      "between38And40": 2.2
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {},
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "130",
    "name": "Reproductive Medicine Associates of New York, LLP",
    "address": {
      "id": "addr-130",
      "address1": "635 Madison Ave, 10th Floor",
      "city": "New York",
      "state": "NY",
      "postalCode": "10022",
      "country": "US"
    },
    "headline": "Reproductive Medicine Associates of New York, LLP",
    "images": [],
    "tags": [],
    "services": [
      "Counseling",
      "Support groups",
      "Nutrition counseling",
      "Concierge service",
      "Wellness program",
      "Patient portal",
      "Support resources",
      "Yoga",
      "Acupuncture"
    ],
    "languages": ["en"],
    "clinicType": "Hospital-based",
    "conditions": [
      "PCOS",
      "Endometriosis",
      "Male factor",
      "Recurrent pregnancy loss",
      "Unexplained infertility",
      "Oncofertility",
      "Uterine factor"
    ],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Embryo Freezing",
      "PGT",
      "Sperm Freezing",
      "Donor programs",
      "Surrogacy",
      "Fertility preservation",
      "Male factor"
    ],
    "website": "https://www.rmany.com/",
    "email": null,
    "phone": "(212) 756-5777",
    "bookingUrl": "https://www.rmany.com/appointments",
    "location": {
      "latitude": 40.7637,
      "longitude": -73.971
    },
    "insurances": [],
    "insuranceAccepted": true,
    "insuranceName": null,
    "financiers": [
      "Payment plans",
      "Loans",
      "Package pricing",
      "CapexMD",
      "Future Family",
      "PatientFi",
      "Gaia"
    ],
    "consultationTypes": ["In person", "Telehealth"],
    "patientGroups": ["LGBTQIA+", "Single Parents", "Same sex couples"],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 2247,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": "Division of Reproductive Endocrinology at Mount Sinai, operating 14 offices and 4 IVF labs across the NYC metro area with a dedicated oncofertility and male reproductive health center.",
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 50.6,
      "between35And37": 54.1,
      "between38And40": 51.5
    },
    "medicaldirector": "Eric Flisser, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 55,
      "between35And37": 45.8,
      "between38And40": 33.9
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 52.9,
      "frozenEmbryos": 48.7,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "306",
    "name": "RMA Long Island IVF",
    "address": {
      "id": "addr-306",
      "address1": "8 Corporate Center Dr, Suite 101",
      "city": "Melville",
      "state": "NY",
      "postalCode": "11747",
      "country": "US"
    },
    "headline": "RMA Long Island IVF",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(631) 752-0606",
    "bookingUrl": null,
    "location": {
      "latitude": 40.7748,
      "longitude": -73.4075
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 1136,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 44.8,
      "between35And37": 45.8,
      "between38And40": 38.6
    },
    "medicaldirector": "Beth McAvey, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 45.7,
      "between35And37": 38.9,
      "between38And40": 21.9
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 50,
      "frozenEmbryos": 36.8
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "127",
    "name": "Rochester Regional Health Fertility Care",
    "address": {
      "id": "addr-127",
      "address1": "1561 Long Pond Rd, Suite 410",
      "city": "Rochester",
      "state": "NY",
      "postalCode": "14626",
      "country": "US"
    },
    "headline": "Rochester Regional Health Fertility Care",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(585) 453-7760",
    "bookingUrl": null,
    "location": {
      "latitude": 43.1921,
      "longitude": -77.7047
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 97,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 36.9,
      "between35And37": 23.1
    },
    "medicaldirector": "Jamil Mroueh, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 35.9
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "627",
    "name": "Sher Fertility Solutions-New York",
    "address": {
      "id": "addr-627",
      "address1": "425 Fifth Ave, 3rd Floor",
      "city": "New York",
      "state": "NY",
      "postalCode": "10016",
      "country": "US"
    },
    "headline": "Sher Fertility Solutions-New York",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(646) 792-7476",
    "bookingUrl": null,
    "location": {
      "latitude": 40.751,
      "longitude": -73.9825
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 298,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 20.8,
      "between35And37": 30
    },
    "medicaldirector": "Drew V. Tortoriello, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {},
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "880",
    "name": "Spring Fertility-New York",
    "address": {
      "id": "addr-880",
      "address1": "114 W. 41st St, 2nd Floor",
      "city": "New York",
      "state": "NY",
      "postalCode": "10036",
      "country": "US"
    },
    "headline": "Spring Fertility-New York",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(646) 568-5638",
    "bookingUrl": null,
    "location": {
      "latitude": 40.7545,
      "longitude": -73.9855
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 33,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 55.55555555555556,
      "between35And37": 0
    },
    "medicaldirector": "Catha Fischer, MD",
    "clinicStatus": "Reorganized",
    "successRateDenominators": {
      "under35": 9,
      "between35And37": 5
    },
    "newPatientSuccessRates": {
      "under35": 55.55555555555556
    },
    "newPatientSuccessRateDenominators": {
      "under35": 9
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "357",
    "name": "Strong Fertility Center",
    "address": {
      "id": "addr-357",
      "address1": "500 Red Creek Dr, Suite 220",
      "city": "Rochester",
      "state": "NY",
      "postalCode": "14623",
      "country": "US"
    },
    "headline": "Strong Fertility Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(585) 487-3378",
    "bookingUrl": null,
    "location": {
      "latitude": 43.0645,
      "longitude": -77.6303
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 460,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 35.6,
      "between35And37": 29.3,
      "between38And40": 29.3
    },
    "medicaldirector": "Erin M. Masaba, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 51.6,
      "between35And37": 34.5,
      "between38And40": 27.8
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "frozenEmbryos": 27.3,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "113",
    "name": "The New York Fertility Center",
    "address": {
      "id": "addr-113",
      "address1": "42-31 Colden St, Suite 202",
      "city": "Flushing",
      "state": "NY",
      "postalCode": "11355",
      "country": "US"
    },
    "headline": "The New York Fertility Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(718) 261-9068",
    "bookingUrl": null,
    "location": {
      "latitude": 40.7539,
      "longitude": -73.8262
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 332,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 26,
      "between35And37": 20.6,
      "between38And40": 10.2
    },
    "medicaldirector": "Tony Tsai, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 22.7,
      "between35And37": 20,
      "between38And40": 9.7
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "437",
    "name": "Weill Cornell Medicine, Center for Reproductive Medicine",
    "address": {
      "id": "addr-437",
      "address1": "1305 York Ave, 6th Floor",
      "city": "New York",
      "state": "NY",
      "postalCode": "10021",
      "country": "US"
    },
    "headline": "Weill Cornell Medicine, Center for Reproductive Medicine",
    "images": [],
    "tags": [],
    "services": [
      "Acupuncture",
      "Massage therapy",
      "Nutrition counseling",
      "Yoga",
      "Counseling",
      "Patient portal",
      "Support resources"
    ],
    "languages": ["en", "es"],
    "clinicType": "Hospital-based",
    "conditions": [
      "PCOS",
      "Endometriosis",
      "Male Factor",
      "Diminished ovarian reserve",
      "Recurrent pregnancy loss",
      "Unexplained infertility",
      "Tubal factor",
      "Ovulatory dysfunction",
      "Uterine factor",
      "Oncofertility"
    ],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Embryo Freezing",
      "PGT",
      "Sperm Freezing",
      "Donor programs",
      "Surrogacy",
      "Fertility preservation",
      "Male factor"
    ],
    "website": "https://ivf.org",
    "email": null,
    "phone": "(646) 962-2764",
    "bookingUrl": "https://ivf.org/contact-us",
    "location": {
      "latitude": 40.7655,
      "longitude": -73.9552
    },
    "insurances": [],
    "insuranceAccepted": true,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": ["In person", "Telehealth"],
    "patientGroups": ["LGBTQIA+", "Single Parents", "Same sex couples"],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 3311,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": "Academic medical center affiliated with NewYork-Presbyterian, with over 21,000 IVF babies born and its own PGT and reproductive endocrinology labs.",
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 46.6,
      "between35And37": 42.2,
      "between38And40": 33.7
    },
    "medicaldirector": "Zev Rosenwaks, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 51.8,
      "between35And37": 37.3,
      "between38And40": 29.1
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 50,
      "freshEmbryosFrozenEggs": 53.3,
      "frozenEmbryos": 45.2,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFreshEggs": 12
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "47",
    "name": "Westchester Fertility & Reproductive Endocrinology",
    "address": {
      "id": "addr-47",
      "address1": "136 S. Broadway",
      "city": "White Plains",
      "state": "NY",
      "postalCode": "10605",
      "country": "US"
    },
    "headline": "Westchester Fertility & Reproductive Endocrinology",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(914) 949-6677",
    "bookingUrl": null,
    "location": {
      "latitude": 41.0262,
      "longitude": -73.7612
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 125,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 23.1,
      "between35And37": 36
    },
    "medicaldirector": "Michael B. Blotner, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 33.33333333333333
    },
    "newPatientSuccessRateDenominators": {
      "under35": 18
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "625",
    "name": "Westmed Reproductive Services",
    "address": {
      "id": "addr-625",
      "address1": "3030 Westchester Ave",
      "city": "Purchase",
      "state": "NY",
      "postalCode": "10577",
      "country": "US"
    },
    "headline": "Westmed Reproductive Services",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(914) 607-6213",
    "bookingUrl": null,
    "location": {
      "latitude": 41.0095,
      "longitude": -73.6963
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 299,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 47.7,
      "between35And37": 52.9,
      "between38And40": 41.9
    },
    "medicaldirector": "Martin D. Keltz, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 60.6,
      "between35And37": 47.1,
      "between38And40": 21.1
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 60,
      "frozenEmbryos": 54.54545454545454
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFrozenEggs": 10,
      "frozenEmbryos": 11
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "895",
    "name": "Your Family Fertility",
    "address": {
      "id": "addr-895",
      "address1": "630 Frankhauser",
      "city": "Williamsville",
      "state": "NY",
      "postalCode": "14221",
      "country": "US"
    },
    "headline": "Your Family Fertility",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(716) 243-8377",
    "bookingUrl": null,
    "location": {
      "latitude": 43.0004,
      "longitude": -78.8009
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 11,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 0,
      "between35And37": 0,
      "between38And40": 0
    },
    "medicaldirector": "Krystene B. DiPaola, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 0,
      "between35And37": 0,
      "between38And40": 0
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 54.54545454545454,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 11
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "285",
    "name": "Bethesda Fertility Center",
    "address": {
      "id": "addr-285",
      "address1": "10506 Montgomery Rd, Suite 303",
      "city": "Cincinnati",
      "state": "OH",
      "postalCode": "45242",
      "country": "US"
    },
    "headline": "Bethesda Fertility Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(513) 865-1675",
    "bookingUrl": null,
    "location": {
      "latitude": 39.2513,
      "longitude": -84.3405
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 192,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 43.8,
      "between35And37": 52.6,
      "between38And40": 18.2
    },
    "medicaldirector": "Isela M. Robertshaw, MD",
    "clinicStatus": "Reorganized",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 45.2,
      "between35And37": 50
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "donatedEmbryos": 33.3
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "380",
    "name": "Cleveland Clinic Fertility Center",
    "address": {
      "id": "addr-380",
      "address1": "26900 Cedar Rd, Suite 220S",
      "city": "Beachwood",
      "state": "OH",
      "postalCode": "44122",
      "country": "US"
    },
    "headline": "Cleveland Clinic Fertility Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(216) 839-3150",
    "bookingUrl": null,
    "location": {
      "latitude": 41.5005,
      "longitude": -81.4892
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 557,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 56.6,
      "between35And37": 47.3,
      "between38And40": 45.8
    },
    "medicaldirector": "Marjan Attaran, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 59,
      "between35And37": 38.4,
      "between38And40": 27.9
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 43.9
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "143",
    "name": "Institute for Reproductive Health",
    "address": {
      "id": "addr-143",
      "address1": "3805 Edwards Rd, Suite 450",
      "city": "Cincinnati",
      "state": "OH",
      "postalCode": "45209",
      "country": "US"
    },
    "headline": "Institute for Reproductive Health",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(513) 924-5546",
    "bookingUrl": null,
    "location": {
      "latitude": 39.1484,
      "longitude": -84.444
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 869,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 43.4,
      "between35And37": 37.1,
      "between38And40": 38.5
    },
    "medicaldirector": "Michael D. Scheiber, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 59.7,
      "between35And37": 42.2,
      "between38And40": 30.3
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 58.3,
      "frozenEmbryos": 41
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "136",
    "name": "Ohio Reproductive Medicine",
    "address": {
      "id": "addr-136",
      "address1": "535 Reach Blvd, Suite 200",
      "city": "Columbus",
      "state": "OH",
      "postalCode": "43215",
      "country": "US"
    },
    "headline": "Ohio Reproductive Medicine",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(614) 451-2280",
    "bookingUrl": null,
    "location": {
      "latitude": 40.0585,
      "longitude": -83.0381
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 534,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 33.3,
      "between35And37": 33.7,
      "between38And40": 20.7
    },
    "medicaldirector": "Grant E. Schmidt, MD, PHD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 38.4,
      "between35And37": 30,
      "between38And40": 14.5
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 60,
      "frozenEmbryos": 72.72727272727273
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFreshEggs": 10,
      "frozenEmbryos": 11
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "382",
    "name": "Reproductive Gynecology & Infertility-Akron",
    "address": {
      "id": "addr-382",
      "address1": "95 Arch St, Suite 250",
      "city": "Akron",
      "state": "OH",
      "postalCode": "44304",
      "country": "US"
    },
    "headline": "Reproductive Gynecology & Infertility-Akron",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(330) 375-7722",
    "bookingUrl": null,
    "location": {
      "latitude": 41.0823,
      "longitude": -81.4995
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 671,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 55,
      "between35And37": 49.1,
      "between38And40": 51.8
    },
    "medicaldirector": "David M. Nash, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 57,
      "between35And37": 36.8,
      "between38And40": 38
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 54.8
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "262",
    "name": "Reproductive Gynecology & Infertility-Westerville",
    "address": {
      "id": "addr-262",
      "address1": "540 N. Cleveland Ave, Suite 100",
      "city": "Westerville",
      "state": "OH",
      "postalCode": "43082",
      "country": "US"
    },
    "headline": "Reproductive Gynecology & Infertility-Westerville",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(614) 895-3333",
    "bookingUrl": null,
    "location": {
      "latitude": 40.1404,
      "longitude": -82.9466
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 482,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 59.8,
      "between35And37": 57.6,
      "between38And40": 47.2
    },
    "medicaldirector": "David M. Nash, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 65.3,
      "between35And37": 45,
      "between38And40": 32.7
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 65.1
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "618",
    "name": "SpringCreek Fertility",
    "address": {
      "id": "addr-618",
      "address1": "7095 Clyo Rd",
      "city": "Dayton",
      "state": "OH",
      "postalCode": "45459",
      "country": "US"
    },
    "headline": "SpringCreek Fertility",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(937) 458-5084",
    "bookingUrl": null,
    "location": {
      "latitude": 39.6422,
      "longitude": -84.1389
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 349,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 42.4,
      "between35And37": 50,
      "between38And40": 28.9
    },
    "medicaldirector": "Jeremy M. Groll, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 48.2,
      "between35And37": 43.9,
      "between38And40": 25.7
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 61.53846153846154,
      "frozenEmbryos": 32.4
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFrozenEggs": 13
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "528",
    "name": "The Fertility Wellness Institute of Ohio",
    "address": {
      "id": "addr-528",
      "address1": "7671 Tylers Place Blvd",
      "city": "West Chester",
      "state": "OH",
      "postalCode": "45069",
      "country": "US"
    },
    "headline": "The Fertility Wellness Institute of Ohio",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(513) 326-4300",
    "bookingUrl": null,
    "location": {
      "latitude": 39.3588,
      "longitude": -84.3766
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 231,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 42.7,
      "between35And37": 38.8,
      "between38And40": 20.8
    },
    "medicaldirector": "Neeoo W. Chin, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 47.1,
      "between35And37": 33.3
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "355",
    "name": "UC Center for Reproductive Health",
    "address": {
      "id": "addr-355",
      "address1": "7675 Wellness Way, Suite 315",
      "city": "West Chester",
      "state": "OH",
      "postalCode": "45069",
      "country": "US"
    },
    "headline": "UC Center for Reproductive Health",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(513) 475-7600",
    "bookingUrl": null,
    "location": {
      "latitude": 39.358,
      "longitude": -84.368
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 177,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 51,
      "between35And37": 27.3,
      "between38And40": 44.4
    },
    "medicaldirector": "Emily G. Hurley, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 59,
      "between35And37": 25,
      "between38And40": 29.6
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "frozenEmbryos": 35.714285714285715,
      "donatedEmbryos": 30.3
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 14
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "331",
    "name": "University Hospitals Fertility Center",
    "address": {
      "id": "addr-331",
      "address1": "Kathy Risman Pavilion, 1000 Auburn Dr, Suite 310",
      "city": "Beachwood",
      "state": "OH",
      "postalCode": "44122",
      "country": "US"
    },
    "headline": "University Hospitals Fertility Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(216) 285-5028",
    "bookingUrl": null,
    "location": {
      "latitude": 41.4526,
      "longitude": -81.495
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 390,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 53.4,
      "between35And37": 39.4,
      "between38And40": 42.9
    },
    "medicaldirector": "Rebecca Flyckt, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 60,
      "between35And37": 43.8,
      "between38And40": 22.5
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 56.5
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "892",
    "name": "Mate Fertility",
    "address": {
      "id": "addr-892",
      "address1": "3427 N.W. 50th St",
      "city": "Oklahoma City",
      "state": "OK",
      "postalCode": "73112",
      "country": "US"
    },
    "headline": "Mate Fertility",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(405) 930-3483",
    "bookingUrl": null,
    "location": {
      "latitude": 35.5225,
      "longitude": -97.5781
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 26,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 50
    },
    "medicaldirector": "Shaurin Patel, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "under35": 12
    },
    "newPatientSuccessRates": {
      "under35": 42.857142857142854
    },
    "newPatientSuccessRateDenominators": {
      "under35": 14
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "9",
    "name": "OU Health Reproductive Medicine",
    "address": {
      "id": "addr-9",
      "address1": "840 Research Pkwy, Suite 200",
      "city": "Oklahoma City",
      "state": "OK",
      "postalCode": "73104",
      "country": "US"
    },
    "headline": "OU Health Reproductive Medicine",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(405) 271-1616",
    "bookingUrl": null,
    "location": {
      "latitude": 35.4775,
      "longitude": -97.5009
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 309,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 48,
      "between35And37": 37,
      "between38And40": 29.5
    },
    "medicaldirector": "LaTasha B. Craig, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 67.3,
      "between35And37": 52.2,
      "between38And40": 17.4
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 50
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFrozenEggs": 12
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "111",
    "name": "Tulsa Fertility Center",
    "address": {
      "id": "addr-111",
      "address1": "115 E. 15th St",
      "city": "Tulsa",
      "state": "OK",
      "postalCode": "74119",
      "country": "US"
    },
    "headline": "Tulsa Fertility Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(918) 584-2870",
    "bookingUrl": null,
    "location": {
      "latitude": 36.1412,
      "longitude": -95.9843
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 171,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 47.4,
      "between35And37": 32.1
    },
    "medicaldirector": "Stanley G. Prough, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 33.3,
      "between35And37": 25
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 66.66666666666666
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 12
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "812",
    "name": "Oregon Fertility Institute",
    "address": {
      "id": "addr-812",
      "address1": "9370 S.W. Greenburg Rd, Suite 412",
      "city": "Portland",
      "state": "OR",
      "postalCode": "97223",
      "country": "US"
    },
    "headline": "Oregon Fertility Institute",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(503) 292-7734",
    "bookingUrl": null,
    "location": {
      "latitude": 45.4521,
      "longitude": -122.773
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 61,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 53.333333333333336
    },
    "medicaldirector": "Aimee Chang, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "under35": 15
    },
    "newPatientSuccessRates": {
      "under35": 45.45454545454545
    },
    "newPatientSuccessRateDenominators": {
      "under35": 11
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "272",
    "name": "ORM Fertility-Portland",
    "address": {
      "id": "addr-272",
      "address1": "808 S.W. 15th Ave",
      "city": "Portland",
      "state": "OR",
      "postalCode": "97205",
      "country": "US"
    },
    "headline": "ORM Fertility-Portland",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(503) 274-4994",
    "bookingUrl": null,
    "location": {
      "latitude": 45.5205,
      "longitude": -122.687
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 720,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 62.4,
      "between35And37": 54.9,
      "between38And40": 52.9
    },
    "medicaldirector": "John S. Hesla, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 59.2,
      "between35And37": 50.4,
      "between38And40": 33.3
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "frozenEmbryos": 56.6,
      "donatedEmbryos": 53
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "411",
    "name": "The Fertility Center of Oregon",
    "address": {
      "id": "addr-411",
      "address1": "590 Country Club Pkwy, Suite A",
      "city": "Eugene",
      "state": "OR",
      "postalCode": "97401",
      "country": "US"
    },
    "headline": "The Fertility Center of Oregon",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(541) 272-6266",
    "bookingUrl": null,
    "location": {
      "latitude": 44.0639,
      "longitude": -123.092
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 165,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 38.3,
      "between35And37": 37.9,
      "between38And40": 42.3
    },
    "medicaldirector": "Douglas J. Austin, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 52.2,
      "between35And37": 36.84210526315789,
      "between38And40": 45.5
    },
    "newPatientSuccessRateDenominators": {
      "between35And37": 19
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 100,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 52.63157894736842
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFreshEggs": 6,
      "frozenEmbryos": 19
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "517",
    "name": "University Fertility Consultants, Oregon Health & Science University",
    "address": {
      "id": "addr-517",
      "address1": "OHSU Center for Health & Healing, 3303 S.W. Bond Ave, 10th Floor",
      "city": "Portland",
      "state": "OR",
      "postalCode": "97239",
      "country": "US"
    },
    "headline": "University Fertility Consultants, Oregon Health & Science University",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(503) 418-3700",
    "bookingUrl": null,
    "location": {
      "latitude": 45.4985,
      "longitude": -122.671
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 410,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 50,
      "between35And37": 44.2,
      "between38And40": 50
    },
    "medicaldirector": "Diana H. Wu, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 53.9,
      "between35And37": 41.1,
      "between38And40": 40
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "frozenEmbryos": 47.8,
      "donatedEmbryos": 37.5
    },
    "donorSuccessRateDenominators": {
      "donatedEmbryos": 16
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "628",
    "name": "AHN Center for Reproductive Medicine",
    "address": {
      "id": "addr-628",
      "address1": "200 Quinn Drive, Suite 120",
      "city": "Pittsburgh",
      "state": "PA",
      "postalCode": "15275",
      "country": "US"
    },
    "headline": "AHN Center for Reproductive Medicine",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(412) 847-1166",
    "bookingUrl": null,
    "location": {
      "latitude": 40.5738,
      "longitude": -80.0249
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 177,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 44.9,
      "between35And37": 26.5
    },
    "medicaldirector": "Lori Homa, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 46,
      "between35And37": 24.2
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "142",
    "name": "Family Fertility Center",
    "address": {
      "id": "addr-142",
      "address1": "95 Highland Ave, Suite 100",
      "city": "Bethlehem",
      "state": "PA",
      "postalCode": "18017",
      "country": "US"
    },
    "headline": "Family Fertility Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(610) 868-8600",
    "bookingUrl": null,
    "location": {
      "latitude": 40.6672,
      "longitude": -75.3845
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 84,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 58.8,
      "between35And37": 68.42105263157895,
      "between38And40": 38.46153846153847
    },
    "medicaldirector": "H. Christina Lee, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between35And37": 19,
      "between38And40": 13
    },
    "newPatientSuccessRates": {
      "under35": 65.5,
      "between35And37": 52.94117647058824
    },
    "newPatientSuccessRateDenominators": {
      "between35And37": 17
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "409",
    "name": "Geisinger Medical Center Fertility Program",
    "address": {
      "id": "addr-409",
      "address1": "100 N. Academy Ave",
      "city": "Danville",
      "state": "PA",
      "postalCode": "17822",
      "country": "US"
    },
    "headline": "Geisinger Medical Center Fertility Program",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(570) 271-5620",
    "bookingUrl": null,
    "location": {
      "latitude": 40.9678,
      "longitude": -76.6053
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 215,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 42.5,
      "between35And37": 43.3,
      "between38And40": 30.4
    },
    "medicaldirector": "Jennifer Gell, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 41.2,
      "between35And37": 33.3,
      "between38And40": 12
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "167",
    "name": "Main Line Fertility & Reproductive Medicine",
    "address": {
      "id": "addr-167",
      "address1": "825 Old Lancaster Rd, Suite 170",
      "city": "Bryn Mawr",
      "state": "PA",
      "postalCode": "19010",
      "country": "US"
    },
    "headline": "Main Line Fertility & Reproductive Medicine",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(484) 380-4879",
    "bookingUrl": null,
    "location": {
      "latitude": 40.0205,
      "longitude": -75.3214
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 1032,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 47.9,
      "between35And37": 42,
      "between38And40": 37.5
    },
    "medicaldirector": "Michael J. Glassner, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 41.5,
      "between35And37": 36.7,
      "between38And40": 28
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 40,
      "frozenEmbryos": 47.5,
      "donatedEmbryos": 28.6
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFrozenEggs": 15
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "872",
    "name": "Penn Fertility Care-Lancaster General Health",
    "address": {
      "id": "addr-872",
      "address1": "2112 Harrisburg Pike, Suite 110",
      "city": "Lancaster",
      "state": "PA",
      "postalCode": "17601",
      "country": "US"
    },
    "headline": "Penn Fertility Care-Lancaster General Health",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(717) 544-0107",
    "bookingUrl": null,
    "location": {
      "latitude": 40.0646,
      "longitude": -76.3557
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 26,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {},
    "medicaldirector": "Christine C. Skiadas, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {},
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "6",
    "name": "Penn State Milton S. Hershey Medical Center",
    "address": {
      "id": "addr-6",
      "address1": "35 Hope Dr, Suite 202",
      "city": "Hershey",
      "state": "PA",
      "postalCode": "17033",
      "country": "US"
    },
    "headline": "Penn State Milton S. Hershey Medical Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(717) 531-6731",
    "bookingUrl": null,
    "location": {
      "latitude": 40.2702,
      "longitude": -76.6611
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 99,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 51.5,
      "between35And37": 45
    },
    "medicaldirector": "Samantha Butts, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 56.8,
      "between35And37": 38.88888888888889
    },
    "newPatientSuccessRateDenominators": {
      "between35And37": 18
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "146",
    "name": "Reproductive Medicine Associates of Philadelphia",
    "address": {
      "id": "addr-146",
      "address1": "625 Clark Ave, Suite 17B",
      "city": "King Of Prussia",
      "state": "PA",
      "postalCode": "19406",
      "country": "US"
    },
    "headline": "Reproductive Medicine Associates of Philadelphia",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(215) 654-1544",
    "bookingUrl": null,
    "location": {
      "latitude": 40.0973,
      "longitude": -75.4032
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 798,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 57.6,
      "between35And37": 54.8,
      "between38And40": 46.7
    },
    "medicaldirector": "Arthur J. Castelbaum, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 66.9,
      "between35And37": 57.8,
      "between38And40": 32
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 47.1,
      "donatedEmbryos": 27.77777777777778
    },
    "donorSuccessRateDenominators": {
      "donatedEmbryos": 18
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "2",
    "name": "Shady Grove Fertility-Pennsylvania",
    "address": {
      "id": "addr-2",
      "address1": "945 Chesterbrook Blvd",
      "city": "Wayne",
      "state": "PA",
      "postalCode": "19087",
      "country": "US"
    },
    "headline": "Shady Grove Fertility-Pennsylvania",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(610) 981-6000",
    "bookingUrl": null,
    "location": {
      "latitude": 40.0681,
      "longitude": -75.4619
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 985,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 46,
      "between35And37": 44.1,
      "between38And40": 43.1
    },
    "medicaldirector": "Isaac E. Sasson, MD, PHD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 61.1,
      "between35And37": 51.2,
      "between38And40": 31.4
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 53.8,
      "freshEmbryosFrozenEggs": 50,
      "frozenEmbryos": 44.3,
      "donatedEmbryos": 34.1
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFrozenEggs": 10
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "8",
    "name": "Society Hill Reproductive Medicine",
    "address": {
      "id": "addr-8",
      "address1": "822 Pine St, Suite 4B",
      "city": "Philadelphia",
      "state": "PA",
      "postalCode": "19107",
      "country": "US"
    },
    "headline": "Society Hill Reproductive Medicine",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(215) 829-8110",
    "bookingUrl": null,
    "location": {
      "latitude": 39.9443,
      "longitude": -75.1561
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 65,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 44.44444444444444
    },
    "medicaldirector": "Maureen P. Kelly, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "under35": 18
    },
    "newPatientSuccessRates": {
      "under35": 53.333333333333336
    },
    "newPatientSuccessRateDenominators": {
      "under35": 15
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "398",
    "name": "University of Pennsylvania, Penn Fertility Care",
    "address": {
      "id": "addr-398",
      "address1": "3701 Market St, Suite 800",
      "city": "Philadelphia",
      "state": "PA",
      "postalCode": "19104",
      "country": "US"
    },
    "headline": "University of Pennsylvania, Penn Fertility Care",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(215) 662-6100",
    "bookingUrl": null,
    "location": {
      "latitude": 39.9568,
      "longitude": -75.1961
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 831,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 51.6,
      "between35And37": 43.2,
      "between38And40": 33.6
    },
    "medicaldirector": "Clarisa R. Gracia, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 55.2,
      "between35And37": 49.6,
      "between38And40": 26.6
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 46.15384615384615,
      "frozenEmbryos": 41.9
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFrozenEggs": 13
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "168",
    "name": "University of Pittsburgh Physicians, Center for Fertility and Reproductive Endocrinology",
    "address": {
      "id": "addr-168",
      "address1": "Magee Womens Hospital, 300 Halket St, Suite 5150",
      "city": "Pittsburgh",
      "state": "PA",
      "postalCode": "15213",
      "country": "US"
    },
    "headline": "University of Pittsburgh Physicians, Center for Fertility and Reproductive Endocrinology",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(412) 731-8000",
    "bookingUrl": null,
    "location": {
      "latitude": 40.437,
      "longitude": -79.9607
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 381,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 44.4,
      "between35And37": 47.6,
      "between38And40": 32.4
    },
    "medicaldirector": "Julie M. Rios, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 54,
      "between35And37": 58.8,
      "between38And40": 27.8
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 55.6,
      "frozenEmbryos": 66.7
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "274",
    "name": "Clinica de Fertilidad HIMA-San Pablo Caguas",
    "address": {
      "id": "addr-274",
      "address1": "Ave Muñoz Rivera, A-1, Suite 303",
      "city": "Caguas",
      "state": "PR",
      "postalCode": "726",
      "country": "US"
    },
    "headline": "Clinica de Fertilidad HIMA-San Pablo Caguas",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(787) 653-3775",
    "bookingUrl": null,
    "location": {
      "latitude": 18.2468,
      "longitude": -66.0358
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 54,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 50
    },
    "medicaldirector": "Jose R. Cruz, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "under35": 12
    },
    "newPatientSuccessRates": {
      "under35": 50
    },
    "newPatientSuccessRateDenominators": {
      "under35": 12
    },
    "donorSuccessRates": {
      "frozenEmbryos": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "145",
    "name": "GREFI, Gynecology, Reproductive Endocrinology & Fertility Institute",
    "address": {
      "id": "addr-145",
      "address1": "First Bank Building, 1519 Ponce de León Ave, Suite 705",
      "city": "San Juan",
      "state": "PR",
      "postalCode": "909",
      "country": "US"
    },
    "headline": "GREFI, Gynecology, Reproductive Endocrinology & Fertility Institute",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(787) 984-3008",
    "bookingUrl": null,
    "location": {
      "latitude": 18.4418,
      "longitude": -66.0706
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 5,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 26.8,
      "between35And37": 17.4,
      "between38And40": 12
    },
    "medicaldirector": "Rosa Ileana Cruz, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 29.5,
      "between35And37": 15,
      "between38And40": 13.6
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "338",
    "name": "Puerto Rico Fertility Center",
    "address": {
      "id": "addr-338",
      "address1": "Dr. Arturo Cadilla Building, 100 Paseo San Pablo, Suite 503",
      "city": "Bayamón",
      "state": "PR",
      "postalCode": "961",
      "country": "US"
    },
    "headline": "Puerto Rico Fertility Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(787) 798-0100",
    "bookingUrl": null,
    "location": {
      "latitude": 18.3989,
      "longitude": -66.1481
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 208,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 20.3,
      "between35And37": 17.9,
      "between38And40": 12.8
    },
    "medicaldirector": "Amaury J. Llorens, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 24.4,
      "between38And40": 17.2
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 8
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "721",
    "name": "Women & Infants Fertility Center",
    "address": {
      "id": "addr-721",
      "address1": "90 Plain St, 5th Floor",
      "city": "Providence",
      "state": "RI",
      "postalCode": "2903",
      "country": "US"
    },
    "headline": "Women & Infants Fertility Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(401) 453-7500",
    "bookingUrl": null,
    "location": {
      "latitude": 41.8141,
      "longitude": -71.4123
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 528,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 40.9,
      "between35And37": 45.1,
      "between38And40": 32.3
    },
    "medicaldirector": "Virginia A. Mensah, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 46.4,
      "between35And37": 43.9,
      "between38And40": 35.1
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 32,
      "frozenEmbryos": 53.6,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "891",
    "name": "Adore Fertility",
    "address": {
      "id": "addr-891",
      "address1": "1280 Hospital Drive, Suite 300",
      "city": "Mount Pleasant",
      "state": "SC",
      "postalCode": "29464",
      "country": "US"
    },
    "headline": "Adore Fertility",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(843) 990-4500",
    "bookingUrl": null,
    "location": {
      "latitude": 32.7901,
      "longitude": -79.8771
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 3,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 0,
      "between35And37": 0,
      "between38And40": 0
    },
    "medicaldirector": "Jeris Cox, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 0,
      "between35And37": 0,
      "between38And40": 0
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "89",
    "name": "Coastal Fertility Specialists",
    "address": {
      "id": "addr-89",
      "address1": "1375 Hospital Dr",
      "city": "Mount Pleasant",
      "state": "SC",
      "postalCode": "29464",
      "country": "US"
    },
    "headline": "Coastal Fertility Specialists",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(843) 883-5800",
    "bookingUrl": null,
    "location": {
      "latitude": 32.8165,
      "longitude": -79.8535
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 568,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 65.2,
      "between35And37": 51.4,
      "between38And40": 57.7
    },
    "medicaldirector": "John A. Schnorr, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 69.7,
      "between35And37": 44.4,
      "between38And40": 42.9
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 48.5,
      "frozenEmbryos": 53
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "41",
    "name": "Fertility Center of the Carolinas, University Medical Group, Department of Obstetrics and Gynecology",
    "address": {
      "id": "addr-41",
      "address1": "890 W. Faris Rd, Suite 470",
      "city": "Greenville",
      "state": "SC",
      "postalCode": "29605",
      "country": "US"
    },
    "headline": "Fertility Center of the Carolinas, University Medical Group, Department of Obstetrics and Gynecology",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(864) 455-1600",
    "bookingUrl": null,
    "location": {
      "latitude": 34.8175,
      "longitude": -82.4105
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 222,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 39.5,
      "between35And37": 25.6,
      "between38And40": 42.3
    },
    "medicaldirector": "Creighton E. Likes, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 53.8,
      "between35And37": 22.7,
      "between38And40": 21.7
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 55.55555555555556,
      "frozenEmbryos": 26.31578947368421
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFrozenEggs": 9,
      "frozenEmbryos": 19
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "10",
    "name": "Piedmont Reproductive Endocrinology Group, PA",
    "address": {
      "id": "addr-10",
      "address1": "17 Caledon Ct, Suite C",
      "city": "Greenville",
      "state": "SC",
      "postalCode": "29615",
      "country": "US"
    },
    "headline": "Piedmont Reproductive Endocrinology Group, PA",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(864) 232-7734",
    "bookingUrl": null,
    "location": {
      "latitude": 34.8631,
      "longitude": -82.3396
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 587,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 47.8,
      "between35And37": 47.4,
      "between38And40": 45.3
    },
    "medicaldirector": "John E. Nichols, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 56.6,
      "between35And37": 50,
      "between38And40": 33.3
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 53.333333333333336,
      "freshEmbryosFrozenEggs": 50,
      "frozenEmbryos": 46.8,
      "donatedEmbryos": 35.4
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFreshEggs": 15,
      "freshEmbryosFrozenEggs": 12
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "269",
    "name": "Sanford Women's Health",
    "address": {
      "id": "addr-269",
      "address1": "1500 W. 22nd St, MB3, Suite 102",
      "city": "Sioux Falls",
      "state": "SD",
      "postalCode": "57105",
      "country": "US"
    },
    "headline": "Sanford Women's Health",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(605) 328-8800",
    "bookingUrl": null,
    "location": {
      "latitude": 43.5346,
      "longitude": -96.7436
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 259,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 31.5,
      "between35And37": 32.8
    },
    "medicaldirector": "Keith A. Hansen, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 42.9,
      "between35And37": 37.5
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 35,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "132",
    "name": "Fertility Center, LLC",
    "address": {
      "id": "addr-132",
      "address1": "7407 Ziegler Rd",
      "city": "Chattanooga",
      "state": "TN",
      "postalCode": "37421",
      "country": "US"
    },
    "headline": "Fertility Center, LLC",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(423) 899-0500",
    "bookingUrl": null,
    "location": {
      "latitude": 35.0203,
      "longitude": -85.1596
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 169,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 44.9,
      "between35And37": 57.1,
      "between38And40": 46.15384615384615
    },
    "medicaldirector": "Barry W. Donesky, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between38And40": 13
    },
    "newPatientSuccessRates": {
      "under35": 46.8,
      "between35And37": 45
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 61.5
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "152",
    "name": "Kutteh Ke Fertility Associates of Memphis, PLLC",
    "address": {
      "id": "addr-152",
      "address1": "80 Humphreys Center, Suite 307",
      "city": "Memphis",
      "state": "TN",
      "postalCode": "38120",
      "country": "US"
    },
    "headline": "Kutteh Ke Fertility Associates of Memphis, PLLC",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(901) 747-2229",
    "bookingUrl": null,
    "location": {
      "latitude": 35.1282,
      "longitude": -89.8569
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 370,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 60.7,
      "between35And37": 52.7,
      "between38And40": 32.7
    },
    "medicaldirector": "Raymond W. Ke, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 64.9,
      "between35And37": 51.4,
      "between38And40": 31
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 56,
      "donatedEmbryos": 63
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "258",
    "name": "Nashville Fertility Center",
    "address": {
      "id": "addr-258",
      "address1": "345 23rd Ave North, Suite 401",
      "city": "Nashville",
      "state": "TN",
      "postalCode": "37203",
      "country": "US"
    },
    "headline": "Nashville Fertility Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(615) 321-4740",
    "bookingUrl": null,
    "location": {
      "latitude": 36.155,
      "longitude": -86.8096
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 616,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 58.9,
      "between35And37": 51.5,
      "between38And40": 61.4
    },
    "medicaldirector": "George A. Hill, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 52.2,
      "between35And37": 37.3,
      "between38And40": 25.9
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 39.5,
      "donatedEmbryos": 72.22222222222221
    },
    "donorSuccessRateDenominators": {
      "donatedEmbryos": 18
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "314",
    "name": "Quillen Fertility & Women's Services",
    "address": {
      "id": "addr-314",
      "address1": "1319 Sunset Dr, Suite 103",
      "city": "Johnson City",
      "state": "TN",
      "postalCode": "37604",
      "country": "US"
    },
    "headline": "Quillen Fertility & Women's Services",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(423) 439-7246",
    "bookingUrl": null,
    "location": {
      "latitude": 36.3274,
      "longitude": -82.3925
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 28,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 35
    },
    "medicaldirector": "Mark X. Ransom, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 54.54545454545454
    },
    "newPatientSuccessRateDenominators": {
      "under35": 11
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "436",
    "name": "Southeastern Center for Fertility and Reproductive Surgery, PLLC",
    "address": {
      "id": "addr-436",
      "address1": "11126 Kingston Pike",
      "city": "Knoxville",
      "state": "TN",
      "postalCode": "37934",
      "country": "US"
    },
    "headline": "Southeastern Center for Fertility and Reproductive Surgery, PLLC",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(865) 777-0088",
    "bookingUrl": null,
    "location": {
      "latitude": 35.8858,
      "longitude": -84.1503
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 242,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 43.3,
      "between35And37": 16,
      "between38And40": 47.368421052631575
    },
    "medicaldirector": "John D. Gordon, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between38And40": 19
    },
    "newPatientSuccessRates": {
      "under35": 43.3
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 0,
      "donatedEmbryos": 47.5
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "715",
    "name": "Tennessee Fertility Institute",
    "address": {
      "id": "addr-715",
      "address1": "9160 Carothers Pkwy, Suite 201",
      "city": "Franklin",
      "state": "TN",
      "postalCode": "37067",
      "country": "US"
    },
    "headline": "Tennessee Fertility Institute",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(615) 721-6250",
    "bookingUrl": null,
    "location": {
      "latitude": 35.9602,
      "longitude": -86.8002
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 225,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 55.8,
      "between35And37": 47.6,
      "between38And40": 44
    },
    "medicaldirector": "Christopher P. Montville, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 57.1,
      "between35And37": 30.3,
      "between38And40": 14.3
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 34.6
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "307",
    "name": "Tennessee Reproductive Medicine",
    "address": {
      "id": "addr-307",
      "address1": "6031 Shallowford Rd, Suite 101",
      "city": "Chattanooga",
      "state": "TN",
      "postalCode": "37421",
      "country": "US"
    },
    "headline": "Tennessee Reproductive Medicine",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(423) 876-2229",
    "bookingUrl": null,
    "location": {
      "latitude": 35.0539,
      "longitude": -85.183
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 230,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 48.3,
      "between35And37": 56.3,
      "between38And40": 55.6
    },
    "medicaldirector": "Ringland S. Murray, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 51.6,
      "between35And37": 31.3,
      "between38And40": 33.3
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 33.3,
      "donatedEmbryos": 41.66666666666667
    },
    "donorSuccessRateDenominators": {
      "donatedEmbryos": 12
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "66",
    "name": "The Center for Reproductive Health",
    "address": {
      "id": "addr-66",
      "address1": "2410 Patterson St, Suite 401",
      "city": "Nashville",
      "state": "TN",
      "postalCode": "37203",
      "country": "US"
    },
    "headline": "The Center for Reproductive Health",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(615) 321-8899",
    "bookingUrl": null,
    "location": {
      "latitude": 36.1523,
      "longitude": -86.8109
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 103,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 20.8
    },
    "medicaldirector": "Jaime M. Vasquez, MD",
    "clinicStatus": "Closed",
    "successRateDenominators": {},
    "newPatientSuccessRates": {},
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 26.31578947368421,
      "donatedEmbryos": 21.7
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 19
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "489",
    "name": "Advanced Fertility Center of Texas",
    "address": {
      "id": "addr-489",
      "address1": "10901 Katy Freeway",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77079",
      "country": "US"
    },
    "headline": "Advanced Fertility Center of Texas",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(713) 467-4488",
    "bookingUrl": null,
    "location": {
      "latitude": 29.7837,
      "longitude": -95.5702
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 169,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 46.9,
      "between35And37": 48.1,
      "between38And40": 58.333333333333336
    },
    "medicaldirector": "Michael A. Allon, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between38And40": 12
    },
    "newPatientSuccessRates": {
      "under35": 50,
      "between35And37": 30.4,
      "between38And40": 29.411764705882355
    },
    "newPatientSuccessRateDenominators": {
      "between38And40": 17
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 54.8,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "622",
    "name": "Advanced Fertility Centers, PLLC",
    "address": {
      "id": "addr-622",
      "address1": "420 E. 6th St, Suite 101",
      "city": "Odessa",
      "state": "TX",
      "postalCode": "79761",
      "country": "US"
    },
    "headline": "Advanced Fertility Centers, PLLC",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(432) 614-6376",
    "bookingUrl": null,
    "location": {
      "latitude": 31.8511,
      "longitude": -102.366
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 26,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 66.66666666666666
    },
    "medicaldirector": "Rizwan Malik, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "under35": 18
    },
    "newPatientSuccessRates": {
      "under35": 64.70588235294117
    },
    "newPatientSuccessRateDenominators": {
      "under35": 17
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "42",
    "name": "Aspire Fertility-Austin",
    "address": {
      "id": "addr-42",
      "address1": "911 W. 38th St, Suite 402",
      "city": "Austin",
      "state": "TX",
      "postalCode": "78705",
      "country": "US"
    },
    "headline": "Aspire Fertility-Austin",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(512) 479-7979",
    "bookingUrl": null,
    "location": {
      "latitude": 30.3046,
      "longitude": -97.7432
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 275,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 52,
      "between35And37": 50.7,
      "between38And40": 61.3
    },
    "medicaldirector": "Christine Mansfield, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 56.8,
      "between35And37": 50.9,
      "between38And40": 30.6
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 66.66666666666666
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 9
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "703",
    "name": "Aspire Fertility-Dallas",
    "address": {
      "id": "addr-703",
      "address1": "16415 Addison Rd, Suite 900",
      "city": "Addison",
      "state": "TX",
      "postalCode": "75001",
      "country": "US"
    },
    "headline": "Aspire Fertility-Dallas",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(214) 414-3806",
    "bookingUrl": null,
    "location": {
      "latitude": 32.9724,
      "longitude": -96.8308
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 297,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 34.9,
      "between35And37": 32.8,
      "between38And40": 47.2
    },
    "medicaldirector": "Christine Mansfield, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 43.2,
      "between35And37": 27.7,
      "between38And40": 26.5
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 60
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 10
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "62",
    "name": "Aspire Fertility-San Antonio",
    "address": {
      "id": "addr-62",
      "address1": "150 E. Sonterra Blvd, Suite 220",
      "city": "San Antonio",
      "state": "TX",
      "postalCode": "78258",
      "country": "US"
    },
    "headline": "Aspire Fertility-San Antonio",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(210) 337-8453",
    "bookingUrl": null,
    "location": {
      "latitude": 29.6153,
      "longitude": -98.4922
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 618,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 57.1,
      "between35And37": 54.7,
      "between38And40": 56
    },
    "medicaldirector": "Ursula Balthazar, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 56.7,
      "between35And37": 43.6,
      "between38And40": 17.9
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 60,
      "frozenEmbryos": 48.4,
      "donatedEmbryos": 56.3
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "442",
    "name": "Austin Fertility and Reproductive Medicine-Westlake IVF",
    "address": {
      "id": "addr-442",
      "address1": "300 Beardsley Ln, Bldg B, Suite 200",
      "city": "Austin",
      "state": "TX",
      "postalCode": "78746",
      "country": "US"
    },
    "headline": "Austin Fertility and Reproductive Medicine-Westlake IVF",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(512) 444-1414",
    "bookingUrl": null,
    "location": {
      "latitude": 30.3133,
      "longitude": -97.8541
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 176,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 48.7,
      "between35And37": 31.3,
      "between38And40": 45
    },
    "medicaldirector": "Shahryar K. Kavoussi, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 53.4,
      "between35And37": 26.1,
      "between38And40": 20
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 87.5
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 8
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "112",
    "name": "Austin Fertility Institute, PA",
    "address": {
      "id": "addr-112",
      "address1": "2200 Park Bend Dr, Bldg 2, Suite 201",
      "city": "Austin",
      "state": "TX",
      "postalCode": "78758",
      "country": "US"
    },
    "headline": "Austin Fertility Institute, PA",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(512) 339-4234",
    "bookingUrl": null,
    "location": {
      "latitude": 30.4095,
      "longitude": -97.7031
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 165,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 43.8,
      "between35And37": 37.2,
      "between38And40": 48
    },
    "medicaldirector": "Kenneth K. Moghadam, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 50,
      "between35And37": 33.3,
      "between38And40": 36
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "289",
    "name": "Brooke Army Medical Center",
    "address": {
      "id": "addr-289",
      "address1": "Department of Obstetrics & Gynecology, 3551 Roger Brooke Dr",
      "city": "Fort Sam Houston",
      "state": "TX",
      "postalCode": "78234",
      "country": "US"
    },
    "headline": "Brooke Army Medical Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(210) 916-6305",
    "bookingUrl": null,
    "location": {
      "latitude": 37.7018,
      "longitude": -97.316
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 121,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 44.8,
      "between35And37": 46.9,
      "between38And40": 47.368421052631575
    },
    "medicaldirector": "Rhiana Saunders, MD",
    "clinicStatus": "Reorganized",
    "successRateDenominators": {
      "between38And40": 19
    },
    "newPatientSuccessRates": {
      "under35": 44.2,
      "between35And37": 54.2
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "427",
    "name": "CCRM Dallas-Fort Worth",
    "address": {
      "id": "addr-427",
      "address1": "8380 Warren Pkwy, Suite 201",
      "city": "Frisco",
      "state": "TX",
      "postalCode": "75034",
      "country": "US"
    },
    "headline": "CCRM Dallas-Fort Worth",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(972) 377-2625",
    "bookingUrl": null,
    "location": {
      "latitude": 33.1089,
      "longitude": -96.8142
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 163,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 61.7,
      "between35And37": 53.84615384615385,
      "between38And40": 41.17647058823529
    },
    "medicaldirector": "Dorette J. Noorhasan, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between35And37": 13,
      "between38And40": 17
    },
    "newPatientSuccessRates": {
      "under35": 61.4,
      "between35And37": 42.857142857142854,
      "between38And40": 9.5
    },
    "newPatientSuccessRateDenominators": {
      "between35And37": 14
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "249",
    "name": "Center for Assisted Reproduction",
    "address": {
      "id": "addr-249",
      "address1": "1701 Park Place Ave",
      "city": "Bedford",
      "state": "TX",
      "postalCode": "76022",
      "country": "US"
    },
    "headline": "Center for Assisted Reproduction",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(817) 540-1157",
    "bookingUrl": null,
    "location": {
      "latitude": 32.8344,
      "longitude": -97.1295
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 464,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 44,
      "between35And37": 29.4,
      "between38And40": 38.5
    },
    "medicaldirector": "Kevin J. Doody, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 61.7,
      "between35And37": 34.3,
      "between38And40": 28.3
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 29.7,
      "donatedEmbryos": 45.8
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "334",
    "name": "Center of Reproductive Medicine, LLP dba, SGF Houston",
    "address": {
      "id": "addr-334",
      "address1": "1015 Medical Center Blvd, Suite 2100",
      "city": "Webster",
      "state": "TX",
      "postalCode": "77598",
      "country": "US"
    },
    "headline": "Center of Reproductive Medicine, LLP dba, SGF Houston",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(281) 332-0073",
    "bookingUrl": null,
    "location": {
      "latitude": 29.5351,
      "longitude": -95.1332
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 492,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 53.2,
      "between35And37": 44.7,
      "between38And40": 42.9
    },
    "medicaldirector": "Vicki L. Schnell, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 55.9,
      "between35And37": 35.4,
      "between38And40": 10.9
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 50
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "811",
    "name": "Conceive Fertility Center",
    "address": {
      "id": "addr-811",
      "address1": "7515 Greenville Ave., Suite 1030",
      "city": "Dallas",
      "state": "TX",
      "postalCode": "75231",
      "country": "US"
    },
    "headline": "Conceive Fertility Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(214) 224-0778",
    "bookingUrl": null,
    "location": {
      "latitude": 32.9012,
      "longitude": -96.9572
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 185,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 47.2,
      "between35And37": 53.3
    },
    "medicaldirector": "Derek Haas, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 44.4,
      "between35And37": 38.7,
      "between38And40": 13
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 54.5
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "83",
    "name": "Cooper Institute for Advanced Reproductive Medicine",
    "address": {
      "id": "addr-83",
      "address1": "7500 Beechnut St, Suite 308",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77074",
      "country": "US"
    },
    "headline": "Cooper Institute for Advanced Reproductive Medicine",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(713) 771-9771",
    "bookingUrl": null,
    "location": {
      "latitude": 29.6924,
      "longitude": -95.5188
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 57,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 27.3
    },
    "medicaldirector": "C. James Chuong, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 27.77777777777778
    },
    "newPatientSuccessRateDenominators": {
      "under35": 18
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "253",
    "name": "Dallas IVF",
    "address": {
      "id": "addr-253",
      "address1": "2840 Legacy Dr, Bldg 1, Suite 100",
      "city": "Frisco",
      "state": "TX",
      "postalCode": "75034",
      "country": "US"
    },
    "headline": "Dallas IVF",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(214) 297-0027",
    "bookingUrl": null,
    "location": {
      "latitude": 33.1022,
      "longitude": -96.8409
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 620,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 54.6,
      "between35And37": 49.5,
      "between38And40": 44.8
    },
    "medicaldirector": "Brian D. Barnett, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 54.1,
      "between35And37": 40.2,
      "between38And40": 15.4
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 72.72727272727273,
      "frozenEmbryos": 60.4,
      "donatedEmbryos": 57.1
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFrozenEggs": 11
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "177",
    "name": "Dallas-Fort Worth Fertility Associates",
    "address": {
      "id": "addr-177",
      "address1": "5477 Glen Lakes Dr, Suite 200",
      "city": "Dallas",
      "state": "TX",
      "postalCode": "75231",
      "country": "US"
    },
    "headline": "Dallas-Fort Worth Fertility Associates",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(214) 363-5965",
    "bookingUrl": null,
    "location": {
      "latitude": 32.8835,
      "longitude": -96.7663
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 987,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 46.2,
      "between35And37": 47.5,
      "between38And40": 42.7
    },
    "medicaldirector": "Samuel J. Chantilis, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 60,
      "between35And37": 51.2,
      "between38And40": 23.3
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 46.666666666666664,
      "freshEmbryosFrozenEggs": 42.4,
      "frozenEmbryos": 29.3,
      "donatedEmbryos": 46.2
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFreshEggs": 15
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "626",
    "name": "DFW Center for Fertility & IVF",
    "address": {
      "id": "addr-626",
      "address1": "980 Raintree Cir",
      "city": "Allen",
      "state": "TX",
      "postalCode": "75013",
      "country": "US"
    },
    "headline": "DFW Center for Fertility & IVF",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(214) 383-2600",
    "bookingUrl": null,
    "location": {
      "latitude": 33.1106,
      "longitude": -96.6796
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 81,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 70.4,
      "between35And37": 50,
      "between38And40": 27.77777777777778
    },
    "medicaldirector": "Victor E. Beshay, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between35And37": 14,
      "between38And40": 18
    },
    "newPatientSuccessRates": {
      "under35": 70.8,
      "between38And40": 38.46153846153847
    },
    "newPatientSuccessRateDenominators": {
      "between38And40": 13
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "451",
    "name": "Family Fertility Center",
    "address": {
      "id": "addr-451",
      "address1": "Texas Children's Pavilion for Women, 6651 Main St, Suite E350",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77030",
      "country": "US"
    },
    "headline": "Family Fertility Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(832) 826-7463",
    "bookingUrl": null,
    "location": {
      "latitude": 29.7082,
      "longitude": -95.4027
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 300,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 46.5,
      "between35And37": 60,
      "between38And40": 35.7
    },
    "medicaldirector": "Laura Detti, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 39.4,
      "between35And37": 23.7,
      "between38And40": 21.4
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 55.55555555555556,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 18
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "238",
    "name": "Fertility and Advanced Reproductive Medicine",
    "address": {
      "id": "addr-238",
      "address1": "Outpatient Building, 1801 Inwood Rd, Suite 616",
      "city": "Dallas",
      "state": "TX",
      "postalCode": "75390",
      "country": "US"
    },
    "headline": "Fertility and Advanced Reproductive Medicine",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(214) 645-3858",
    "bookingUrl": null,
    "location": {
      "latitude": 32.8161,
      "longitude": -96.8464
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 149,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 50,
      "between35And37": 50
    },
    "medicaldirector": "Orhan Bukulmez, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between35And37": 16
    },
    "newPatientSuccessRates": {
      "under35": 50
    },
    "newPatientSuccessRateDenominators": {
      "under35": 18
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 62.5,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFrozenEggs": 8
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "445",
    "name": "Fertility Center of Dallas",
    "address": {
      "id": "addr-445",
      "address1": "Baylor Medical Pavilion, 3900 Junius St, Suite 610",
      "city": "Dallas",
      "state": "TX",
      "postalCode": "75246",
      "country": "US"
    },
    "headline": "Fertility Center of Dallas",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(972) 884-5700",
    "bookingUrl": null,
    "location": {
      "latitude": 32.7908,
      "longitude": -96.7776
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 136,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 47.2,
      "between35And37": 66.7,
      "between38And40": 66.66666666666666
    },
    "medicaldirector": "Samuel Chantilis, MD",
    "clinicStatus": "Reorganized",
    "successRateDenominators": {
      "between38And40": 15
    },
    "newPatientSuccessRates": {
      "under35": 63.2,
      "between35And37": 46.4
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 45.45454545454545
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 11
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "123",
    "name": "Fertility Center of San Antonio",
    "address": {
      "id": "addr-123",
      "address1": "7707 Ewing Halsell Dr, Suite 103",
      "city": "San Antonio",
      "state": "TX",
      "postalCode": "78229",
      "country": "US"
    },
    "headline": "Fertility Center of San Antonio",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(210) 692-0577",
    "bookingUrl": null,
    "location": {
      "latitude": 29.5103,
      "longitude": -98.5738
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 296,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 47.3,
      "between35And37": 41.9,
      "between38And40": 30.3
    },
    "medicaldirector": "Gregory S. Neal, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 55.7,
      "between35And37": 40.5,
      "between38And40": 33.3
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "frozenEmbryos": 55.55555555555556
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 18
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "98",
    "name": "Fertility Specialists of Texas-Lubbock",
    "address": {
      "id": "addr-98",
      "address1": "3405 22nd St, Suite 300",
      "city": "Lubbock",
      "state": "TX",
      "postalCode": "79410",
      "country": "US"
    },
    "headline": "Fertility Specialists of Texas-Lubbock",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(806) 788-1212",
    "bookingUrl": null,
    "location": {
      "latitude": 33.5747,
      "longitude": -101.888
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 45,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 58.3
    },
    "medicaldirector": "Jerald Goldstein, MD",
    "clinicStatus": "Reorganized",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 52.63157894736842
    },
    "newPatientSuccessRateDenominators": {
      "under35": 19
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "480",
    "name": "Fertility Specialists of Texas, PLLC",
    "address": {
      "id": "addr-480",
      "address1": "5736 State Highway 121",
      "city": "Plano",
      "state": "TX",
      "postalCode": "75024",
      "country": "US"
    },
    "headline": "Fertility Specialists of Texas, PLLC",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(214) 618-2044",
    "bookingUrl": null,
    "location": {
      "latitude": 33.1056,
      "longitude": -96.8372
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 712,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 54.5,
      "between35And37": 54.1,
      "between38And40": 46.5
    },
    "medicaldirector": "Jerald S. Goldstein, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 61.8,
      "between35And37": 47.1,
      "between38And40": 23.4
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 60.6
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "843",
    "name": "Fora Fertility, PLLC",
    "address": {
      "id": "addr-843",
      "address1": "715 W. 34th St",
      "city": "Austin",
      "state": "TX",
      "postalCode": "78705",
      "country": "US"
    },
    "headline": "Fora Fertility, PLLC",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(512) 956-5006",
    "bookingUrl": null,
    "location": {
      "latitude": 30.3015,
      "longitude": -97.7427
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 245,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 66.7,
      "between35And37": 57.1,
      "between38And40": 37.5
    },
    "medicaldirector": "Amanda Skillern, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 50,
      "between35And37": 27.8,
      "between38And40": 18.9
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 41.17647058823529,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 17
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "468",
    "name": "HART Fertility Clinic",
    "address": {
      "id": "addr-468",
      "address1": "111 Vision Park, Suite 110",
      "city": "The Woodlands",
      "state": "TX",
      "postalCode": "77384",
      "country": "US"
    },
    "headline": "HART Fertility Clinic",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(281) 444-4784",
    "bookingUrl": null,
    "location": {
      "latitude": 30.1909,
      "longitude": -95.4569
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 148,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 52.7,
      "between35And37": 39.3,
      "between38And40": 42.857142857142854
    },
    "medicaldirector": "Dorothy J. Roach, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between38And40": 14
    },
    "newPatientSuccessRates": {
      "under35": 51.1,
      "between35And37": 36.4
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 71.42857142857143
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 7
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "104",
    "name": "Houston Fertility Institute",
    "address": {
      "id": "addr-104",
      "address1": "2500 Fondren Rd, Suite 300",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77063",
      "country": "US"
    },
    "headline": "Houston Fertility Institute",
    "images": [],
    "tags": [],
    "services": ["Counseling", "Support resources", "Patient portal"],
    "languages": ["en", "vi"],
    "clinicType": "Network & group",
    "conditions": [
      "PCOS",
      "Endometriosis",
      "Male factor",
      "Diminished ovarian reserve",
      "Oncofertility"
    ],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Embryo Freezing",
      "PGT",
      "Ovulation Induction",
      "Sperm Freezing",
      "Donor programs",
      "Surrogacy",
      "Fertility preservation",
      "Male factor"
    ],
    "website": "https://www.aspirehfi.com/",
    "email": null,
    "phone": "(713) 730-2229",
    "bookingUrl": "https://www.aspirehfi.com/appointments",
    "location": {
      "latitude": 29.7404,
      "longitude": -95.5221
    },
    "insurances": [],
    "insuranceAccepted": true,
    "insuranceName": null,
    "financiers": [
      "Payment plans",
      "Loans",
      "Future Family",
      "CapexMD",
      "PatientFi"
    ],
    "consultationTypes": ["In person"],
    "patientGroups": ["LGBTQIA+", "Single Parents", "Same sex couples"],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 2207,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": "The largest and most experienced fertility center in Texas, part of the Prelude Network, with 14 locations across Greater Houston and its own donor egg bank.",
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 56.3,
      "between35And37": 48.6,
      "between38And40": 47.4
    },
    "medicaldirector": "Ghassan F. Haddad, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 65.1,
      "between35And37": 48.3,
      "between38And40": 36.5
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 57.8,
      "frozenEmbryos": 46.5,
      "donatedEmbryos": 47.6
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "3",
    "name": "Houston Infertility Clinic, Sonja Kristiansen, MD",
    "address": {
      "id": "addr-3",
      "address1": "9055 Katy Freeway, Suite 450",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77024",
      "country": "US"
    },
    "headline": "Houston Infertility Clinic, Sonja Kristiansen, MD",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(713) 862-6181",
    "bookingUrl": null,
    "location": {
      "latitude": 29.7836,
      "longitude": -95.5123
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 220,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 20.3,
      "between35And37": 16.7,
      "between38And40": 38.5
    },
    "medicaldirector": "Sonja B. Kristiansen, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 11.3,
      "between35And37": 11.1,
      "between38And40": 24.2
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "frozenEmbryos": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 5,
      "donatedEmbryos": 8
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "33",
    "name": "Houston IVF dba, CCRM Houston",
    "address": {
      "id": "addr-33",
      "address1": "929 Gessner Rd, Suite 2300",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77024",
      "country": "US"
    },
    "headline": "Houston IVF dba, CCRM Houston",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(713) 465-1211",
    "bookingUrl": null,
    "location": {
      "latitude": 29.782,
      "longitude": -95.5455
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 815,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 63.3,
      "between35And37": 52.4,
      "between38And40": 54.4
    },
    "medicaldirector": "Timothy N. Hickman, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 63.8,
      "between35And37": 50,
      "between38And40": 37
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "frozenEmbryos": 50.6,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "841",
    "name": "Inovi Fertility & Genetics Institute",
    "address": {
      "id": "addr-841",
      "address1": "3773 Richmond Ave, Suite 400",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77046",
      "country": "US"
    },
    "headline": "Inovi Fertility & Genetics Institute",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(713) 401-9000",
    "bookingUrl": null,
    "location": {
      "latitude": 29.7325,
      "longitude": -95.4372
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 54,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 52.94117647058824
    },
    "medicaldirector": "Stephan Krotz, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "under35": 17
    },
    "newPatientSuccessRates": {
      "under35": 50
    },
    "newPatientSuccessRateDenominators": {
      "under35": 16
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 53.84615384615385,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 13
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "827",
    "name": "IVFMD-Arlington",
    "address": {
      "id": "addr-827",
      "address1": "600 W. Mayfield Rd",
      "city": "Arlington",
      "state": "TX",
      "postalCode": "76014",
      "country": "US"
    },
    "headline": "IVFMD-Arlington",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(817) 701-1290",
    "bookingUrl": null,
    "location": {
      "latitude": 32.6906,
      "longitude": -97.1134
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 167,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 43.2,
      "between35And37": 38.3,
      "between38And40": 38.88888888888889
    },
    "medicaldirector": "Renju Raj, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between38And40": 18
    },
    "newPatientSuccessRates": {
      "under35": 56.6,
      "between35And37": 43.2,
      "between38And40": 35.714285714285715
    },
    "newPatientSuccessRateDenominators": {
      "between38And40": 14
    },
    "donorSuccessRates": {},
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "469",
    "name": "IVFMD-Irving",
    "address": {
      "id": "addr-469",
      "address1": "7501 Las Colinas Blvd, Suite 200A",
      "city": "Irving",
      "state": "TX",
      "postalCode": "75063",
      "country": "US"
    },
    "headline": "IVFMD-Irving",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(972) 506-9986",
    "bookingUrl": null,
    "location": {
      "latitude": 32.9098,
      "longitude": -96.9555
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 257,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 53.2,
      "between35And37": 47.9,
      "between38And40": 25
    },
    "medicaldirector": "Sy Q. Le, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 55.6,
      "between35And37": 52.8,
      "between38And40": 30.8
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 43.3
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "927",
    "name": "Kindbody - Houston",
    "address": {
      "id": "addr-927",
      "address1": "1111 Uptown Park Blvd, Suite 02",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77056",
      "country": "US"
    },
    "headline": "Kindbody - Houston",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(528) 171-9935",
    "bookingUrl": null,
    "location": {
      "latitude": 29.7518,
      "longitude": -95.4485
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 0,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 0,
      "between35And37": 0,
      "between38And40": 0
    },
    "medicaldirector": "Toral  Parikh, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 0,
      "between35And37": 0,
      "between38And40": 0
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "879",
    "name": "Kindbody Austin",
    "address": {
      "id": "addr-879",
      "address1": "100 Colorado St",
      "city": "Austin",
      "state": "TX",
      "postalCode": "78701",
      "country": "US"
    },
    "headline": "Kindbody Austin",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(737) 787-7806",
    "bookingUrl": null,
    "location": {
      "latitude": 30.264,
      "longitude": -97.746
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 7,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {},
    "medicaldirector": "Deborah E. Ikhena-Abel, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {},
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "890",
    "name": "Origin Fertility, PA",
    "address": {
      "id": "addr-890",
      "address1": "1643 Lancaster Dr, Suite 309",
      "city": "Grapevine",
      "state": "TX",
      "postalCode": "76051",
      "country": "US"
    },
    "headline": "Origin Fertility, PA",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(817) 840-7700",
    "bookingUrl": null,
    "location": {
      "latitude": 32.938,
      "longitude": -97.0754
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 3,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 0,
      "between35And37": 0,
      "between38And40": 0
    },
    "medicaldirector": "Linda C. Elkins, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 0,
      "between35And37": 0,
      "between38And40": 0
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "896",
    "name": "Pozitivf Fertility",
    "address": {
      "id": "addr-896",
      "address1": "4515 N Loop 1604 W, Suite 301",
      "city": "San Antonio",
      "state": "TX",
      "postalCode": "78249",
      "country": "US"
    },
    "headline": "Pozitivf Fertility",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(210) 404-2229",
    "bookingUrl": null,
    "location": {
      "latitude": 29.5964,
      "longitude": -98.5693
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 0,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 0,
      "between35And37": 0,
      "between38And40": 0
    },
    "medicaldirector": "Francisco Arredondo, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 0,
      "between35And37": 0,
      "between38And40": 0
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "205",
    "name": "Reproductive Institute of South Texas",
    "address": {
      "id": "addr-205",
      "address1": "110 E. Savannah Ave, Bldg B, Suite 103",
      "city": "Mcallen",
      "state": "TX",
      "postalCode": "78503",
      "country": "US"
    },
    "headline": "Reproductive Institute of South Texas",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(956) 687-2693",
    "bookingUrl": null,
    "location": {
      "latitude": 26.1845,
      "longitude": -98.2215
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 80,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 37.5,
      "between38And40": 8.3
    },
    "medicaldirector": "Esteban O. Brown, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 45
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "24",
    "name": "ReproMed Fertility Center",
    "address": {
      "id": "addr-24",
      "address1": "3800 San Jacinto St",
      "city": "Dallas",
      "state": "TX",
      "postalCode": "75204",
      "country": "US"
    },
    "headline": "ReproMed Fertility Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(214) 827-8777",
    "bookingUrl": null,
    "location": {
      "latitude": 32.7972,
      "longitude": -96.785
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 145,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 50,
      "between35And37": 64.70588235294117,
      "between38And40": 53.84615384615385
    },
    "medicaldirector": "Anil B. Pinto, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between35And37": 17,
      "between38And40": 13
    },
    "newPatientSuccessRates": {
      "under35": 45.2,
      "between35And37": 33.33333333333333
    },
    "newPatientSuccessRateDenominators": {
      "between35And37": 18
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "234",
    "name": "Scott & White Clinic-Temple",
    "address": {
      "id": "addr-234",
      "address1": "Department of Obstetrics and Gynecology, 2401 S. 31st St",
      "city": "Temple",
      "state": "TX",
      "postalCode": "76508",
      "country": "US"
    },
    "headline": "Scott & White Clinic-Temple",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(254) 724-3389",
    "bookingUrl": null,
    "location": {
      "latitude": 31.0776,
      "longitude": -97.364
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 160,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 41,
      "between35And37": 30.3,
      "between38And40": 23.8
    },
    "medicaldirector": "Gordon W. Bates, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 44.4,
      "between35And37": 37
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "201",
    "name": "Southwest Center for Reproductive Health, PA",
    "address": {
      "id": "addr-201",
      "address1": "700 S. Mesa Hills Dr",
      "city": "El Paso",
      "state": "TX",
      "postalCode": "79912",
      "country": "US"
    },
    "headline": "Southwest Center for Reproductive Health, PA",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(915) 842-9998",
    "bookingUrl": null,
    "location": {
      "latitude": 31.8154,
      "longitude": -106.539
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 49,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 41.66666666666667
    },
    "medicaldirector": "Luis S. Noble, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "under35": 12
    },
    "newPatientSuccessRates": {},
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "376",
    "name": "Texas Center for Reproductive Health",
    "address": {
      "id": "addr-376",
      "address1": "Barnett Tower, 3600 Gaston Ave, Suite 504",
      "city": "Dallas",
      "state": "TX",
      "postalCode": "75246",
      "country": "US"
    },
    "headline": "Texas Center for Reproductive Health",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(214) 821-2274",
    "bookingUrl": null,
    "location": {
      "latitude": 32.7901,
      "longitude": -96.7801
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 45,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 45.5
    },
    "medicaldirector": "Samuel P. Marynick, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 69.23076923076923,
      "between38And40": 0
    },
    "newPatientSuccessRateDenominators": {
      "under35": 13,
      "between38And40": 5
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "276",
    "name": "Texas Fertility Center, Vaughn, Silverberg & Associates",
    "address": {
      "id": "addr-276",
      "address1": "6500 N. Mopac Expressway, Bldg 1, Suite 1200",
      "city": "Austin",
      "state": "TX",
      "postalCode": "78731",
      "country": "US"
    },
    "headline": "Texas Fertility Center, Vaughn, Silverberg & Associates",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(512) 451-0149",
    "bookingUrl": null,
    "location": {
      "latitude": 30.3472,
      "longitude": -97.7514
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 1141,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 51.9,
      "between35And37": 52.7,
      "between38And40": 46.2
    },
    "medicaldirector": "Kaylen Silverberg, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 55.7,
      "between35And37": 42.6,
      "between38And40": 19.1
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "frozenEmbryos": 51.5,
      "donatedEmbryos": 40
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "48",
    "name": "Texas IVF",
    "address": {
      "id": "addr-48",
      "address1": "6130 W. Parker Rd, Suite 215",
      "city": "Plano",
      "state": "TX",
      "postalCode": "75093",
      "country": "US"
    },
    "headline": "Texas IVF",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(972) 981-7800",
    "bookingUrl": null,
    "location": {
      "latitude": 33.044,
      "longitude": -96.8371
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 97,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 41.9,
      "between38And40": 41.66666666666667
    },
    "medicaldirector": "Alfred J. Rodriguez, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between38And40": 12
    },
    "newPatientSuccessRates": {
      "under35": 31.57894736842105
    },
    "newPatientSuccessRateDenominators": {
      "under35": 19
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 33.33333333333333,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 18
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "519",
    "name": "Texas Tech University Health Sciences Center, Center for Fertility and Reproductive Surgery",
    "address": {
      "id": "addr-519",
      "address1": "808 Joliet Ave, Suite 230",
      "city": "Lubbock",
      "state": "TX",
      "postalCode": "79415",
      "country": "US"
    },
    "headline": "Texas Tech University Health Sciences Center, Center for Fertility and Reproductive Surgery",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(806) 743-4256",
    "bookingUrl": null,
    "location": {
      "latitude": 33.5877,
      "longitude": -101.89
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 88,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 31.3,
      "between35And37": 50
    },
    "medicaldirector": "Edward\t Yeomans, MD",
    "clinicStatus": "Reorganized",
    "successRateDenominators": {
      "between35And37": 14
    },
    "newPatientSuccessRates": {
      "under35": 46.4,
      "between35And37": 50
    },
    "newPatientSuccessRateDenominators": {
      "between35And37": 12
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "608",
    "name": "The Center for Reproductive Endocrinology",
    "address": {
      "id": "addr-608",
      "address1": "7777 Forest Ln, Suite C638",
      "city": "Dallas",
      "state": "TX",
      "postalCode": "75230",
      "country": "US"
    },
    "headline": "The Center for Reproductive Endocrinology",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(972) 566-6686",
    "bookingUrl": null,
    "location": {
      "latitude": 32.9127,
      "longitude": -96.7744
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 201,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 41.4,
      "between35And37": 50,
      "between38And40": 40.6
    },
    "medicaldirector": "Walid A. Saleh, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 47.9,
      "between35And37": 44,
      "between38And40": 28.9
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 63.63636363636363,
      "frozenEmbryos": 40.9,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFrozenEggs": 11
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "169",
    "name": "UT Health San Antonio Reproductive Health and Fertility Center",
    "address": {
      "id": "addr-169",
      "address1": "Medical Arts & Research Center, 8300 Floyd Curl Dr, 5th Floor",
      "city": "San Antonio",
      "state": "TX",
      "postalCode": "78229",
      "country": "US"
    },
    "headline": "UT Health San Antonio Reproductive Health and Fertility Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(210) 450-9500",
    "bookingUrl": null,
    "location": {
      "latitude": 36.0525,
      "longitude": -94.1268
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 240,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 38.8,
      "between35And37": 38.8,
      "between38And40": 26.4
    },
    "medicaldirector": "Belinda J. Yauger, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 55.1,
      "between35And37": 33.3,
      "between38And40": 16.7
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 0
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 8
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "833",
    "name": "Conceptions Fertility Center",
    "address": {
      "id": "addr-833",
      "address1": "1900 N. State St, Suite 105",
      "city": "Provo",
      "state": "UT",
      "postalCode": "84604",
      "country": "US"
    },
    "headline": "Conceptions Fertility Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(801) 655-5245",
    "bookingUrl": null,
    "location": {
      "latitude": 40.2603,
      "longitude": -111.676
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 125,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 48.5,
      "between35And37": 43.75
    },
    "medicaldirector": "Andrew K. Moore, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between35And37": 16
    },
    "newPatientSuccessRates": {
      "under35": 61.2,
      "between35And37": 46.15384615384615
    },
    "newPatientSuccessRateDenominators": {
      "between35And37": 13
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "79",
    "name": "Reproductive Care Center",
    "address": {
      "id": "addr-79",
      "address1": "10150 Petunia Way",
      "city": "Sandy",
      "state": "UT",
      "postalCode": "84092",
      "country": "US"
    },
    "headline": "Reproductive Care Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(801) 878-8888",
    "bookingUrl": null,
    "location": {
      "latitude": 40.5668,
      "longitude": -111.851
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 261,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 43.5,
      "between35And37": 44.1,
      "between38And40": 27.3
    },
    "medicaldirector": "Keith L. Blauer, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 66.7,
      "between35And37": 46.9
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "frozenEmbryos": 36.8,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {
      "donatedEmbryos": 8
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "16",
    "name": "Utah Center for Reproductive Medicine",
    "address": {
      "id": "addr-16",
      "address1": "675 Arapeen Dr, Suite 205",
      "city": "Salt Lake City",
      "state": "UT",
      "postalCode": "84108",
      "country": "US"
    },
    "headline": "Utah Center for Reproductive Medicine",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(801) 581-3834",
    "bookingUrl": null,
    "location": {
      "latitude": 40.7552,
      "longitude": -111.826
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 327,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 61.5,
      "between35And37": 62.2,
      "between38And40": 23.1
    },
    "medicaldirector": "Megan Link, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 59.8,
      "between35And37": 58.3,
      "between38And40": 9.8
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 36.8,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "433",
    "name": "Utah Fertility Center",
    "address": {
      "id": "addr-433",
      "address1": "1446 W. Pleasant Grove Blvd",
      "city": "Pleasant Grove",
      "state": "UT",
      "postalCode": "84062",
      "country": "US"
    },
    "headline": "Utah Fertility Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(801) 785-5100",
    "bookingUrl": null,
    "location": {
      "latitude": 40.3605,
      "longitude": -111.761
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 1178,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 48.2,
      "between35And37": 47.3,
      "between38And40": 56
    },
    "medicaldirector": "Shawn E. Gurtcheff, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 56.2,
      "between35And37": 43.5,
      "between38And40": 33
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "frozenEmbryos": 50.7,
      "donatedEmbryos": 47.2
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "806",
    "name": "CCRM Northern Virginia",
    "address": {
      "id": "addr-806",
      "address1": "8010 Towers Crescent Dr, 5th Floor",
      "city": "Vienna",
      "state": "VA",
      "postalCode": "22182",
      "country": "US"
    },
    "headline": "CCRM Northern Virginia",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(571) 789-2100",
    "bookingUrl": null,
    "location": {
      "latitude": 38.9143,
      "longitude": -77.2207
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 721,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 51.3,
      "between35And37": 57.8,
      "between38And40": 42.7
    },
    "medicaldirector": "Mark D. Payson, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 45.1,
      "between35And37": 37,
      "between38And40": 16.9
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 39.4,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "327",
    "name": "Dominion Fertility",
    "address": {
      "id": "addr-327",
      "address1": "4040 N. Fairfax Dr, Suite 600",
      "city": "Arlington",
      "state": "VA",
      "postalCode": "22203",
      "country": "US"
    },
    "headline": "Dominion Fertility",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(703) 920-3890",
    "bookingUrl": null,
    "location": {
      "latitude": 38.882,
      "longitude": -77.1089
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 783,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 51.9,
      "between35And37": 54.5,
      "between38And40": 37.2
    },
    "medicaldirector": "Michael DiMattina, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 41.5,
      "between35And37": 39.1,
      "between38And40": 20
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 33.8
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "461",
    "name": "Genetics & IVF Institute",
    "address": {
      "id": "addr-461",
      "address1": "3015 Williams Dr",
      "city": "Fairfax",
      "state": "VA",
      "postalCode": "22031",
      "country": "US"
    },
    "headline": "Genetics & IVF Institute",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(703) 698-3912",
    "bookingUrl": null,
    "location": {
      "latitude": 38.8685,
      "longitude": -77.2332
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 97,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 40,
      "between35And37": 46.2,
      "between38And40": 53.84615384615385
    },
    "medicaldirector": "Laurence C. Udoff, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between38And40": 13
    },
    "newPatientSuccessRates": {
      "under35": 44.44444444444444,
      "between35And37": 29.411764705882355
    },
    "newPatientSuccessRateDenominators": {
      "under35": 18,
      "between35And37": 17
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 52.4
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "845",
    "name": "Procreate Fertility Center of Virginia",
    "address": {
      "id": "addr-845",
      "address1": "700 Oak Grove Rd",
      "city": "Chesapeake",
      "state": "VA",
      "postalCode": "23320",
      "country": "US"
    },
    "headline": "Procreate Fertility Center of Virginia",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(757) 977-8500",
    "bookingUrl": null,
    "location": {
      "latitude": 36.7352,
      "longitude": -76.2384
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 126,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 41.9,
      "between35And37": 38.88888888888889
    },
    "medicaldirector": "Christian Perez, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between35And37": 18
    },
    "newPatientSuccessRates": {
      "under35": 34.1
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {},
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "105",
    "name": "Shady Grove Fertility-Richmond",
    "address": {
      "id": "addr-105",
      "address1": "9030 Stony Point Pkwy, Suite 450",
      "city": "Richmond",
      "state": "VA",
      "postalCode": "23235",
      "country": "US"
    },
    "headline": "Shady Grove Fertility-Richmond",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(804) 379-9000",
    "bookingUrl": null,
    "location": {
      "latitude": 37.5534,
      "longitude": -77.5688
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 527,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 60.9,
      "between35And37": 51.6,
      "between38And40": 60.3
    },
    "medicaldirector": "Erika B. Johnston-MacAnanny, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 70.2,
      "between35And37": 46.5,
      "between38And40": 42.6
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 68.75,
      "frozenEmbryos": 53.2,
      "donatedEmbryos": 38.5
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFreshEggs": 16
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "202",
    "name": "The New Hope Center for Reproductive Medicine",
    "address": {
      "id": "addr-202",
      "address1": "448 Viking Dr, Suite 100",
      "city": "Virginia Beach",
      "state": "VA",
      "postalCode": "23452",
      "country": "US"
    },
    "headline": "The New Hope Center for Reproductive Medicine",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(757) 496-5370",
    "bookingUrl": null,
    "location": {
      "latitude": 36.8269,
      "longitude": -76.0727
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 253,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 41.2,
      "between35And37": 26.8,
      "between38And40": 16
    },
    "medicaldirector": "Robin L. Poe-Zeigler, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 44.1,
      "between35And37": 23.5,
      "between38And40": 4.2
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 28
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "428",
    "name": "VCU Reproductive Medicine",
    "address": {
      "id": "addr-428",
      "address1": "9109 Stony Point Dr",
      "city": "Richmond",
      "state": "VA",
      "postalCode": "23235",
      "country": "US"
    },
    "headline": "VCU Reproductive Medicine",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(804) 327-8820",
    "bookingUrl": null,
    "location": {
      "latitude": 37.5475,
      "longitude": -77.5657
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 226,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 36.6,
      "between35And37": 38.2,
      "between38And40": 30.2
    },
    "medicaldirector": "Richard S. Lucidi, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 64.9,
      "between35And37": 26.9,
      "between38And40": 38.5
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 20.8
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "278",
    "name": "Virginia Center for Reproductive Medicine",
    "address": {
      "id": "addr-278",
      "address1": "11150 Sunset Hills Rd, Suite 100",
      "city": "Reston",
      "state": "VA",
      "postalCode": "20190",
      "country": "US"
    },
    "headline": "Virginia Center for Reproductive Medicine",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(703) 437-7722",
    "bookingUrl": null,
    "location": {
      "latitude": 38.9482,
      "longitude": -77.3304
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 81,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 66.66666666666666,
      "between35And37": 45.45454545454545
    },
    "medicaldirector": "Fady I. Sharara, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "under35": 9,
      "between35And37": 11
    },
    "newPatientSuccessRates": {
      "under35": 60
    },
    "newPatientSuccessRateDenominators": {
      "under35": 10
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "52",
    "name": "Virginia Fertility & IVF",
    "address": {
      "id": "addr-52",
      "address1": "4100 Olympia Cir, Suite 201",
      "city": "Charlottesville",
      "state": "VA",
      "postalCode": "22911",
      "country": "US"
    },
    "headline": "Virginia Fertility & IVF",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(434) 220-6620",
    "bookingUrl": null,
    "location": {
      "latitude": 38.0228,
      "longitude": -78.4399
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 346,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 58.2,
      "between35And37": 67.2,
      "between38And40": 56.4
    },
    "medicaldirector": "Christopher D. Williams, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 67.3,
      "between35And37": 50,
      "between38And40": 24.3
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 50,
      "frozenEmbryos": 48.1,
      "donatedEmbryos": 73.33333333333333
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFrozenEggs": 12,
      "donatedEmbryos": 15
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "884",
    "name": "Virginia Fertility Associates, LLC, SGF Jones Institute",
    "address": {
      "id": "addr-884",
      "address1": "601 Colley Ave",
      "city": "Norfolk",
      "state": "VA",
      "postalCode": "23507",
      "country": "US"
    },
    "headline": "Virginia Fertility Associates, LLC, SGF Jones Institute",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(757) 937-7955",
    "bookingUrl": null,
    "location": {
      "latitude": 36.8581,
      "longitude": -76.2994
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 3,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 0,
      "between35And37": 0,
      "between38And40": 0
    },
    "medicaldirector": "Erika B. Johnston-MacAnanny, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 0,
      "between35And37": 0,
      "between38And40": 0
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "282",
    "name": "Washington Fertility Center",
    "address": {
      "id": "addr-282",
      "address1": "4316 Evergreen Ln",
      "city": "Annandale",
      "state": "VA",
      "postalCode": "22003",
      "country": "US"
    },
    "headline": "Washington Fertility Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(703) 658-3100",
    "bookingUrl": null,
    "location": {
      "latitude": 38.8307,
      "longitude": -77.1864
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 78,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 40,
      "between35And37": 45.45454545454545
    },
    "medicaldirector": "Pierre Asmar, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between35And37": 11
    },
    "newPatientSuccessRates": {
      "under35": 43.75
    },
    "newPatientSuccessRateDenominators": {
      "under35": 16
    },
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 63.63636363636363,
      "frozenEmbryos": 33.3,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFrozenEggs": 11
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "526",
    "name": "Northeastern Reproductive Medicine",
    "address": {
      "id": "addr-526",
      "address1": "105 W. View Rd, Suite 302",
      "city": "Colchester",
      "state": "VT",
      "postalCode": "5446",
      "country": "US"
    },
    "headline": "Northeastern Reproductive Medicine",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(802) 655-8888",
    "bookingUrl": null,
    "location": {
      "latitude": 44.5096,
      "longitude": -73.1868
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 298,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 50,
      "between35And37": 24.6,
      "between38And40": 22.7
    },
    "medicaldirector": "Jennifer K. Brown, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 53.8,
      "between35And37": 18.2,
      "between38And40": 21.9
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "frozenEmbryos": 44.9
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "613",
    "name": "University of Vermont Medical Center, Vermont Center for Reproductive Medicine",
    "address": {
      "id": "addr-613",
      "address1": "111 Colchester Ave, Main Campus, Main Pavilion, Level 4",
      "city": "Burlington",
      "state": "VT",
      "postalCode": "5401",
      "country": "US"
    },
    "headline": "University of Vermont Medical Center, Vermont Center for Reproductive Medicine",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(802) 847-1248",
    "bookingUrl": null,
    "location": {
      "latitude": 44.4797,
      "longitude": -73.1941
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 82,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 32.6,
      "between35And37": 35
    },
    "medicaldirector": "Elizabeth McGee, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 40,
      "between35And37": 41.66666666666667
    },
    "newPatientSuccessRateDenominators": {
      "between35And37": 12
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "371",
    "name": "Center for Reproductive Health",
    "address": {
      "id": "addr-371",
      "address1": "201 W. North River Dr, Suite 100",
      "city": "Spokane",
      "state": "WA",
      "postalCode": "99201",
      "country": "US"
    },
    "headline": "Center for Reproductive Health",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(509) 462-7070",
    "bookingUrl": null,
    "location": {
      "latitude": 47.6635,
      "longitude": -117.414
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 151,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 50.7,
      "between35And37": 43.75,
      "between38And40": 83.33333333333334
    },
    "medicaldirector": "Edwin D. Robins, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between35And37": 16,
      "between38And40": 6
    },
    "newPatientSuccessRates": {
      "under35": 48.1
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 47.6
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "893",
    "name": "Kindbody - Vancouver (Pacific Northwest)",
    "address": {
      "id": "addr-893",
      "address1": "2501 NE 134th St, Ste 100",
      "city": "Vancouver",
      "state": "WA",
      "postalCode": "98686",
      "country": "US"
    },
    "headline": "Kindbody - Vancouver (Pacific Northwest)",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(360) 535-7590",
    "bookingUrl": null,
    "location": {
      "latitude": 45.7195,
      "longitude": -122.6427
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 1,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 0,
      "between35And37": 0,
      "between38And40": 0
    },
    "medicaldirector": "Angie Beltsos, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 0,
      "between35And37": 0,
      "between38And40": 0
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "718",
    "name": "Madigan Army Medical Center",
    "address": {
      "id": "addr-718",
      "address1": "Department of Obstetrics and Gynecology, 9040A Jackson Ave",
      "city": "Tacoma",
      "state": "WA",
      "postalCode": "98431",
      "country": "US"
    },
    "headline": "Madigan Army Medical Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(253) 968-3783",
    "bookingUrl": null,
    "location": {
      "latitude": 47.1098,
      "longitude": -122.552
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 58,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 55.2,
      "between38And40": 0
    },
    "medicaldirector": "Bruce D. Pier, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between38And40": 11
    },
    "newPatientSuccessRates": {
      "under35": 56.5,
      "between38And40": 0
    },
    "newPatientSuccessRateDenominators": {
      "between38And40": 8
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "415",
    "name": "Olympia Women's Health, Olympia Fertility",
    "address": {
      "id": "addr-415",
      "address1": "403 Black Hills Ln S.W., Suite E",
      "city": "Olympia",
      "state": "WA",
      "postalCode": "98502",
      "country": "US"
    },
    "headline": "Olympia Women's Health, Olympia Fertility",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(360) 786-1515",
    "bookingUrl": null,
    "location": {
      "latitude": 47.0468,
      "longitude": -122.95
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 60,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 60.9,
      "between35And37": 56.25
    },
    "medicaldirector": "James F. Moruzzi, MD, PHD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between35And37": 16
    },
    "newPatientSuccessRates": {
      "under35": 63.1578947368421,
      "between35And37": 45.45454545454545
    },
    "newPatientSuccessRateDenominators": {
      "under35": 19,
      "between35And37": 11
    },
    "donorSuccessRates": {
      "frozenEmbryos": 55.55555555555556,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 9
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "826",
    "name": "ORM Fertility Bellevue",
    "address": {
      "id": "addr-826",
      "address1": "1370 116th Ave N.E., Suite 100",
      "city": "Bellevue",
      "state": "WA",
      "postalCode": "98004",
      "country": "US"
    },
    "headline": "ORM Fertility Bellevue",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(425) 458-2622",
    "bookingUrl": null,
    "location": {
      "latitude": 47.6219,
      "longitude": -122.184
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 90,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 39.4,
      "between35And37": 46.7
    },
    "medicaldirector": "Elizabeth A. Barbieri, MD",
    "clinicStatus": "Closed",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 37,
      "between35And37": 42.10526315789473
    },
    "newPatientSuccessRateDenominators": {
      "between35And37": 19
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 52.8
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "96",
    "name": "Overlake Reproductive Health, Inc., PS",
    "address": {
      "id": "addr-96",
      "address1": "11232 N.E. 15th St, Suite 201",
      "city": "Bellevue",
      "state": "WA",
      "postalCode": "98004",
      "country": "US"
    },
    "headline": "Overlake Reproductive Health, Inc., PS",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(425) 646-4700",
    "bookingUrl": null,
    "location": {
      "latitude": 47.6245,
      "longitude": -122.189
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 273,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 41.6,
      "between35And37": 59.5,
      "between38And40": 50
    },
    "medicaldirector": "Kevin M. Johnson, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between38And40": 12
    },
    "newPatientSuccessRates": {
      "under35": 35.9,
      "between35And37": 32.3,
      "between38And40": 12.5
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 53.8
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "128",
    "name": "Pacific Northwest Fertility and IVF Specialists",
    "address": {
      "id": "addr-128",
      "address1": "1101 Madison St, Suite 1050",
      "city": "Seattle",
      "state": "WA",
      "postalCode": "98104",
      "country": "US"
    },
    "headline": "Pacific Northwest Fertility and IVF Specialists",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(206) 515-0000",
    "bookingUrl": null,
    "location": {
      "latitude": 47.6092,
      "longitude": -122.324
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 646,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 58.6,
      "between35And37": 59.6,
      "between38And40": 58.9
    },
    "medicaldirector": "Julie D. Lamb, MD",
    "clinicStatus": "Reorganized",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 57.6,
      "between35And37": 45.9,
      "between38And40": 34.2
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 38.5,
      "donatedEmbryos": 47.368421052631575
    },
    "donorSuccessRateDenominators": {
      "donatedEmbryos": 19
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "457",
    "name": "Poma Fertility",
    "address": {
      "id": "addr-457",
      "address1": "12039 N.E. 128th St, Suite 110",
      "city": "Kirkland",
      "state": "WA",
      "postalCode": "98034",
      "country": "US"
    },
    "headline": "Poma Fertility",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(425) 822-7662",
    "bookingUrl": null,
    "location": {
      "latitude": 47.7145,
      "longitude": -122.179
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 408,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 54.7,
      "between35And37": 44.6,
      "between38And40": 44.9
    },
    "medicaldirector": "Ronald Beesley, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 69.1,
      "between35And37": 47.4,
      "between38And40": 33.3
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 100,
      "frozenEmbryos": 46.7,
      "donatedEmbryos": 41.4
    },
    "donorSuccessRateDenominators": {
      "freshEmbryosFrozenEggs": 5
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "50",
    "name": "Seattle Reproductive Medicine",
    "address": {
      "id": "addr-50",
      "address1": "1505 Westlake Ave North, Suite 400",
      "city": "Seattle",
      "state": "WA",
      "postalCode": "98109",
      "country": "US"
    },
    "headline": "Seattle Reproductive Medicine",
    "images": [],
    "tags": [],
    "services": ["Counseling", "Support resources", "Patient portal"],
    "languages": ["en"],
    "clinicType": "Network & group",
    "conditions": [
      "PCOS",
      "Endometriosis",
      "Male factor",
      "Recurrent pregnancy loss",
      "Diminished ovarian reserve",
      "Unexplained infertility",
      "Oncofertility"
    ],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Embryo Freezing",
      "PGT",
      "Sperm Freezing",
      "Donor programs",
      "Surrogacy",
      "Fertility preservation"
    ],
    "website": "https://www.seattlefertility.com/",
    "email": "srminfo@seattlefertility.com",
    "phone": "(206) 301-5000",
    "bookingUrl": "https://www.seattlefertility.com/contact-us/",
    "location": {
      "latitude": 47.6326,
      "longitude": -122.341
    },
    "insurances": [],
    "insuranceAccepted": true,
    "insuranceName": null,
    "financiers": [
      "Payment plans",
      "Loans",
      "Package pricing",
      "CapexMD",
      "Future Family",
      "PatientFi",
      "Gaia"
    ],
    "consultationTypes": ["In person", "Telehealth"],
    "patientGroups": ["LGBTQIA+", "Single Parents", "Same sex couples"],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 1934,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": "Seattle's established fertility practice since 2004, now part of Pinnacle Fertility, offering comprehensive IVF, genetic testing, LGBTQ+ family-building, and oncofertility services.",
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 51.3,
      "between35And37": 52.3,
      "between38And40": 50.4
    },
    "medicaldirector": "Paul C. Lin, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 50.8,
      "between35And37": 40.1,
      "between38And40": 24.9
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 51.9,
      "donatedEmbryos": 40.5
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "610",
    "name": "Sound Fertility Care, PLLC",
    "address": {
      "id": "addr-610",
      "address1": "509 Olive Way, Suite 501",
      "city": "Seattle",
      "state": "WA",
      "postalCode": "98101",
      "country": "US"
    },
    "headline": "Sound Fertility Care, PLLC",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(206) 651-4432",
    "bookingUrl": null,
    "location": {
      "latitude": 47.6127,
      "longitude": -122.337
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 129,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 37.2,
      "between35And37": 50,
      "between38And40": 53.3
    },
    "medicaldirector": "Kathleen Lin, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between35And37": 16
    },
    "newPatientSuccessRates": {
      "under35": 48.1,
      "between35And37": 41.66666666666667,
      "between38And40": 44.44444444444444
    },
    "newPatientSuccessRateDenominators": {
      "between35And37": 12,
      "between38And40": 18
    },
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 37.5
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 16
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "513",
    "name": "SRM Spokane",
    "address": {
      "id": "addr-513",
      "address1": "15920 E. Indiana Ave, Suite 200",
      "city": "Spokane Valley",
      "state": "WA",
      "postalCode": "99216",
      "country": "US"
    },
    "headline": "SRM Spokane",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(206) 301-5000",
    "bookingUrl": null,
    "location": {
      "latitude": 47.6686,
      "longitude": -117.191
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 152,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 60.6,
      "between35And37": 41,
      "between38And40": 34.5
    },
    "medicaldirector": "Brenda S. Houmard, MD, PHD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 76.6,
      "between35And37": 50,
      "between38And40": 31.57894736842105
    },
    "newPatientSuccessRateDenominators": {
      "between38And40": 19
    },
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "frozenEmbryos": 54.8
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "925",
    "name": "Think Fertility",
    "address": {
      "id": "addr-925",
      "address1": "1600 116th Ave N.E., Suite 104",
      "city": "Bellevue",
      "state": "WA",
      "postalCode": "98004",
      "country": "US"
    },
    "headline": "Think Fertility",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(425) 453-2229",
    "bookingUrl": null,
    "location": {
      "latitude": 47.6252,
      "longitude": -122.1825
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 0,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 0,
      "between35And37": 0,
      "between38And40": 0
    },
    "medicaldirector": "Jie Deng, MD, PHD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 0,
      "between35And37": 0,
      "between38And40": 0
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "180",
    "name": "University Reproductive Care, University of Washington",
    "address": {
      "id": "addr-180",
      "address1": "4245 Roosevelt Way N.E., 3rd Floor",
      "city": "Seattle",
      "state": "WA",
      "postalCode": "98105",
      "country": "US"
    },
    "headline": "University Reproductive Care, University of Washington",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(206) 598-4225",
    "bookingUrl": null,
    "location": {
      "latitude": 47.6588,
      "longitude": -122.318
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 136,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 64.4,
      "between35And37": 42.9,
      "between38And40": 47.6
    },
    "medicaldirector": "Ginny Ryan, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 58.8,
      "between35And37": 44.4,
      "between38And40": 36.4
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "525",
    "name": "Aurora Health Care-Aurora Fertility Services, The Women's Center at Aurora BayCare Medical Center",
    "address": {
      "id": "addr-525",
      "address1": "2845 Greenbrier Rd, Suite 350",
      "city": "Green Bay",
      "state": "WI",
      "postalCode": "54311",
      "country": "US"
    },
    "headline": "Aurora Health Care-Aurora Fertility Services, The Women's Center at Aurora BayCare Medical Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(920) 288-8500",
    "bookingUrl": null,
    "location": {
      "latitude": 44.475,
      "longitude": -87.9407
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 150,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 63.9,
      "between35And37": 45.8,
      "between38And40": 75
    },
    "medicaldirector": "Katherine A. Green, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between38And40": 8
    },
    "newPatientSuccessRates": {
      "under35": 67.9,
      "between35And37": 38.1
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "503",
    "name": "Aurora Health Care-Aurora Fertility Services, West Allis",
    "address": {
      "id": "addr-503",
      "address1": "West Allis Memorial Hospital, 8901 W. Lincoln Ave, 2nd Floor",
      "city": "West Allis",
      "state": "WI",
      "postalCode": "53227",
      "country": "US"
    },
    "headline": "Aurora Health Care-Aurora Fertility Services, West Allis",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(414) 329-4300",
    "bookingUrl": null,
    "location": {
      "latitude": 43.0014,
      "longitude": -88.0234
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 200,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 63.5,
      "between35And37": 56.7,
      "between38And40": 75
    },
    "medicaldirector": "Katherine A. Green, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between38And40": 12
    },
    "newPatientSuccessRates": {
      "under35": 46.2,
      "between35And37": 29,
      "between38And40": 30.4
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 58.333333333333336,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {
      "frozenEmbryos": 12
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "183",
    "name": "Froedtert & Medical College of Wisconsin, Reproductive Medicine Center",
    "address": {
      "id": "addr-183",
      "address1": "North Hills Health Center, W129 N7055 Northfield Dr, Bldg B, Suite 500",
      "city": "Menomonee Falls",
      "state": "WI",
      "postalCode": "53051",
      "country": "US"
    },
    "headline": "Froedtert & Medical College of Wisconsin, Reproductive Medicine Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(262) 253-9220",
    "bookingUrl": null,
    "location": {
      "latitude": 43.145,
      "longitude": -88.0718
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 263,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.184Z",
    "successRates": {
      "under35": 47.4,
      "between35And37": 35.8,
      "between38And40": 35.7
    },
    "medicaldirector": "Katherine Schoyer, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 61,
      "between35And37": 36.1,
      "between38And40": 37
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "donatedEmbryos": 55.55555555555556
    },
    "donorSuccessRateDenominators": {
      "donatedEmbryos": 9
    },
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "343",
    "name": "Reproductive Specialty Center",
    "address": {
      "id": "addr-343",
      "address1": "2350 N. Lake Dr, Suite 301",
      "city": "Milwaukee",
      "state": "WI",
      "postalCode": "53211",
      "country": "US"
    },
    "headline": "Reproductive Specialty Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(414) 289-9668",
    "bookingUrl": null,
    "location": {
      "latitude": 43.0613,
      "longitude": -87.8787
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 26,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {},
    "medicaldirector": "Grace M. Janik, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {},
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "397",
    "name": "University of Wisconsin-Generations Fertility Care",
    "address": {
      "id": "addr-397",
      "address1": "2365 Deming Way",
      "city": "Middleton",
      "state": "WI",
      "postalCode": "53562",
      "country": "US"
    },
    "headline": "University of Wisconsin-Generations Fertility Care",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(608) 824-6160",
    "bookingUrl": null,
    "location": {
      "latitude": 43.1006,
      "longitude": -89.5172
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 180,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 48.5,
      "between35And37": 42.3,
      "between38And40": 28
    },
    "medicaldirector": "Bala Bhagavath, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 56.9,
      "between35And37": 55.2
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 35.7,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "470",
    "name": "Wisconsin Fertility Institute",
    "address": {
      "id": "addr-470",
      "address1": "3146 Deming Way",
      "city": "Middleton",
      "state": "WI",
      "postalCode": "53562",
      "country": "US"
    },
    "headline": "Wisconsin Fertility Institute",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(608) 824-0075",
    "bookingUrl": null,
    "location": {
      "latitude": 43.1058,
      "longitude": -89.5266
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 224,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 34.3,
      "between35And37": 28.3,
      "between38And40": 20
    },
    "medicaldirector": "Elizabeth Pritts, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {},
    "newPatientSuccessRates": {
      "under35": 44.6,
      "between35And37": 26.7,
      "between38And40": 9.1
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "freshEmbryosFrozenEggs": 0,
      "frozenEmbryos": 41.7,
      "donatedEmbryos": 37
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "493",
    "name": "Cabell Huntington Hospital, Center for Advanced Reproductive Medicine",
    "address": {
      "id": "addr-493",
      "address1": "1600 Medical Center Dr, Suite 4500",
      "city": "Huntington",
      "state": "WV",
      "postalCode": "25701",
      "country": "US"
    },
    "headline": "Cabell Huntington Hospital, Center for Advanced Reproductive Medicine",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(304) 526-2602",
    "bookingUrl": null,
    "location": {
      "latitude": 38.4091,
      "longitude": -82.4269
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 34,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 47.368421052631575
    },
    "medicaldirector": "William N. Burns, MD",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "under35": 19
    },
    "newPatientSuccessRates": {
      "under35": 60
    },
    "newPatientSuccessRateDenominators": {
      "under35": 15
    },
    "donorSuccessRates": {
      "freshEmbryosFrozenEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  },
  {
    "id": "418",
    "name": "West Virginia University Center for Reproductive Medicine",
    "address": {
      "id": "addr-418",
      "address1": "1322 Pineview Dr, Suite 2",
      "city": "Morgantown",
      "state": "WV",
      "postalCode": "26505",
      "country": "US"
    },
    "headline": "West Virginia University Center for Reproductive Medicine",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["en"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": ["IVF & ICSI", "Donor programs"],
    "website": null,
    "email": null,
    "phone": "(304) 598-3100",
    "bookingUrl": null,
    "location": {
      "latitude": 39.6627,
      "longitude": -79.9537
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": true,
    "nbCyclePerYear": 128,
    "reportedTo": "CDC",
    "lastReportYear": 2022,
    "publicNotes": null,
    "lastUpdatedIso": "2026-02-09T05:39:47.185Z",
    "successRates": {
      "under35": 45.7,
      "between35And37": 62.5,
      "between38And40": 50
    },
    "medicaldirector": "Ryan J. Heitmann, DO",
    "clinicStatus": "Open",
    "successRateDenominators": {
      "between35And37": 16,
      "between38And40": 10
    },
    "newPatientSuccessRates": {
      "under35": 46.4
    },
    "newPatientSuccessRateDenominators": {},
    "donorSuccessRates": {
      "freshEmbryosFreshEggs": 0,
      "donatedEmbryos": 0
    },
    "donorSuccessRateDenominators": {},
    "outcomeSourceUrl": "https://data.cdc.gov/resource/cchw-gdwa.json",
    "outcomeSourceType": "national-mandatory-registry",
    "outcomeMetric": "live_birth_per_transfer",
    "outcomeReportingPopulation": "CDC/NASS Q019: patients using their own eggs; live-birth deliveries per embryo transfer",
    "outcomeDenominatorDescription": "Use the published rate-cell count only; annual clinic volume is not an outcome denominator."
  }
]
